webpackJsonp([3],Array(25).concat([
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(44);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(26);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(27);

var _createClass3 = _interopRequireDefault(_createClass2);

var _promise = __webpack_require__(12);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(370);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var client = _axios2.default.create({
  withCredentials: true,
  headers: {
    'Accept': 'application/json'
  }
});

var vueStore = null;
var vueRoot = null;

// currently I do not find an appropriate to catch reject of promise globally
// I wish I could find a solution before the end of this project
// lol, sadly
// const Errors = [
//   'Error',
//   'RequireWritePermissionError',
//   'NoQuotaError',
//   'ProjectLockedError',
//   'PermissionError',
//   'NotFoundError'
// ]

client.interceptors.response.use(function (response) {
  if (vueStore) {
    var enabled = !!response.headers['x-sneaky-mode'];
    vueStore.dispatch('set_sneaky_mode', enabled);
  }
  return response;
}, function (error) {
  var ret = _promise2.default.reject(error);
  setTimeout(function () {
    return ret.catch(function (error) {
      if (error && error.mute) return;
      if (!vueRoot) return;
      if (error.response.status >= 500) {
        vueRoot.$message({
          message: '服务器暂时异常，请重试操作或刷新页面',
          type: 'error',
          duration: 3000
        });
      } else if (error.response.status >= 400 && error.response.status !== 401) {
        var data = error.response.data;
        var popup = true;

        // NoQuotaError for post export request do not need popup message
        if (data.type === 'NoQuotaError' && /\/export$/.test(error.response.config.url) && error.response.config.method === 'post') {
          popup = false;
        }

        if (popup) {
          vueRoot.$message({
            message: data.message,
            type: 'error',
            duration: 1500,
            onClose: function onClose() {
              if (['NotFoundError', 'PermissionError'].indexOf(data.type) >= 0) {
                vueRoot.$router.push('/projects');
              }
            }
          });
        }
      }
    });
  });
  return ret;
});

function expandPath(path) {
  return "/api/" + path.replace(/^\//, '');
}

var ApiBase = function () {
  function ApiBase() {
    (0, _classCallCheck3.default)(this, ApiBase);
  }

  (0, _createClass3.default)(ApiBase, null, [{
    key: 'setVueStore',
    value: function setVueStore(store) {
      vueStore = store;
    }
  }, {
    key: 'setVueRoot',
    value: function setVueRoot(root) {
      vueRoot = root;
    }
  }, {
    key: 'get',
    value: function get(path, params) {
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return client.get(expandPath(path), (0, _assign2.default)({}, config, {
        params: (0, _assign2.default)({}, params, { '_timestamp': Date.now() })
      }));
    }
  }, {
    key: 'post',
    value: function post(path, params) {
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return client.post(expandPath(path), params, config);
    }
  }, {
    key: 'put',
    value: function put(path, params) {
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return client.put(expandPath(path), params, config);
    }
    //

  }, {
    key: 'delete',
    value: function _delete(path, params) {
      return client.delete(expandPath(path), { params: params });
    }
  }]);
  return ApiBase;
}();

exports.default = ApiBase;

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(494);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

var _errorbag = __webpack_require__(400);

var _errorbag2 = _interopRequireDefault(_errorbag);

var _regexes = __webpack_require__(80);

var _regexes2 = _interopRequireDefault(_regexes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// dictionary for fields
var Dictionary = {
  'zh-cn': {
    emailOrCellphone: '邮箱/手机号',
    email: '邮箱',
    password: '密码',
    oldPassword: '原始密码',
    newPassword: '新的密码',
    passwordConfirmation: '确认密码',
    cellphone: '手机号',
    captcha: '短信验证码',
    realname: '真实姓名',
    province: '省份',
    organization: '任教学校',
    certificate: '证件图片',
    cannotBeEmpty: '不能为空',
    notValidFormat: '不是有效的格式',
    and: '与',
    notMatch: '不匹配'
  }
}; // el-form validation rule helper


var locale = "zh-cn";

var $t = function $t(word) {
  return Dictionary[locale][word];
};

var rules = {
  required: function required(attributes) {
    var vm = this;
    attributes = _lodash2.default.isArray(attributes) ? attributes : [attributes];

    var requiredValidator = function requiredValidator(rule, value, callback) {
      if (!value) {
        var errorMessage = $t(rule.field) + $t('cannotBeEmpty');
        vm.errors.add(rule.field, errorMessage);
        callback(new Error(errorMessage));
      } else {
        callback();
      }
    };

    return attributes.reduce(function (result, attribute) {
      result[attribute] = [{
        validator: requiredValidator,
        trigger: 'blur'
      }];
      return result;
    }, {});
  },
  confirmed: function confirmed(attributes) {
    var vm = this;
    attributes = _lodash2.default.isArray(attributes) ? attributes : [attributes];

    function confirmedValidator(rule, value, callback) {
      var recursion = this.recursion;
      var original = this.original;
      var target = this.target;
      // use vm and recusive to get compaired data
      var searching = function searching(result) {
        var recursion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        var current = recursion.split('.')[0];

        if (current) {
          result = result[current];
        }

        var next = recursion.substr(current.length + 1);
        if (!next) {
          return result;
        } else {
          return searching(result, next);
        }
      };

      var compared = searching(vm.$data, recursion)[original];
      if (value !== compared) {
        var errorMessage = $t(target) + $t('and') + $t(original) + $t('notMatch');
        vm.errors.add(rule.field, errorMessage);
        callback(new Error(errorMessage));
      } else {
        callback();
      }
    }

    return attributes.reduce(function (result, attribute) {
      result[attribute.target] = [{
        validator: function validator() {
          confirmedValidator.apply(attribute, arguments);
        },
        trigger: 'blur'
      }];
      return result;
    }, {});
  },
  email: function email(attributes) {
    var vm = this;
    attributes = _lodash2.default.isArray(attributes) ? attributes : [attributes];

    var emailValidator = function emailValidator(rule, value, callback) {
      if (!_regexes2.default.email.test(value)) {
        var errorMessage = $t(rule.field) + $t('notValidFormat');
        vm.errors.add(rule.field, errorMessage);
        callback(new Error(errorMessage));
      } else {
        callback();
      }
    };

    return attributes.reduce(function (result, attribute) {
      result[attribute] = [{
        validator: emailValidator,
        trigger: 'blur'
      }];
      return result;
    }, {});
  }
};

exports.default = {
  props: {
    // 记录表单上各个元素，在前端验证上是否有错误的集合
    errors: {
      default: function _default() {
        return new _errorbag2.default();
      }
    },
    rules: {
      // rules 会被 el-form使用，作为el-form需要的rules， 见 http://element.eleme.io/1.4/#/zh-CN/component/form
      default: function _default() {
        var vm = this;
        if (!vm.$options.rules) return null;

        // 对 rules 所有有效的[const rules 定义了的]规则，生成对应的validator
        var validators = _lodash2.default.keys(vm.$options.rules).filter(function (key) {
          return _lodash2.default.isFunction(rules[key]);
        }).map(function (key) {
          // key is someting like 'required', 'confirmed'
          return rules[key].call(vm, vm.$options.rules[key]);
        });

        return _lodash2.default.assignWith.apply(_lodash2.default, [{}].concat((0, _toConsumableArray3.default)(validators), [function (d, s) {
          return d ? _lodash2.default.concat(d, s) : s;
        }]));
      }
    }
  },
  methods: {
    clearErrors: function clearErrors(field) {
      field ? this.errors.remove(field) : this.errors.clear();
    }
  }
};

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lazyload = undefined;

var _regenerator = __webpack_require__(495);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(491);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(12);

var _promise2 = _interopRequireDefault(_promise);

var lazyload = exports.lazyload = function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(packageName) {
    var load = function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(packageName) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = packageName;
                _context.next = _context.t0 === 'weixin' ? 3 : _context.t0 === 'wxlogin' ? 5 : _context.t0 === 'vue-numeric' ? 7 : _context.t0 === 'jquery' ? 8 : _context.t0 === 'blueimp-file-upload' ? 9 : _context.t0 === 'plupload' ? 10 : _context.t0 === 'qiniu' ? 11 : _context.t0 === 'simple-ajax-uploader' ? 12 : _context.t0 === 'chartkick' ? 13 : 16;
                break;

              case 3:
                if (!weixinPromise) {
                  weixinPromise = asyncInsertScript('//res.wx.qq.com/open/js/jweixin-1.2.0.js');
                }
                return _context.abrupt('return', weixinPromise);

              case 5:
                if (!weixinPromise) {
                  wxloginPromise = asyncInsertScript('//res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js');
                }
                return _context.abrupt('return', wxloginPromise);

              case 7:
                return _context.abrupt('return', new Promise(function(resolve) { resolve(__webpack_require__(888)); }));

              case 8:
                return _context.abrupt('return', __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 964)));

              case 9:
                return _context.abrupt('return', __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 965)));

              case 10:
                return _context.abrupt('return', __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 968)));

              case 11:
                return _context.abrupt('return', __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 969)));

              case 12:
                return _context.abrupt('return', __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 970)));

              case 13:
                _context.next = 15;
                return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 966));

              case 15:
                return _context.abrupt('return', __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 967)));

              case 16:
                return _context.abrupt('return', __webpack_require__(961)(packageName));

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function load(_x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', load(packageName).catch(function (e) {
              window.alert( true ? '当前网络出现问题，请重新刷新页面' : 'Network Error');
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function lazyload(_x) {
    return _ref.apply(this, arguments);
  };
}();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// webpack lazy loading
// https://webpack.js.org/guides/lazy-loading/#src/components/Sidebar/Sidebar.jsx
//
var weixinPromise = null;
var wxloginPromise = null;

var asyncInsertScript = function asyncInsertScript(src) {
  return new _promise2.default(function (resolve, reject) {
    var script = document.createElement('script');
    var body = document.getElementsByTagName('body')[0];

    var load = function load() {
      console.log('load', src);
      resolve();
    };

    var error = function error() {
      console.log('error', src);
      reject();
    };

    script.addEventListener ? script.addEventListener('load', load, !1) : script.attachEvent('onload', load);
    script.addEventListener ? script.addEventListener('error', error, !1) : script.attachEvent('onerror', error);

    script.type = 'text/javascript';
    script.async = !0;
    body.appendChild(script);
    script.src = src;
  });
};

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDialog = undefined;

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _store = __webpack_require__(159);

var _i18n = __webpack_require__(158);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createDialog = function createDialog(component) {
  var DialogConstructor = _vue2.default.extend(component);

  // a hack way to overcome shortage of i18n
  // vuei18n的fallback机制，是需要instance的meessages只包含这一层级vue的messages，_root进行fallback
  // Vue.extend会让plugins里面的vue instance作为根instance，i18n为根i18n
  // 所以需要hack way来重置instance的messages
  var instance = new DialogConstructor({
    store: (0, _store.createStore)(),
    i18n: {
      root: _i18n2.default,
      fallbackLocale: _i18n2.default.fallbackLocale,
      silentTranslationWarn: _i18n2.default.silentTranslationWarn
    }
  });

  var wakeup = function wakeup() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (!instance.$el) {
      instance.$mount(document.createElement('div'));
      document.body.appendChild(instance.$el);
    }

    _vue2.default.nextTick(function () {
      instance.open(opts);
    });
  };
  return wakeup;
}; // 通过 Vue.extend 的方式，创建一个 vue instance 并插入到 body 里面，来实现 dialog
// 这种实现，可以将 dialog 的dom层级直接插到body的最外层

// 使用方式
// let dialog = createDilog(Component)
// dialog()  // open the dialog
exports.createDialog = createDialog;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsLogger = __webpack_require__(811);

var _jsLogger2 = _interopRequireDefault(_jsLogger);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_jsLogger2.default.useDefaults({
  defaultLevel:  true ? _jsLogger2.default.INFO : _jsLogger2.default.DEBUG
});

var consoleHandler = _jsLogger2.default.createDefaultHandler({
  formatter: function formatter(messages, context) {
    messages.unshift((0, _moment2.default)().format('[[' + context.name + ' ' + context.level.name + '] h:mm:ss []]'));
  }
});

var customHandler = function customHandler(messages, context) {
  if (context.level.name === 'ERROR') {
    setTimeout(function (_) {
      var err = new Error(messages[0]);
      if (window._errs) {
        window._errs.push(err);
      } else {
        throw err;
      }
    });
  }
};

_jsLogger2.default.setHandler(function (messages, context) {
  consoleHandler(messages, context);
  customHandler(messages, context);
});

exports.default = _jsLogger2.default.get('logger');

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(766)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(910),
  /* scopeId */
  "data-v-3aae0815",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  cellphone: /^1[34578]\d{9}$/,
  captcha: /^\d{6}$/,
  email: /^.+@.+\..{2,6}$/,
  projectName: /\S/ // 项目名称重命名不能为空字符串
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bus = new _vue2.default({}); // global event driver

exports.default = bus;

/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(12);

var _promise2 = _interopRequireDefault(_promise);

exports.dynamicImportChartkick = dynamicImportChartkick;

var _lazyLoadModule = __webpack_require__(48);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var chartId = 1; // 参考: https://github.com/ankane/vue-chartkick

var createComponent = function createComponent(ChartType) {
  var chartProps = ['colors', 'curve', 'discrete', 'donut', 'download', 'label', 'legend', 'library', 'max', 'min', 'points', 'refresh', 'stacked', 'title', 'xtitle', 'xtype', 'ytitle'];

  return {
    props: ['data', 'id', 'width', 'height'].concat(chartProps),
    template: '<div v-bind:id="chartId" v-bind:style="chartStyle">Loading...</div>',
    data: function data() {
      return {
        chartId: null
      };
    },

    computed: {
      chartStyle: function chartStyle() {
        // hack to watch data and options
        // 注释： updated() 只有在 Component上面绑定了的元素发生updated的时候才会触发。template 并没有{{data}}, 所以props的值发生改变并不会触发 updated()，导致图表刷新
        // 修复的方法是 让chartStyle与data关联，或者在template上面绑定一个值与data关联。
        // 为了避免显式在dom上面绑定 data 和 chartOptions， 使用hack的方式关联其与chartStyle
        if (this.data || this.chartOptions) {
          var color = '#999';
        }

        return {
          height: this.height || '300px',
          lineHeight: this.height || '300px',
          width: this.width || '100%',
          textAlign: 'center',
          color: color || '#999',
          fontSize: '14px',
          fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Verdana, Arial, Helvetica, sans-serif'
        };
      },
      chartOptions: function chartOptions() {
        var options = {};
        var props = chartProps;
        for (var i = 0; i < props.length; i++) {
          var prop = props[i];
          if (this[prop] !== undefined) {
            options[prop] = this[prop];
          }
        }
        return options;
      }
    },
    created: function created() {
      this.chartId = this.chartId || this.id || 'chart-' + chartId++;
    },
    mounted: function mounted() {
      this.chart = new ChartType(this.chartId, this.data, this.chartOptions);
    },
    updated: function updated() {
      this.chart.updateData(this.data, this.chartOptions);
    }
  };
};
function dynamicImportChartkick(chartType) {
  return new _promise2.default(function (resolve, reject) {
    (0, _lazyLoadModule.lazyload)('chartkick').then(function (Chartkick) {
      resolve(createComponent(Chartkick[chartType]));
    }).catch(reject);
  });
}

// export default { dynamicImportChartkick }

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateSessionID = generateSessionID;

var _md = __webpack_require__(812);

var _md2 = _interopRequireDefault(_md);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _jsCookie = __webpack_require__(810);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function generateSessionID(userId, file) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  function random(length) {
    var possible = 'abcdefghijklmnopqrstuvwxyz0123456789';
    var value = '';

    for (var i = 0; i < Number(length); i++) {
      value += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return value;
  }

  var lmd = (0, _moment2.default)(file.lastModifiedDate || 'invalid');
  var session = [(0, _moment2.default)().format('YYYYMMDD'), userId, file.size ? file.size : '0', (0, _md2.default)(escape(file.name)), lmd.isValid() ? lmd.format('YYYYMMDDHHmmss') : '0'].join('_');

  if (options.clean) {
    _jsCookie2.default.remove(session);
    return;
  }

  var token = _jsCookie2.default.get(session);
  if (!token) {
    token = random(8);
    _jsCookie2.default.set(session, token, { expires: 1 });
  }

  console.log('generate upload session id: ' + session + '_' + token);
  return session + '_' + token;
}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  type: 'beta',
  name: '体验版',
  price: 0,
  permanent: 0,
  export: 120,
  logo: 99,
  cdn_amount: 30,
  log_retain_days: 3,
  report_type: 'base'
}, {
  type: 'base',
  package: 'yearly_basic',
  name: '基础版',
  price: 299,
  permanent: 10,
  export: 120,
  logo: 99,
  cdn_amount: 300,
  log_retain_days: 7,
  report_type: 'base',
  target_intro: '适合个人初步试用'
}, {
  type: 'advanced',
  package: 'yearly_pro',
  name: '专业版',
  price: 1999,
  permanent: 80,
  export: null,
  logo: null,
  cdn_amount: 2000,
  custom_queue: true,
  log_retain_days: 15,
  report_type: 'advanced',
  data_export: true,
  wxpay: true,
  wechat_support: true,
  target_intro: '适合个人或小团队专业使用'
}, {
  type: 'edu',
  package: 'yearly_edu',
  name: '教育特惠版',
  price: 199.9,
  permanent: 50,
  export: 120,
  logo: 99,
  cdn_amount: 2000,
  custom_queue: true,
  log_retain_days: 15,
  report_type: 'advanced',
  data_export: true,
  wxpay: true,
  wechat_support: true,
  target_intro: '仅限成功认证的公立学校老师购买',
  show: false
}, {
  type: 'zizi',
  package: 'yearly_zizi',
  name: '教育专业版',
  price: 999,
  permanent: 80,
  export: 120,
  logo: 99,
  cdn_amount: 2000,
  custom_queue: true,
  log_retain_days: 15,
  report_type: 'advanced',
  data_export: true,
  wxpay: true,
  wechat_support: true,
  target_intro: '',
  show: false
}, {
  type: 'enterprise',
  package: 'yearly_enterprise',
  name: '企业版',
  prefer: true,
  price: 4999,
  permanent: 200,
  export: null,
  logo: null,
  sub_account: 5,
  custom_domain: true,
  cdn_amount: 5000,
  custom_queue: true,
  custom_encryption: true,
  custom_cdnspeedup: true,
  custom_cs: true,
  log_retain_days: null,
  report_type: 'advanced',
  data_export: true,
  wxpay: true,
  wechat_support: true,
  target_intro: '适合中小公司或部门间办公协同'
}, {
  type: 'professional',
  name: '企业增强版',
  package: 'yearly_enterprise_plus',
  price: 16999,
  price_more: true,
  permanent: null,
  export: null,
  logo: null,
  sub_account: 20,
  custom_domain: true,
  cdn_amount: 16000,
  custom_queue: true,
  custom_encryption: true,
  custom_cdnspeedup: true,
  custom_cs: true,
  online_tutor: true,
  log_retain_days: null,
  report_type: 'advanced',
  data_export: true,
  wxpay: true,
  wechat_support: true,
  target_intro: '适合一定规模公司办公协同'
}];

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

var _vueI18n = __webpack_require__(819);

var _vueI18n2 = _interopRequireDefault(_vueI18n);

var _index = __webpack_require__(403);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(402);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// use vue-i18n
_vue2.default.use(_vueI18n2.default);
// 设置版本语言

// 时代光华要求 所有 “项目”字样改为“微课”
var tbcLocale = _lodash2.default.cloneDeep(_index2.default);
tbcLocale['common']['project'] = '微课';

// the global instance for i18n
var i18nInstance = new _vueI18n2.default({
  locale: "zh-cn",
  fallbackLocale: 'zh-cn',
  silentTranslationWarn: true,
  messages: {
    en: _index4.default,
    'zh-cn': _index2.default,
    'tbc': tbcLocale
  }
});

exports.default = i18nInstance;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(63);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

// import * as actions from './actions';


exports.createStore = createStore;

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(330);

var _vuex2 = _interopRequireDefault(_vuex);

var _user = __webpack_require__(417);

var _user2 = _interopRequireDefault(_user);

var _project = __webpack_require__(415);

var _project2 = _interopRequireDefault(_project);

var _category = __webpack_require__(410);

var _category2 = _interopRequireDefault(_category);

var _media = __webpack_require__(412);

var _media2 = _interopRequireDefault(_media);

var _quota = __webpack_require__(416);

var _quota2 = _interopRequireDefault(_quota);

var _income = __webpack_require__(411);

var _income2 = _interopRequireDefault(_income);

var _order = __webpack_require__(413);

var _order2 = _interopRequireDefault(_order);

var _withdraw = __webpack_require__(418);

var _withdraw2 = _interopRequireDefault(_withdraw);

var _organization = __webpack_require__(414);

var _organization2 = _interopRequireDefault(_organization);

var _apis = __webpack_require__(409);

var _apis2 = _interopRequireDefault(_apis);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var debug = "production" !== 'production';

var SNEAKY_MODE = 'SNEAKY_MODE'; // 是否是隐藏访问
var TBC_MODE = 'TBC_MODE'; // 时代光华模式

var i18nInstance = null; // reference to i18n instance

var store = new _vuex2.default.Store({
  state: { sneakyMode: false, tbcMode: false },
  modules: { user: _user2.default, project: _project2.default, category: _category2.default, media: _media2.default, quota: _quota2.default, income: _income2.default, order: _order2.default, withdraw: _withdraw2.default, organization: _organization2.default, apis: _apis2.default },
  actions: {
    set_sneaky_mode: function set_sneaky_mode(_ref, enabled) {
      var commit = _ref.commit,
          state = _ref.state;

      if (state.sneakyMode !== enabled) {
        commit(SNEAKY_MODE, enabled);
      }
    },

    // alter tbcMode    -> tbc stands for 时代光华
    set_tbc_mode: function set_tbc_mode(_ref2, enabled) {
      var commit = _ref2.commit,
          state = _ref2.state;

      if (state.tbcMode !== enabled) {
        commit(TBC_MODE, enabled);

        // alter i18 locale to company required
        // 之所以放在这儿而不是通过外面watch，是因为watch后的function执行是延迟于dom mounted的
        // 这样会有闪动
        if (enabled) {
          i18nInstance.locale = 'tbc';
        }
      }
    },

    // use to refresh all necessary vuex state as much as possible
    refresh: function refresh(_ref3) {
      var dispatch = _ref3.dispatch;

      return dispatch('user/get', { force: true });
    }
  },
  mutations: (_mutations = {}, (0, _defineProperty3.default)(_mutations, SNEAKY_MODE, function (state, enabled) {
    state.sneakyMode = enabled;
  }), (0, _defineProperty3.default)(_mutations, TBC_MODE, function (state, enabled) {
    state.tbcMode = enabled;
  }), _mutations),
  strict: debug
});

function createStore(i18n) {
  i18nInstance = i18n;
  return store;
}

/***/ }),
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(148);

__webpack_require__(401);

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _app = __webpack_require__(821);

var _app2 = _interopRequireDefault(_app);

var _router = __webpack_require__(408);

var _store = __webpack_require__(159);

var _i18n = __webpack_require__(158);

var _i18n2 = _interopRequireDefault(_i18n);

__webpack_require__(744);

var _elementUi = __webpack_require__(204);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(745);

__webpack_require__(746);

var _utils = __webpack_require__(405);

var _utils2 = _interopRequireDefault(_utils);

var _session = __webpack_require__(404);

var _session2 = _interopRequireDefault(_session);

var _logger = __webpack_require__(62);

var _logger2 = _interopRequireDefault(_logger);

var _api_base = __webpack_require__(25);

var _api_base2 = _interopRequireDefault(_api_base);

var _crosstab = __webpack_require__(203);

var _crosstab2 = _interopRequireDefault(_crosstab);

var _contacts = __webpack_require__(406);

var _contacts2 = _interopRequireDefault(_contacts);

var _dialogs = __webpack_require__(407);

var _dialogs2 = _interopRequireDefault(_dialogs);

var _image_uploader = __webpack_require__(879);

var _image_uploader2 = _interopRequireDefault(_image_uploader);

var _spinner = __webpack_require__(882);

var _spinner2 = _interopRequireDefault(_spinner);

var _cellphone = __webpack_require__(876);

var _cellphone2 = _interopRequireDefault(_cellphone);

var _vueClipboard = __webpack_require__(818);

var _vueClipboard2 = _interopRequireDefault(_vueClipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// register global component


// import global component


// self-defined plugins


// import api


// using default css


// use element ui


// use i18n


// use vue-router


// use vue
_vue2.default.component('image-uploader', _image_uploader2.default);

// import clipboard support


// import crosstab


// import logger


// import global mixins


// import global stylesheets


// use vuex

_vue2.default.component('spinner', _spinner2.default);
_vue2.default.component('cellphone-input', _cellphone2.default);

_vue2.default.use(_elementUi2.default);
// custom global mixins
_vue2.default.mixin(_utils2.default);
_vue2.default.mixin(_session2.default);

// use external plugins
_vue2.default.use(_vueClipboard2.default);

// use custom plugins
_vue2.default.use(_contacts2.default);
_vue2.default.use(_dialogs2.default);

var store = (0, _store.createStore)(_i18n2.default);
var a = new _vue2.default({
  el: '#main',
  render: function render(h) {
    return h(_app2.default);
  },
  store: store,
  router: (0, _router.createRouter)(store),
  i18n: _i18n2.default
});
_logger2.default.debug(a);

// 如果有其他同源tab发送refresh vuex 请求
_crosstab2.default.on('refresh', function (res) {
  // block refresh request from current tab
  if (_crosstab2.default.id !== res.origin) {
    a.$store.dispatch('refresh');
  }
});

// set api base
_api_base2.default.setVueStore(store);
_api_base2.default.setVueRoot(a);

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"createProjectNum":"创建@:common.project数","packageAccountsTotalNum":"套餐内账号总数","projectsTotalNum":"@:common.project总数","projectsTotalPV":"@:common.project浏览次数","packageAccountsUsedNum":"当前账号总数","recentCreateProjectList":"最近创建@:common.project","projectName":"@:common.project名称","projectNum":"@:common.project数：","projectCreator":"创建人","projectCreatedDate":"创建日期","projectPV":"浏览人次","seeAndShare":"查看及分享","periods":{"past":"过去","week":"一周","month":"一个月","season":"三个月","year":"一年"}}}')
}


/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"deleteProjectCompleted":"@:common.project成功删除"}}')
}


/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"noProject":"暂无@:common.project"}}')
}


/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"roles":{"owner":"创建者","admin":"管理员","member":"普通成员"},"memberState":{"accepted":"正常","awaiting":"未激活","denied":"已拒绝"}}}')
}


/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"browseProject":"查看@:common.project","editProject":"修改@:common.project"}}')
}


/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"projectQuota":"@:common.project额度","disconnectWXhint":"解除微信绑定后，您的微信号将不会收到@:common.project生成状态的推送，以及一些与微信相关的功能也会收到限制。是否继续？"}}')
}


/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"projectIncome":"@:common.project收入","projectName":"@:common.project名称"}}')
}


/***/ }),
/* 340 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"accessDisableReasonTemp":"临时@:common.project不能设置访问限制为公众号或付费阅读","accessDisableReasonOverdate":"过期@:common.project不能修改访问限制规则"}}')
}


/***/ }),
/* 341 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"lockedProjectHint":"当前@:common.project为只读@:common.project，不能修改"}}')
}


/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"pv_by_source":{"singlemessage":"朋友转发","timeline":"朋友圈","groupmessage":"群转发","other":"其他","course":"课程中心","knowledge":"资料中心","total":"总计"},"shares_by_target":{"sendappmessage":"微信好友","sharetimeline":"朋友圈","shareqq":"QQ好友","other":"其他"}}}')
}


/***/ }),
/* 343 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"supportFormat":"支持格式：pptx ppt dps pdf","chooseSubmit":"选择上传"}}')
}


/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"title":"从素材库选取音乐","empty":"暂时没有音乐","tags":{"bgm":"背景音乐","pub":"公共音乐"},"messagebox":{"remove":{"title":"从素材库中移除该音乐?","message":"注意，该操作不会使之前引用的文件失效"},"close":{"title":"请保持素材库打开","message":"上传文件中，请勿关闭素材库"},"save":{"title":"请选择音乐后保存","message":"单击某条音乐来选中，或点击取消按钮来关闭素材库"}}}}')
}


/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"title":"从素材库选取图片","empty":"暂时没有图片","tags":{"thumbnail":"@:common.project封面","cover":"微信分享封面","logo":"企业logo"},"messagebox":{"remove":{"title":"从素材库中移除该图片?","message":"注意，该操作不会使之前引用的文件失效"},"close":{"title":"请保持素材库打开","message":"上传文件中，请勿关闭素材库"},"save":{"title":"请选择图片后保存","message":"单击某个图片来选中，或点击取消按钮来关闭素材库"}},"imageUploading":"图片上传中"}}')
}


/***/ }),
/* 346 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"upgradeProject":"升级@:common.project","unlockProject":"解锁@:common.project","upgradeHint":"升级为永久@:common.project可以保证链接长期有效，解除付费阅读、更新PPT等限制","unlockHint":"解除@:common.project无法更新PPT的限制","upgradeComplete":"该@:common.project已成功升级为永久@:common.project！","unlockComplete":"该@:common.project已解除锁定！"}}')
}


/***/ }),
/* 347 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"projectOverdateHint":"@:common.project已过期，暂时无法更新PPT文件。升级为永久@:common.project可解除限制。","projectLockedHint":"@:common.project被锁定，暂时无法更新PPT文件。使用永久@:common.project额度可以解除限制。","upgradeProject":"升级@:common.project","unlockProject":"解锁@:common.project"}}')
}


/***/ }),
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(26);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(27);

var _createClass3 = _interopRequireDefault(_createClass2);

var _api_base = __webpack_require__(25);

var _api_base2 = _interopRequireDefault(_api_base);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ApisApi = function () {
  function ApisApi() {
    (0, _classCallCheck3.default)(this, ApisApi);
  }

  (0, _createClass3.default)(ApisApi, null, [{
    key: 'apiInfo',
    value: function apiInfo(params) {
      return _api_base2.default.get(params.organization_id ? '/organizations/' + params.organization_id + '/personal_key' : '/personal_key');
    }
  }, {
    key: 'updateApiInfo',
    value: function updateApiInfo(params) {
      return _api_base2.default.put(params.organization_id ? '/organizations/' + params.organization_id + '/personal_key' : '/personal_key', {
        personal_key: _lodash2.default.pick(params, ['injected_code', 'ip_whitelist', 'notify_url', 'signing'])
      });
    }
  }, {
    key: 'sendApplication',
    value: function sendApplication(params) {
      return _api_base2.default.post('/api_applications', {
        application: _lodash2.default.pick(params, ['name', 'phone', 'company', 'scenario', 'estimate_ppts'])
      });
    }
  }]);
  return ApisApi;
}();

exports.default = ApisApi;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(26);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(27);

var _createClass3 = _interopRequireDefault(_createClass2);

var _api_base = __webpack_require__(25);

var _api_base2 = _interopRequireDefault(_api_base);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CategoryApi = function () {
  function CategoryApi() {
    (0, _classCallCheck3.default)(this, CategoryApi);
  }

  (0, _createClass3.default)(CategoryApi, null, [{
    key: 'index',
    value: function index(params) {
      return _api_base2.default.get('/categories', _lodash2.default.pick(params, ['organization_id']));
    }
  }, {
    key: 'show',
    value: function show(id) {
      return _api_base2.default.get('/categories/' + id);
    }
  }, {
    key: 'destroy',
    value: function destroy(id) {
      return _api_base2.default.delete('/categories/' + id);
    }
  }, {
    key: 'createOrUpdate',
    value: function createOrUpdate(params) {
      var create = function create(params) {
        return _api_base2.default.post(params.organization_id ? '/organizations/' + params.organization_id + '/categories' : '/categories', {
          category: _lodash2.default.pick(params, ['name', 'description', 'cover', 'publicity', 'order'])
        });
      };

      var update = function update(params) {
        return _api_base2.default.put('/categories/' + params.id, {
          category: _lodash2.default.pick(params, ['name', 'description', 'cover', 'publicity', 'order'])
        });
      };
      return params.id ? update(params) : create(params);
    }
  }]);
  return CategoryApi;
}();

exports.default = CategoryApi;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(26);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(27);

var _createClass3 = _interopRequireDefault(_createClass2);

var _api_base = __webpack_require__(25);

var _api_base2 = _interopRequireDefault(_api_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IncomeApi = function () {
  function IncomeApi() {
    (0, _classCallCheck3.default)(this, IncomeApi);
  }

  (0, _createClass3.default)(IncomeApi, null, [{
    key: 'index',
    value: function index() {
      return _api_base2.default.get('/projects/income');
    }
  }, {
    key: 'show',
    value: function show(id) {
      return _api_base2.default.get('/projects/' + id + '/income');
    }
  }]);
  return IncomeApi;
}(); // 负责处理与收入相关的api


exports.default = IncomeApi;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(26);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(27);

var _createClass3 = _interopRequireDefault(_createClass2);

var _api_base = __webpack_require__(25);

var _api_base2 = _interopRequireDefault(_api_base);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MediaApi = function () {
  function MediaApi() {
    (0, _classCallCheck3.default)(this, MediaApi);
  }

  (0, _createClass3.default)(MediaApi, null, [{
    key: 'index',

    // 获得某类资源
    value: function index(params) {
      return _api_base2.default.get('/media', _lodash2.default.pick(params, ['type', 'tag', 'organization_id', 'public']));
    }

    // 获得某个资源，通过id

  }, {
    key: 'show',
    value: function show(id) {
      return _api_base2.default.get('/media/' + id);
    }

    // 删除某个资源, 通过id

  }, {
    key: 'destroy',
    value: function destroy(id) {
      return _api_base2.default.delete('/media/' + id);
    }
  }]);
  return MediaApi;
}();

exports.default = MediaApi;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.weixinConfig = weixinConfig;

var _api_base = __webpack_require__(25);

var _api_base2 = _interopRequireDefault(_api_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function weixinConfig() {
  return _api_base2.default.get('/wechat/signature.json');
}

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(26);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(27);

var _createClass3 = _interopRequireDefault(_createClass2);

var _api_base = __webpack_require__(25);

var _api_base2 = _interopRequireDefault(_api_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderApi = function () {
  function OrderApi() {
    (0, _classCallCheck3.default)(this, OrderApi);
  }

  (0, _createClass3.default)(OrderApi, null, [{
    key: 'state',
    value: function state(id) {
      return _api_base2.default.get('/orders/' + id + '/state');
    }
  }]);
  return OrderApi;
}(); // 负责处理与收入相关的api


exports.default = OrderApi;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(26);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(27);

var _createClass3 = _interopRequireDefault(_createClass2);

var _api_base = __webpack_require__(25);

var _api_base2 = _interopRequireDefault(_api_base);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 负责处理与组织相关的api
var OrganizationApi = function () {
  function OrganizationApi() {
    (0, _classCallCheck3.default)(this, OrganizationApi);
  }

  (0, _createClass3.default)(OrganizationApi, null, [{
    key: 'members',
    value: function members(params) {
      return _api_base2.default.get('/organizations/' + params.orgId + '/members', _lodash2.default.pick(params, ['page']));
    }
  }, {
    key: 'logs',
    value: function logs(params) {
      return _api_base2.default.get('/organizations/' + params.orgId + '/security_logs', _lodash2.default.pick(params, ['page']));
    }
  }, {
    key: 'stats',
    value: function stats(params) {
      return _api_base2.default.get('/organizations/' + params.orgId + '/stats', _lodash2.default.pick(params, ['period']));
    }
  }, {
    key: 'editMember',
    value: function editMember(params) {
      return _api_base2.default.put('/organizations/' + params.orgId + '/members/' + params.memId, {
        member: _lodash2.default.pick(params, ['department', 'role', 'permissions'])
      });
    }
  }, {
    key: 'removeMember',
    value: function removeMember(params) {
      return _api_base2.default.delete('/organizations/' + params.orgId + '/members/' + params.memId);
    }
  }]);
  return OrganizationApi;
}();

exports.default = OrganizationApi;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(26);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(27);

var _createClass3 = _interopRequireDefault(_createClass2);

var _api_base = __webpack_require__(25);

var _api_base2 = _interopRequireDefault(_api_base);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectApi = function () {
  function ProjectApi() {
    (0, _classCallCheck3.default)(this, ProjectApi);
  }

  (0, _createClass3.default)(ProjectApi, null, [{
    key: 'index',
    value: function index(params) {
      return _api_base2.default.get('/projects', _lodash2.default.pick(params, ['category_id', 'organization_id', 'page']));
    }
  }, {
    key: 'states',
    value: function states(params) {
      return _api_base2.default.get('/projects/states', _lodash2.default.pick(params, ['ids']));
    }
  }, {
    key: 'show',
    value: function show(id) {
      return _api_base2.default.get('/projects/' + id);
    }
  }, {
    key: 'state',
    value: function state(id) {
      return _api_base2.default.get('/projects/' + id + '/state');
    }
  }, {
    key: 'destroy',
    value: function destroy(id) {
      if (!id) {
        throw new Error('ArgumentError');
      }
      return _api_base2.default.delete('/projects/' + id);
    }
  }, {
    key: 'create',
    value: function create(params) {
      return _api_base2.default.post(params.organization_id ? '/organizations/' + params.organization_id + '/projects' : '/projects', {
        file_id: params.file_id,
        qn_file_id: params.qn_file_id,
        project: _lodash2.default.pick(params, ['source_filename', 'category_id'])
      });
    }
  }, {
    key: 'update',
    value: function update(id, params) {
      console.log('tbc params', !params.tbc ? null : _lodash2.default.pick(params.tbc, ['sync_course', 'sync_knowledge', 'public']));
      return _api_base2.default.put('/projects/' + id, {
        file_id: params.file_id,
        qn_file_id: params.qn_file_id,
        tbc: !params.tbc ? null : _lodash2.default.pick(params.tbc, ['sync_course', 'sync_knowledge', 'public']),
        project: _lodash2.default.pick(params, ['name', 'source_filename', 'thumbnail', // 项目名,源文件名,封面
        'bgm', 'bgm_name', 'bgm_volume', // 背景音乐相关
        'category_id', // 分类相关
        'cover', 'title', 'description', // wechat share related field
        'logo', // logo
        'arrow_mode', 'transition_ctrl', 'stretch_mode', 'auto_play', 'forbid_share', // 翻页小箭头, 翻页控制, 页面适配, 自动播放,允许微信转发
        'auth_type', 'auth_config', 'pay_to_read_price', // 访问权限相关
        'test'])
      });
    }
  }, {
    key: 'recordQrcode',
    value: function recordQrcode(id) {
      return _api_base2.default.get('/projects/' + id + '/action_record/editor_qrcode');
    }
  }, {
    key: 'stats',
    value: function stats(id) {
      return _api_base2.default.get('/projects/' + id + '/stats');
    }
  }, {
    key: 'formRecords',
    value: function formRecords(params) {
      return _api_base2.default.get('/projects/' + params.id + '/form_records', _lodash2.default.pick(params, ['page']));
    }
  }, {
    key: 'deleteFormRecords',
    value: function deleteFormRecords(params) {
      return _api_base2.default.delete('/projects/' + params.id + '/form_records/id', _lodash2.default.pick(params, ['batch_ids']));
    }

    // 导出相关 api

  }, {
    key: 'createExport',
    value: function createExport(params) {
      return _api_base2.default.post('/projects/' + params.id + '/export', _lodash2.default.pick(params, ['export_format']));
    }
  }, {
    key: 'checkExport',
    value: function checkExport(id) {
      return _api_base2.default.get('/projects/' + id + '/export');
    }
  }]);
  return ProjectApi;
}();

exports.default = ProjectApi;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(26);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(27);

var _createClass3 = _interopRequireDefault(_createClass2);

var _api_base = __webpack_require__(25);

var _api_base2 = _interopRequireDefault(_api_base);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 负责处理与额度相关的api
var QuotaApi = function () {
  function QuotaApi() {
    (0, _classCallCheck3.default)(this, QuotaApi);
  }

  (0, _createClass3.default)(QuotaApi, null, [{
    key: 'index',
    value: function index(params) {
      return _api_base2.default.get(params.organization_id ? '/organizations/' + params.organization_id + '/quotas' : '/quotas');
    }
  }, {
    key: 'buy',
    value: function buy(params) {
      return _api_base2.default.post(params.organization_id ? '/organizations/' + params.organization_id + '/quotas' : '/quotas', _lodash2.default.pick(params, ['package', 'project_id', 'promote_code', 'payment_method', 'return_path']));
    }

    // 使用额度

  }, {
    key: 'consume',
    value: function consume(params) {
      return _api_base2.default.post('/quotas/consume', _lodash2.default.pick(params, ['key', 'project_id']));
    }

    // 查询价格

  }, {
    key: 'price',
    value: function price(params) {
      return _api_base2.default.get('/quotas/new', _lodash2.default.pick(params, ['package', 'promote_code']));
    }
  }]);
  return QuotaApi;
}();

exports.default = QuotaApi;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(26);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(27);

var _createClass3 = _interopRequireDefault(_createClass2);

var _api_base = __webpack_require__(25);

var _api_base2 = _interopRequireDefault(_api_base);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserApi = function () {
  function UserApi() {
    (0, _classCallCheck3.default)(this, UserApi);
  }

  (0, _createClass3.default)(UserApi, null, [{
    key: 'captcha',
    value: function captcha(params) {
      return _api_base2.default.post('/captchas', _lodash2.default.pick(params, ['cellphone', 'reset']));
    }
  }, {
    key: 'show',
    value: function show() {
      return _api_base2.default.get('/profile');
    }
  }, {
    key: 'update',
    value: function update(params) {
      return _api_base2.default.put('/profile', {
        user: _lodash2.default.pick(params, ['cellphone', 'nickname']),
        captcha: params.captcha
      });
    }
  }, {
    key: 'signUp',
    value: function signUp(params) {
      return _api_base2.default.post('/users', {
        user: _lodash2.default.pick(params, ['email', 'password', 'cellphone', 'sign_up_ref']),
        captcha: params.captcha
      });
    }
  }, {
    key: 'signIn',
    value: function signIn(params) {
      return _api_base2.default.post('/users/sign_in', {
        user: _lodash2.default.pick(params, ['login', 'password'])
      });
    }
  }, {
    key: 'signOut',
    value: function signOut() {
      return _api_base2.default.delete('/users/sign_out');
    }
  }, {
    key: 'changePassword',
    value: function changePassword(params) {
      return _api_base2.default.put('/users', _lodash2.default.pick(params, ['current_password', 'password']));
    }
  }, {
    key: 'reqResetPassword',
    value: function reqResetPassword(params) {
      // according to params.findType, filter params
      return _api_base2.default.post('/users/password', params.findType === 'email' ? _lodash2.default.pick(params, ['email']) : _lodash2.default.pick(params, ['cellphone', 'captcha']));
    }
  }, {
    key: 'resetPassword',
    value: function resetPassword(params) {
      return _api_base2.default.put('/users/password', _lodash2.default.pick(params, ['reset_password_token', 'password']));
    }
  }, {
    key: 'wxConnection',
    value: function wxConnection() {
      return _api_base2.default.get('/authentications/connect_qrcode');
    }
  }, {
    key: 'wxDisconnect',
    value: function wxDisconnect() {
      return _api_base2.default.delete('/authentications/wechat/disconnect');
    }
  }, {
    key: 'wxAuth',
    value: function wxAuth() {
      return _api_base2.default.get('/auth/wechat_web.json');
    }
  }]);
  return UserApi;
}();

exports.default = UserApi;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(26);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(27);

var _createClass3 = _interopRequireDefault(_createClass2);

var _api_base = __webpack_require__(25);

var _api_base2 = _interopRequireDefault(_api_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WithdrawApi = function () {
  function WithdrawApi() {
    (0, _classCallCheck3.default)(this, WithdrawApi);
  }

  (0, _createClass3.default)(WithdrawApi, null, [{
    key: 'index',
    value: function index() {
      return _api_base2.default.get('/withdraws');
    }
  }]);
  return WithdrawApi;
}(); // 负责处理与额度相关的api


exports.default = WithdrawApi;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(493);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = __webpack_require__(26);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(27);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorBag = function () {
  function ErrorBag() {
    (0, _classCallCheck3.default)(this, ErrorBag);

    this.errors = [];
  }

  /**
   * Adds an error to the internal array.
   *
   * @param {string} field The field name.
   * @param {string} msg The error message.
   * @param {String} rule The rule that is responsible for the error.
   * @param {String} scope The Scope name, optional.
   */


  (0, _createClass3.default)(ErrorBag, [{
    key: 'add',
    value: function add(field, msg, rule) {
      var scope = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '__global__';

      this.errors.push({ field: field, msg: msg, rule: rule, scope: scope });
    }

    /**
     * Gets all error messages from the internal array.
     *
     * @param {String} scope The Scope name, optional.
     * @return {Array} errors Array of all error messages.
     */

  }, {
    key: 'all',
    value: function all(scope) {
      if (!scope) {
        return this.errors.map(function (e) {
          return e.msg;
        });
      }

      return this.errors.filter(function (e) {
        return e.scope === scope;
      }).map(function (e) {
        return e.msg;
      });
    }

    /**
     * Checks if there are any errors in the internal array.
     * @param {String} scope The Scope name, optional.
     * @return {boolean} result True if there was at least one error, false otherwise.
     */

  }, {
    key: 'any',
    value: function any(scope) {
      if (!scope) {
        return !!this.errors.length;
      }

      return !!this.errors.filter(function (e) {
        return e.scope === scope;
      }).length;
    }

    /**
     * Removes all items from the internal array.
     *
     * @param {String} scope The Scope name, optional.
     */

  }, {
    key: 'clear',
    value: function clear(scope) {
      if (!scope) {
        scope = '__global__';
      }

      this.errors = this.errors.filter(function (e) {
        return e.scope !== scope;
      });
    }

    /**
     * Collects errors into groups or for a specific field.
     *
     * @param  {string} field The field name.
     * @param  {string} scope The scope name.
     * @param {Boolean} map If it should map the errors to strings instead of objects.
     * @return {Array} errors The errors for the specified field.
     */

  }, {
    key: 'collect',
    value: function collect(field, scope) {
      var map = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (!field) {
        var collection = {};
        this.errors.forEach(function (e) {
          if (!collection[e.field]) {
            collection[e.field] = [];
          }

          collection[e.field].push(map ? e.msg : e);
        });

        return collection;
      }

      if (!scope) {
        return this.errors.filter(function (e) {
          return e.field === field;
        }).map(function (e) {
          return map ? e.msg : e;
        });
      }

      return this.errors.filter(function (e) {
        return e.field === field && e.scope === scope;
      }).map(function (e) {
        return map ? e.msg : e;
      });
    }
    /**
     * Gets the internal array length.
     *
     * @return {Number} length The internal array length.
     */

  }, {
    key: 'count',
    value: function count() {
      return this.errors.length;
    }

    /**
     * Gets the first error message for a specific field.
     *
     * @param  {string} field The field name.
     * @return {string|null} message The error message.
     */

  }, {
    key: 'first',
    value: function first(field) {
      var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '__global__';

      var selector = this._selector(field);
      var scoped = this._scope(field);

      if (scoped) {
        var result = this.first(scoped.name, scoped.scope);
        // if such result exist, return it. otherwise it could be a field.
        // with dot in its name.
        if (result) {
          return result;
        }
      }

      if (selector) {
        return this.firstByRule(selector.name, selector.rule, scope);
      }

      for (var i = 0; i < this.errors.length; i++) {
        if (this.errors[i].field === field && this.errors[i].scope === scope) {
          return this.errors[i].msg;
        }
      }

      return null;
    }

    /**
     * Returns the first error rule for the specified field
     *
     * @param {string} field The specified field.
     * @return {string|null} First error rule on the specified field if one is found, otherwise null
     */

  }, {
    key: 'firstRule',
    value: function firstRule(field, scope) {
      var errors = this.collect(field, scope, false);

      return errors.length && errors[0].rule || null;
    }

    /**
     * Checks if the internal array has at least one error for the specified field.
     *
     * @param  {string} field The specified field.
     * @return {Boolean} result True if at least one error is found, false otherwise.
     */

  }, {
    key: 'has',
    value: function has(field) {
      var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '__global__';

      return !!this.first(field, scope);
    }

    /**
     * Gets the first error message for a specific field and a rule.
     * @param {String} name The name of the field.
     * @param {String} rule The name of the rule.
     * @param {String} scope The name of the scope (optional).
     */

  }, {
    key: 'firstByRule',
    value: function firstByRule(name, rule, scope) {
      var error = this.collect(name, scope, false).filter(function (e) {
        return e.rule === rule;
      })[0];

      return error && error.msg || null;
    }

    /**
     * Removes all error messages associated with a specific field.
     *
     * @param  {string} field The field which messages are to be removed.
     * @param {String} scope The Scope name, optional.
     */

  }, {
    key: 'remove',
    value: function remove(field, scope) {
      var filter = function filter(e) {
        return e.field !== field || e.scope !== (scope || '__global__');
      };

      this.errors = this.errors.filter(filter);
    }

    /**
     * Get the field attributes if there's a rule selector.
     *
     * @param  {string} field The specified field.
     * @return {Object|null}
     */

  }, {
    key: '_selector',
    value: function _selector(field) {
      if (field.indexOf(':') > -1) {
        var _field$split = field.split(':'),
            _field$split2 = (0, _slicedToArray3.default)(_field$split, 2),
            name = _field$split2[0],
            rule = _field$split2[1];

        return { name: name, rule: rule };
      }

      return null;
    }

    /**
     * Get the field scope if specified using dot notation.
     *
     * @param {string} field the specifie field.
     * @return {Object|null}
     */

  }, {
    key: '_scope',
    value: function _scope(field) {
      if (field.indexOf('.') > -1) {
        var _field$split3 = field.split('.'),
            _field$split4 = (0, _slicedToArray3.default)(_field$split3, 2),
            scope = _field$split4[0],
            name = _field$split4[1];

        return { name: name, scope: scope };
      }

      return null;
    }
  }]);
  return ErrorBag;
}();

exports.default = ErrorBag;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// popper.js need this polyfill to remove dom correctly on IE explorer
// see https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove#Polyfill
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('remove')) {
      return;
    }
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        this.parentNode.removeChild(this);
      }
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(44);

var _assign2 = _interopRequireDefault(_assign);

var _en = __webpack_require__(733);

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _assign2.default)({}, _en2.default, {
  common: {
    headbar: {
      help: 'Help',
      vip: 'Vip Service',
      myProjects: 'My Projects'
    }
  }
});

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(44);

var _assign2 = _interopRequireDefault(_assign);

var _zhCN = __webpack_require__(205);

var _zhCN2 = _interopRequireDefault(_zhCN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _assign2.default)({}, _zhCN2.default, {
  common: {
    project: '项目',
    placeholder: {
      plzChoose: '请选择'
    },
    tablehead: {
      action: '操作'
    },
    buttons: {
      cancel: '取消',
      save: '保存',
      submit: '提交',
      ok: '确定',
      check: '查看',
      close: '关闭',
      edit: '编辑',
      rename: '重命名',
      delete: '删除',
      contactUs: '联系我们',
      return: '返回',
      copy: '复制',
      preview: '预览',
      export: {
        default: '导出',
        html5: '导出 H5',
        scorm: '导出 SCORM'
      },
      record: '语音录制',
      finishRecord: '完成录制'
    },
    infos: {
      copy: '已保存到剪切板'
    },
    errors: {
      server: '服务器暂时故障，请刷新重试：{message}',
      uploading: '上传出现问题，请重试或尝试其他浏览器'
    },
    order: {
      labels: {
        name: '操作@:common.project',
        price: '付费金额',
        payType: '支付方式'
      },
      wechat: '微信',
      alipay: '支付宝'
    }
  },
  messagebox: {
    category: {
      delete: {
        title: '移除分组: {name}',
        message: '删除分组后，该分组的@:common.project仍然会保留，是否继续？'
      }
    },
    project: {
      delete: {
        title: '删除@:common.project: {name}',
        message: '该操作将使生成的二维码和网址无法再继续访问，是否继续？'
      },
      rename: {
        title: '@:common.project重命名',
        inputError: '@:common.project名不能为空'
      }
    },
    media: {
      audio: {
        delete: {
          title: '从素材库中移除该音乐?',
          message: '注意，该操作不会使之前引用的文件失效'
        }
      },
      image: {
        delete: {
          title: '从素材库中移除该图片?',
          message: '注意，该操作不会使之前引用的文件失效'
        }
      }
    }
  },
  actions: {
    headbar: {
      returnIndex: '回到首页',
      help: '帮助',
      vip: '会员服务',
      members: '成员管理',
      price: '价格',
      myProjects: '我的@:common.project',
      myAccount: '我的账户',
      logout: '退出登录',
      logoutMessage: '已注销',
      login: '已有账号，请登录',
      register: '立即注册'
    },
    login: {
      title: '登录账号',
      login: '登录',
      wxlogin: '微信登录',
      accountlogin: '账号登录',
      register: '立即注册',
      password: '找回密码'
    },
    findPassword: {
      title: '找回密码',
      submit: {
        email: '发送验证邮件',
        cellphone: '验证手机号'
      },
      returnLogin: '返回登录',
      placeholder: '请输入账号邮箱',
      sended: {
        title: '验证邮件已送达: {email}',
        hint: '请登录邮箱，使用验证邮件中的链接重置密码'
      }
    },
    register: {
      title: '欢迎注册',
      term: "点击“立即注册”，表明您已阅读并同意<a class='link' href='/static/service_protocol.html' target='_blank'>服务协议</a>和<a class='link' href='/static/privacy_policy.html' target='_blank'>隐私政策</a>",
      submit: '立即注册',
      loginLink: '已有账号，马上登录'
    },
    cellphoneRegister: {
      title: '手机号注册'
    },
    resetPassword: {
      title: '重置密码',
      submit: '重置密码'
    },
    wxlogin: {
      title: '微信登录'
    },
    wxbind: {
      title: '尚未绑定PP匠账号，立即绑定！',
      submit: '绑定PP匠账号'
    },
    category: {
      all: '全部@:common.project',
      edit: '修改分组',
      new: '新建分组',
      remove: '删除分组',
      publicity: '公开访问',
      cover: '点击编辑分组封面',
      noMore: '已到底部',
      noResults: '暂无@:common.project'
    },
    project: {
      new: '新建@:common.project',
      updatePPT: '更新 PPT',
      moveTo: '移动至',
      alterCover: '替换封面',
      steps: {
        upload: '上传@:common.project',
        convert: '转化 H5',
        complete: '分享链接'
      },
      stats: {
        data: '@:common.project数据',
        form: '表单统计'
      },
      settings: {
        basic: '常用设置',
        advanced: '高级设置',
        cancel: '放弃修改',
        wxshare: '微信分享',
        wxcover: '点击编辑封面',
        arrow: '翻页箭头',
        stretch: '页面适配',
        stretchValue: {
          auto: '自动',
          fullscreen: '撑满',
          restrict: '缩放',
          smart: '智能填充'
        },
        autoplayLabel: '动画控制',
        autoplay: {
          enabled: '自动播放',
          original: '还原PPT'
        },
        access: '访问限制',
        accessTypes: {
          none: '无',
          code: '密码访问',
          pay: '付费阅读',
          spell: '公众号推广'
        },
        accessLabels: {
          code: '访问密码',
          random: '随机生成',
          hint: '密码提示',
          previewPages: '预览页数',
          price: '价格（元）',
          wechat: '微信号',
          spell: '回复口令'
        },
        bgmLabel: '背景音乐',
        bgm: {
          submit: '选择上传'
        },
        logoLabel: 'LOGO 设置',
        logo: {
          default: '默认PP匠',
          custom: '自定义',
          hide: '隐藏',
          cover: '点击编辑 LOGO',
          price: '该功能为付费功能，费用为每@:common.project 99 元，',
          priceBtn: '点击购买',
          title: '购买自定义logo权限',
          price2: '￥ 99.00 元 / @:common.project'
        }
      }
    },
    export: {
      paid: {
        title: '@:common.project导出',
        submit: '点击链接下载文件'
      },
      unpaid: {
        title: '购买@:common.project导出权限',
        price: '￥ 120.00 元 / @:common.project'
      }
    },
    record: {
      title: '录制语音',
      loading: '正在获取录制链接',
      editView: '录制页面',
      clientView: '播放页面'
    },
    imageUploader: {
      defaultCoverHint: '单击上传图片'
    },
    order: {
      wechat: {
        title: '支付',
        hint: '打开微信，扫码完成支付'
      },
      loading: '下单中，请稍后',
      paid: '支付成功，即将返回上一界面...',
      questions: '遇到问题？'
    }
  },
  placeholder: {
    category: {
      name: '分组名称',
      description: '分组描述'
    },
    project: {
      name: '@:common.project名称',
      viewer_url: '网页地址',
      client_url: '播放地址',
      title: '分享标题',
      description: '分享描述',
      auth_config: {
        code: '3-20位字母或数字',
        hint: '例：公司电话号码',
        wechat: '微信公众号的微信ID',
        spell: '设置回复口令'
      }
    },
    user: {
      email: '账号邮箱',
      cellphone: '用户手机号码',
      emailOrCellphone: '邮箱或手机号',
      captcha: '验证码',
      password: '账号密码',
      oldPassword: '原始密码',
      newPassword: '新的密码',
      passwordConfirmation: '请再次输入密码'
    }
  },
  hint: {
    project: {
      convert: {
        main: '正在生成中，大概需要 1 - 3 分钟，请稍候...',
        secondary: '完成后自动跳转下一步，请勿关闭本页面'
      },
      edit: {
        access: {
          none: '请放心，PP 匠生成的链接是私密安全的请放心使用，访问限制只是进一步控制权限。',
          code: '密码访问提示文案',
          pay: '付费阅读提示文案',
          spell: '公众号推广提示文案'
        },
        bgm: '文件限制 10M, 建议将音乐裁剪至 40 秒内以保证加载速度。',
        logo: {
          default: '加载页默认用PP匠logo',
          hide: '加载页不显示logo'
        }
      },
      export: {
        main: '导出会将H5打包为zip文件下载到本地，包含生成的html、js以及图片等资源',
        secondary: '注意：购买后@:common.project只有两次导出的机会，请确认转化效果满意后再使用'
      },
      logo: {
        main: '您的@:common.project可以更新加载页的logo'
      },
      record: {
        main: '使用微信在 h5 页面中添加语音，可以用来录制微课或解说',
        secondary: '微信扫码进入录制页面',
        error: '请确保在手机编辑的最后一页点击“完成录制”按钮'
      }
    },
    media: {
      audio: {
        empty: '暂无音乐'
      },
      image: {
        empty: '暂无图片',
        uploading: '上传中',
        remove: '从素材库中移除该图片'
      }
    }
  },
  qrcode: {
    convert: '微信扫一扫<br />即时获取生成进度',
    project: '手机扫码，浏览作品'
  },
  project: {
    state: {
      uploading: '转化中',
      converting: '转化中',
      rendering: '转化中',
      disting: '转化中',
      redisting: '转化中',
      finishing: '发布中',
      completed: '已完成',
      halted: '异常',
      expired: '已过期',
      temp: '临时'
    }
  }
});

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  computed: {
    organization: function organization() {
      return this.$store && this.$store.getters['user/organization'];
    },
    user: function user() {
      return this.$store && this.$store.state.user.info;
    },
    tbcMode: function tbcMode() {
      return this.$store && this.$store.state.tbcMode;
    },
    embedMode: function embedMode() {
      return window.top !== window.self;
    }
  },
  methods: {
    canDo: function canDo(permission) {
      return this.organization && this.organization.permissions && this.organization.permissions.indexOf(permission) >= 0;
    }
  }
};

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// methods here can directly be called in methods of each component
_moment2.default.locale("zh-cn");

var dictionary = {
  'zh-cn': {
    'after': '之后',
    'before': '之前',
    'day': '天',
    'hour': '小时',
    'minute': '分钟',
    'second': '秒',
    'priceNotAvaliable': '暂无金额'
  }
};

var getLocale = function getLocale(tag) {
  return dictionary["zh-cn"][tag];
};

exports.default = {
  methods: {
    sizeReadable: function sizeReadable(size) {
      var i = -1;
      var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
      do {
        size = size / 1024;
        i++;
      } while (size > 1024);

      return Math.max(size, 0.1).toFixed(1) + byteUnits[i];
    },
    durationReadable: function durationReadable(durationInSeconds) {
      var result = '';

      if (durationInSeconds > 3600) {
        var h = parseInt(durationInSeconds / 3600, 10);
        result += (h < 10 ? '0' + h : '' + h) + ':';
      }

      var m = parseInt(durationInSeconds % 3600 / 60, 10);
      result += (m < 10 ? '0' + m : '' + m) + ':';

      var s = parseInt(durationInSeconds % 60, 10);
      result += s < 10 ? '0' + s : '' + s;
      return result;
    },
    dateReadable: function dateReadable(ts) {
      var simple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      return (0, _moment2.default)(ts).format(simple ? 'YYYY-MM-DD' : 'YYYY/MM/DD HH:mm:ss');
    },
    timeDiff: function timeDiff(ts, ts2) {
      var words = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (typeof ts2 !== 'number' || typeof ts2 !== 'string') {
        words = ts2;
        ts2 = null;
      }

      var a = (0, _moment2.default)(ts);
      var b = ts2 ? (0, _moment2.default)(ts2) : (0, _moment2.default)();
      var _diff = a.diff(b);
      if (!words) {
        return _diff;
      }

      var suffix = _diff > 0 ? getLocale('after') : getLocale('before');
      _diff = Math.abs(_diff);

      if (_diff > 1000 * 60 * 60 * 24) {
        return Math.abs(a.diff(b, 'days')) + getLocale('day') + suffix;
      } else if (_diff > 1000 * 60 * 60) {
        return Math.abs(a.diff(b, 'hours')) + getLocale('hour') + suffix;
      } else if (_diff > 1000 * 60) {
        return Math.abs(a.diff(b, 'minutes')) + getLocale('minute') + suffix;
      } else {
        return Math.abs(a.diff(b, 'seconds')) + getLocale('second') + suffix;
      }
    },
    priceReadableInHtml: function priceReadableInHtml(price) {
      var _price = Number(price);

      if (isNaN(_price)) {
        return '<span>' + getLocale('priceNotAvaliable') + '</span>';
      }
      return '<span class=\'currency\'>\uFFE5</span><span class=\'integer\'>' + Math.floor(_price) + '</span>.<span class=\'float\'>' + (_price % 1).toFixed(2).substring(2) + '</span>';
    }
  }
};

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _elementUi = __webpack_require__(204);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var temp = new _vue2.default();

var ContactMarket = function ContactMarket() {
  var template = "<div><img src='/static/images/business-qrcode.png' style=\"width:180px;height:180px\"></img><p style=\"margin-top: 10px; margin-bottom: -24px; color: #666;\">销售电话: 18602727347</p></div>";
  var renderer = _vue2.default.compile(template);

  _elementUi.MessageBox.alert(temp.$createElement(renderer), { title: '联系销售', customClass: 'center', showClose: false });
};

var ContactCS = function ContactCS() {
  var template = '<div style="text-align: left;"><p>客服QQ群：461571276</p><p>客服邮箱：support@ppj.io</p></div>';
  var renderer = _vue2.default.compile(template);

  _elementUi.MessageBox.alert(temp.$createElement(renderer), { title: '联系客服', customClass: 'center', showClose: false });
};

var ContactApiApplication = function ContactApiApplication() {
  var template = "<div style=\"margin-bottom: -1em;\"><h1>提交成功</h1><p style=\"color: #333;margin: 2em 0 1em;\">请微信联系客服开通权限</p><img src='/static/images/business-qrcode.png' style=\"width:180px;height:180px\"></img></div>";
  var renderer = _vue2.default.compile(template);

  _elementUi.MessageBox.alert(temp.$createElement(renderer), { title: ' ', customClass: 'center noheader', showClose: false });
};

var install = function install(Vue) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  Vue.prototype.$contactMarket = ContactMarket;
  Vue.prototype.$contactCS = ContactCS;
  Vue.prototype.$contactApiApplication = ContactApiApplication;
};

module.exports = {
  install: install
};

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _dialog = __webpack_require__(61);

var _audio = __webpack_require__(884);

var _audio2 = _interopRequireDefault(_audio);

var _image = __webpack_require__(885);

var _image2 = _interopRequireDefault(_image);

var _order = __webpack_require__(886);

var _order2 = _interopRequireDefault(_order);

var _upgrade = __webpack_require__(887);

var _upgrade2 = _interopRequireDefault(_upgrade);

var _edit = __webpack_require__(883);

var _edit2 = _interopRequireDefault(_edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// project
// create function
var install = function install(Vue) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  Vue.prototype.$mediaAudio = (0, _dialog.createDialog)(_audio2.default);
  Vue.prototype.$mediaImage = (0, _dialog.createDialog)(_image2.default);
  Vue.prototype.$order = (0, _dialog.createDialog)(_order2.default);
  Vue.prototype.$upgradeProject = (0, _dialog.createDialog)(_upgrade2.default);
  Vue.prototype.$editCategory = (0, _dialog.createDialog)(_edit2.default);
};
// category edit

// order


module.exports = {
  install: install
};

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRouter = createRouter;

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(958);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _index = __webpack_require__(828);

var _index2 = _interopRequireDefault(_index);

var _login = __webpack_require__(869);

var _login2 = _interopRequireDefault(_login);

var _wxlogin = __webpack_require__(874);

var _wxlogin2 = _interopRequireDefault(_wxlogin);

var _wxbind = __webpack_require__(873);

var _wxbind2 = _interopRequireDefault(_wxbind);

var _register = __webpack_require__(871);

var _register2 = _interopRequireDefault(_register);

var _cellphone_register = __webpack_require__(868);

var _cellphone_register2 = _interopRequireDefault(_cellphone_register);

var _password = __webpack_require__(870);

var _password2 = _interopRequireDefault(_password);

var _reset_password = __webpack_require__(872);

var _reset_password2 = _interopRequireDefault(_reset_password);

var _api_application = __webpack_require__(867);

var _api_application2 = _interopRequireDefault(_api_application);

var _project = __webpack_require__(848);

var _project2 = _interopRequireDefault(_project);

var _show = __webpack_require__(851);

var _show2 = _interopRequireDefault(_show);

var _upload = __webpack_require__(866);

var _upload2 = _interopRequireDefault(_upload);

var _stats = __webpack_require__(863);

var _stats2 = _interopRequireDefault(_stats);

var _summary = __webpack_require__(864);

var _summary2 = _interopRequireDefault(_summary);

var _form = __webpack_require__(862);

var _form2 = _interopRequireDefault(_form);

var _profile = __webpack_require__(847);

var _profile2 = _interopRequireDefault(_profile);

var _account = __webpack_require__(842);

var _account2 = _interopRequireDefault(_account);

var _income = __webpack_require__(846);

var _income2 = _interopRequireDefault(_income);

var _development = __webpack_require__(845);

var _development2 = _interopRequireDefault(_development);

var _members = __webpack_require__(835);

var _members2 = _interopRequireDefault(_members);

var _price = __webpack_require__(839);

var _price2 = _interopRequireDefault(_price);

var _order = __webpack_require__(838);

var _order2 = _interopRequireDefault(_order);

var _teacher_verification = __webpack_require__(875);

var _teacher_verification2 = _interopRequireDefault(_teacher_verification);

var _dashboard = __webpack_require__(822);

var _dashboard2 = _interopRequireDefault(_dashboard);

var _permanents = __webpack_require__(824);

var _permanents2 = _interopRequireDefault(_permanents);

var _crosstab = __webpack_require__(203);

var _crosstab2 = _interopRequireDefault(_crosstab);

var _bus = __webpack_require__(81);

var _bus2 = _interopRequireDefault(_bus);

var _lazyLoadModule = __webpack_require__(48);

var _miscellaneous = __webpack_require__(393);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// weixin-js-sdk


// import global event-driven


// dashboard view


// profile related view


// project related view


// session related view
_vue2.default.use(_vueRouter2.default);

// faq view


// 一些独立的页面


var routes = [{
  path: '/categories/:id*',
  alias: '/projects',
  name: 'category',
  component: _index2.default
}, {
  path: '/projects/:id*',
  component: _project2.default,
  children: [{
    path: 'upload',
    alias: '/projects/new',
    name: 'project_upload',
    component: _upload2.default
  }, {
    path: 'stats',
    component: _stats2.default,
    children: [{
      path: 'form',
      component: _form2.default
    }, {
      path: '',
      component: _summary2.default
    }]
  }, {
    path: '',
    name: 'project',
    component: _show2.default
  }]
}, {
  path: '/profile',
  component: _profile2.default,
  children: [{
    path: 'income',
    component: _income2.default
  }, {
    path: 'development',
    component: _development2.default
  }, {
    path: '',
    name: 'profile',
    alias: 'account',
    component: _account2.default
  }]
}, {
  path: '/members',
  name: 'members',
  component: _members2.default
}, {
  path: '/dashboard',
  name: 'dashboard',
  component: _dashboard2.default
}, {
  path: '/order',
  name: 'order',
  component: _order2.default
}, {
  path: '/teacher',
  name: 'teacher',
  component: _teacher_verification2.default
}, {
  path: '/price',
  name: 'price',
  component: _price2.default,
  meta: { noSession: 'both', fullscreen: true }
}, {
  path: '/faq/permanent',
  component: _permanents2.default,
  meta: { noSession: 'both' }
}, {
  path: '/apply/company',
  component: _api_application2.default,
  meta: { noSession: 'both' }
}, {
  path: '/login',
  name: 'login',
  component: _login2.default,
  meta: { noSession: true }
}, {
  path: '/wxlogin',
  name: 'wxlogin',
  component: _wxlogin2.default,
  meta: { noSession: true }
}, {
  path: '/wxbind',
  name: 'wxbind',
  component: _wxbind2.default,
  meta: { noSession: true }
}, {
  path: '/register',
  name: 'm_register',
  component: _cellphone_register2.default,
  meta: { noSession: true }
}, {
  path: '/register/email',
  name: 'e_register',
  component: _register2.default,
  meta: { noSession: true }
}, {
  path: '/password',
  name: 'password',
  component: _password2.default,
  meta: { noSession: true }
}, {
  path: '/password/reset',
  component: _reset_password2.default,
  meta: { noSession: true }
}, {
  path: '/error',
  name: 'error',
  component: {
    render: function render(h) {
      return h('div', '异常页面，我们正在积极修复中...');
    }
  }
}, {
  path: '*',
  redirect: '/projects'
}];

var vueStore = null;
var returnTo = null;

var scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition;
  } else {
    return {
      x: 0,
      y: 0
    };
  }
};
//
var beforeEach = function beforeEach(to, from, next) {
  if (to.name === 'error') {
    next();
    return;
  }

  if (to.path === '/login' && to.query.returnTo) {
    returnTo = to.query.returnTo;
  }

  if (to.query.closeOnPQuota) {
    // register close window on get Permanent quotas
    _bus2.default.$on('GetPermanentsQuota', function () {
      // let other tab to refresh
      _crosstab2.default.broadcast('refresh');
      window.setTimeout(function () {
        window.close();
      }, 500);
    });
  }

  if (vueStore) {
    // 用来获得当前session状态
    var noSessionRequired = to.meta.noSession;
    // undefined -- session required, true -- no session required and need redirect if there is session, 'both' -- pass validation

    // get session info
    var redirectWithSession = function redirectWithSession() {
      if (to.query.code && /^\/register/.test(to.path)) {
        window.alert('抱歉，本活动仅限新用户参与');
        next('/');
        return;
      }

      if (returnTo) {
        var _destination = { path: returnTo };
        returnTo = null;
        next(_destination);
        return;
      }

      if (noSessionRequired === true) {
        next('/');
        return;
      }

      next();
    };

    var redirectWithNoSession = function redirectWithNoSession() {
      if (noSessionRequired === undefined) {
        next('/login');
      } else {
        next();
      }
    };

    var session = vueStore.getters['user/session'];
    if (session) {
      redirectWithSession();
    } else if (session === false) {
      redirectWithNoSession();
    } else {
      vueStore.dispatch('user/get').then(function (res) {
        res === false ? redirectWithNoSession() : redirectWithSession();
      });
    }
    return;
  }
  next('error');
};

var inWechat = /micromessenger/i.test(window.navigator.userAgent);
var afterEach = function afterEach(route) {
  // weixin need re-register jsapi if we want share in SPA
  if (inWechat) {
    (0, _lazyLoadModule.lazyload)('weixin').then(function (_) {
      var wx = window.wx;

      (0, _miscellaneous.weixinConfig)().then(function (res) {
        var config = res.data.wx_config;
        wx.ready(function () {
          var shareObj = {
            title: 'PP匠',
            desc: '上传PPT，一键生成H5',
            link: 'https://ppj.io',
            imgUrl: 'https://ppj.io/static/images/share.png'
          };

          wx.onMenuShareTimeline(shareObj);
          wx.onMenuShareAppMessage(shareObj);
          wx.onMenuShareQQ(shareObj);
          wx.onMenuShareWeibo(shareObj);
          wx.onMenuShareQZone(shareObj);
        });

        wx.config(config);
      });
    });
  }
};

var supportsPushState = function () {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
    return false;
  }

  return window.history && 'pushState' in window.history;
}();

// export default [].concat(main)
var router = null;
function createRouter(store) {
  router = new _vueRouter2.default({
    mode: 'history',
    scrollBehavior: scrollBehavior,
    base: supportsPushState ? '' : 'v2',
    routes: routes
  });
  // 注册全局导航钩子
  router.beforeEach(beforeEach);
  router.afterEach(afterEach);

  if (store) {
    vueStore = store;
  }
  return router;
}

exports.default = router;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(44);

var _assign2 = _interopRequireDefault(_assign);

var _apis = __webpack_require__(389);

var _apis2 = _interopRequireDefault(_apis);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// actions
var actions = {
  // get api request
  apiInfo: function apiInfo(_ref) {
    var rootGetters = _ref.rootGetters;

    return _apis2.default.apiInfo((0, _assign2.default)({}, {
      organization_id: rootGetters['user/organization'] && rootGetters['user/organization'].id
    }));
  },


  // update api request
  updateApis: function updateApis(_ref2, params) {
    var rootGetters = _ref2.rootGetters;

    return _apis2.default.updateApiInfo((0, _assign2.default)({}, params, {
      organization_id: rootGetters['user/organization'] && rootGetters['user/organization'].id
    }));
  },


  // send application
  sendApplication: function sendApplication(state, params) {
    return _apis2.default.sendApplication(params);
  }
};

exports.default = {
  namespaced: true,
  actions: actions
};

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(12);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(63);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _category = __webpack_require__(390);

var _category2 = _interopRequireDefault(_category);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Vue from 'vue'

var CATEGORIES_INDEX = 'CATEGORIES_INDEX';
var CATEGORIES_CREATE_OR_UPDATE = 'CATEGORIES_CREATE_OR_UPDATE';
var CATEGORIES_DESTROY = 'CATEGORIES_DESTROY';
// const CATEGORIES_LOAD_PROJECTS = 'CATEGORIES_LOAD_PROJECTS'

var state = {
  items: [] // store all categories info
  // all: [] // store all projects in all tag
};

var getters = {};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, CATEGORIES_INDEX, function (state, _ref) {
  var categories = _ref.categories;

  state.items = categories;
}), (0, _defineProperty3.default)(_mutations, CATEGORIES_CREATE_OR_UPDATE, function (state, _ref2) {
  var category = _ref2.category;

  var id = category.id;
  var oldIndex = _lodash2.default.findIndex(state.items, { id: id });

  if (oldIndex >= 0) {
    // replace rather than insert
    state.items.splice(oldIndex, 1, category);
  } else {
    state.items.push(category);
  }
}), (0, _defineProperty3.default)(_mutations, CATEGORIES_DESTROY, function (state, id) {
  var oldIndex = _lodash2.default.findIndex(state.items, { id: id });
  state.items.splice(oldIndex, 1);
}), _mutations);

var actions = {
  // index: get all categories
  index: function index(_ref3) {
    var state = _ref3.state,
        rootGetters = _ref3.rootGetters,
        commit = _ref3.commit;

    return _category2.default.index({
      organization_id: rootGetters['user/organization'] && rootGetters['user/organization'].id
    }).then(function (res) {
      commit(CATEGORIES_INDEX, { categories: res.data.list });
    });
  },

  // create or update a category, depends on whether there was an 'id' attribute
  // return the id of new/updated category
  create_or_update: function create_or_update(_ref4, params) {
    var rootGetters = _ref4.rootGetters,
        commit = _ref4.commit;

    return _category2.default.createOrUpdate(_lodash2.default.merge(params, {
      organization_id: rootGetters['user/organization'] && rootGetters['user/organization'].id
    })).then(function (res) {
      commit(CATEGORIES_CREATE_OR_UPDATE, { category: res.data });
      return res.data.id;
    });
  },


  // show: get a specific category by its id
  get: function get(_ref5, _ref6) {
    var state = _ref5.state,
        commit = _ref5.commit;
    var id = _ref6.id,
        force = _ref6.force;

    // set current category with its id
    var _id = Number(id);
    if (isNaN(_id)) throw new Error('params error');

    var _cat = state.items.find(function (value) {
      return value.id === _id;
    });

    return _cat && !force ? _promise2.default.resolve(_cat) : _category2.default.show(_id).then(function (res) {
      commit(CATEGORIES_CREATE_OR_UPDATE, { category: res.data });
    });
  },


  // destroy: delete a category
  destroy: function destroy(_ref7, id) {
    var state = _ref7.state,
        commit = _ref7.commit;

    var _id = Number(id);
    if (isNaN(_id)) throw new Error('params error');

    _category2.default.destroy(_id).then(function (res) {
      commit(CATEGORIES_DESTROY, _id);
    });
  }
};

exports.default = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _income = __webpack_require__(391);

var _income2 = _interopRequireDefault(_income);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// actions
var actions = {
  // get list of projects income
  index: function index(state) {
    return _income2.default.index();
  },


  // get a project income
  get: function get(state, id) {
    return _income2.default.show(id);
  }
};

exports.default = {
  namespaced: true,
  actions: actions
};

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _media = __webpack_require__(392);

var _media2 = _interopRequireDefault(_media);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// actions
var actions = {
  // get a bunch of medias
  index: function index(_, params) {
    return _media2.default.index(params);
  },
  destroy: function destroy(_, id) {
    return _media2.default.destroy(id);
  }
};

exports.default = {
  namespaced: true,
  actions: actions
};

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(12);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(63);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _order = __webpack_require__(394);

var _order2 = _interopRequireDefault(_order);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ORDER_SET_CHECKID = 'ORDER_SET_CHECKID';
var CHECK_STATE_INTERVAL = 2000;

// initial state
var state = {
  checks: {}
};

var mutations = (0, _defineProperty3.default)({}, ORDER_SET_CHECKID, function (state, _ref) {
  var id = _ref.id,
      checkID = _ref.checkID;

  state.checks[id] = checkID;
});

// actions
var actions = {
  // get list of projects income
  cancelCheckState: function cancelCheckState(_ref2, id) {
    var state = _ref2.state,
        commit = _ref2.commit;

    var cid = state.checks[id];
    if (cid) {
      window.clearTimeout(cid);
      commit(ORDER_SET_CHECKID, { id: id, checkID: null });
    }
    _promise2.default.resolve();
  },
  checkState: function checkState(_ref3, id) {
    var state = _ref3.state,
        dispatch = _ref3.dispatch,
        commit = _ref3.commit;

    return new _promise2.default(function (resolve, reject) {
      var check = function check() {
        _order2.default.state(id).then(function (res) {
          var state = res.data.state;

          if (state === 'completed') {
            // finished check
            // dispatch refresh for any order completed
            dispatch('refresh', null, { root: true });
            dispatch('cancelCheckState', id);
            resolve();
          } else {
            commit(ORDER_SET_CHECKID, { id: id, checkID: window.setTimeout(check, CHECK_STATE_INTERVAL) });
          }
        }).catch(function (err) {
          reject(err);
        });
      };

      dispatch('cancelCheckState', id).then(check);
    });
  }
};

exports.default = {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _organization = __webpack_require__(395);

var _organization2 = _interopRequireDefault(_organization);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// actions
var actions = {
  // get list of projects income
  members: function members(_, params) {
    return _organization2.default.members(params);
  },
  logs: function logs(_, params) {
    return _organization2.default.logs(params);
  },
  stats: function stats(_, params) {
    return _organization2.default.stats(params);
  },
  editMember: function editMember(_, params) {
    return _organization2.default.editMember(params);
  },
  removeMember: function removeMember(_, params) {
    return _organization2.default.removeMember(params);
  }
};

exports.default = {
  namespaced: true,
  actions: actions
};

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(12);

var _promise2 = _interopRequireDefault(_promise);

var _assign = __webpack_require__(44);

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = __webpack_require__(63);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _project2 = __webpack_require__(396);

var _project3 = _interopRequireDefault(_project2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PROJECT_GET = 'PROJECT_GET';
var PROJECT_SET_CHECKID = 'PROJECT_SET_CHECKID';
var CHECK_STATE_INTERVAL = 2000;

// initial state
var state = {
  items: {}, // store projects in key/value pair
  checks: {} // store checks for each project
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, PROJECT_GET, function (state, params) {
  _vue2.default.set(state.items, params.id, params);
}), (0, _defineProperty3.default)(_mutations, PROJECT_SET_CHECKID, function (state, _ref) {
  var id = _ref.id,
      checkID = _ref.checkID,
      lowerEt = _ref.lowerEt,
      upperEt = _ref.upperEt;

  _vue2.default.set(state.checks, id, {
    checkID: checkID,
    lowerEt: lowerEt || 1,
    upperEt: upperEt || 3
  });
}), _mutations);

// actions
var actions = {
  // get list of projects
  index: function index(_ref2, params) {
    var rootGetters = _ref2.rootGetters;

    return _project3.default.index((0, _assign2.default)({}, params, {
      organization_id: rootGetters['user/organization'] && rootGetters['user/organization'].id
    }));
  },


  // get list of projects' states
  states: function states(_, params) {
    return _project3.default.states(params);
  },


  // crate a project
  create: function create(_ref3, params) {
    var rootGetters = _ref3.rootGetters,
        commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    return _project3.default.create((0, _assign2.default)({}, params, {
      organization_id: rootGetters['user/organization'] && rootGetters['user/organization'].id
    })).then(function (res) {
      commit(PROJECT_GET, res.data);

      // 创建项目会消耗永久额度 所以需要re-pull额度
      dispatch('quota/index', { force: true }, { root: true });
      return res;
    });
  },


  // update a project
  update: function update(_ref4, params) {
    var commit = _ref4.commit;

    return _project3.default.update(params.id, params).then(function (res) {
      commit(PROJECT_GET, res.data);
      return res;
    });
  },


  // soft-delete a project
  destroy: function destroy(state, id) {
    return _project3.default.destroy(id);
  },


  // cancel checkstate
  cancelCheckState: function cancelCheckState(_ref5, id) {
    var state = _ref5.state,
        commit = _ref5.commit;

    var cid = state.checks[id];
    if (cid) {
      window.clearTimeout(cid);
      commit(PROJECT_SET_CHECKID, { id: id, checkID: null });
    }
    _promise2.default.resolve();
  },


  // start to check state of a project
  checkState: function checkState(_ref6, id) {
    var state = _ref6.state,
        dispatch = _ref6.dispatch,
        commit = _ref6.commit;

    return new _promise2.default(function (resolve, reject) {
      var clearTimeout = function clearTimeout() {
        var cid = state.checks[id];
        if (cid) {
          window.clearTimeout(cid);
          commit(PROJECT_SET_CHECKID, { id: id, checkID: null });
        }
      };

      var check = function check() {
        _project3.default.state(id).then(function (res) {
          var state = res.data.state;
          var estimatedTime = res.data.estimated_time;

          if (state === 'completed' || state === 'halted') {
            // finished check
            clearTimeout();
            dispatch('get', { id: id, force: true });
            resolve(id);
          } else {
            commit(PROJECT_SET_CHECKID, {
              id: id,
              checkID: window.setTimeout(check, CHECK_STATE_INTERVAL),
              lowerEt: estimatedTime.lower,
              upperEt: estimatedTime.upper
            });
          }
        }).catch(function (err) {
          reject(err);
        });
      };

      clearTimeout();
      check();
    });
  },


  // stats
  stats: function stats(_ref7, id) {
    var state = _ref7.state;

    return _project3.default.stats(id);
  },


  // form-records
  formRecords: function formRecords(_ref8, params) {
    var state = _ref8.state;

    return _project3.default.formRecords(params);
  },


  // delete form-record items
  deleteFormRecords: function deleteFormRecords(_ref9, params) {
    var state = _ref9.state;

    return _project3.default.deleteFormRecords(params);
  },


  // get
  get: function get(_ref10, _ref11) {
    var state = _ref10.state,
        commit = _ref10.commit;
    var id = _ref11.id,
        force = _ref11.force;

    var _project = state.items[id];

    return _project && !force ? _promise2.default.resolve(_project) : _project3.default.show(id).then(function (res) {
      commit(PROJECT_GET, res.data);
      return res.data;
    });
  },


  // record_qrcode
  recordQrcode: function recordQrcode(_, id) {
    return _project3.default.recordQrcode(id);
  },


  // export related
  createExport: function createExport(_, params) {
    return _project3.default.createExport(params);
  },
  checkExport: function checkExport(_, id) {
    return _project3.default.checkExport(id);
  }
};

exports.default = {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(44);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(39);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(12);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(63);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _quota = __webpack_require__(397);

var _quota2 = _interopRequireDefault(_quota);

var _bus = __webpack_require__(81);

var _bus2 = _interopRequireDefault(_bus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QUOTA_INDEX = 'QUOTA_INDEX';
var QUOTA_CLEAN = 'QUOTA_CLEAN';
// initial state
var state = {
  summary: {},
  list: [],
  'permanent_quota_expired': false
};

var getters = {
  overdate: function overdate(state) {
    return state.permanent_quota_expired;
  }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, QUOTA_INDEX, function (state, _ref) {
  var summary = _ref.summary,
      list = _ref.list,
      permanent_quota_expired = _ref.permanent_quota_expired;

  // check if quota is updated
  if (state.summary.permanents_left !== null && (summary.permanents_left === null || (state.summary.permanents_left || 0) < summary.permanents_left)) {
    _bus2.default.$emit('GetPermanentsQuota', summary.permanents_left === null ? null : summary.permanents_left - state.summary.permanents_left);
  }
  _vue2.default.set(state, 'summary', summary);
  _vue2.default.set(state, 'list', list);
  _vue2.default.set(state, 'permanent_quota_expired', permanent_quota_expired);
}), (0, _defineProperty3.default)(_mutations, QUOTA_CLEAN, function (state) {
  _vue2.default.set(state, 'summary', {});
  _vue2.default.set(state, 'list', []);
  _vue2.default.set(state, 'permanent_quota_expired', false);
}), _mutations);

// actions
var actions = {
  // get a bunch of medias
  index: function index(_ref2) {
    var rootGetters = _ref2.rootGetters,
        commit = _ref2.commit,
        state = _ref2.state;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _force = params.force || false;

    return new _promise2.default(function (resolve, reject) {
      if (state.summary.permanents && !_force) {
        resolve(JSON.parse((0, _stringify2.default)(state)));
      } else {
        _quota2.default.index({
          organization_id: rootGetters['user/organization'] && rootGetters['user/organization'].id
        }).then(function (res) {
          commit(QUOTA_INDEX, res.data);
          resolve(res.data);
        }).catch(reject);
      }
    });
  },


  // buy quota
  buy: function buy(_ref3, params) {
    var rootGetters = _ref3.rootGetters,
        state = _ref3.state;

    return _quota2.default.buy((0, _assign2.default)({}, params, {
      organization_id: rootGetters['user/organization'] && rootGetters['user/organization'].id
    }));
  },


  // consume quota
  consume: function consume(_ref4, params) {
    var dispatch = _ref4.dispatch;

    return _quota2.default.consume(params).then(function (_) {
      dispatch('index', { force: true });
    });
  },


  // check price
  price: function price(_, params) {
    return _quota2.default.price(params);
  }
};

exports.default = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(12);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(63);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _user2 = __webpack_require__(398);

var _user3 = _interopRequireDefault(_user2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var USER_GET = 'USER_GET';
var USER_DESTROY = 'USER_DESTROY';
var WX_CONNECTION_SET = 'WX_CONNECTION_SET';
var WX_CONNECTION_CHECKID_SET = 'WX_CONNECTION_CHECKID_SET';

// initial state
var state = {
  info: {
    id: null
  },
  wxConnection: {
    connected: false
  },
  wxConnectionCheckID: null
};

var getters = {
  organization: function organization(state) {
    return state.info.organizations && state.info.organizations.length > 0 ? state.info.organizations[0] : null;
  },
  session: function session(state) {
    return state.info.id;
  }
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, USER_GET, function (state, _ref) {
  var user = _ref.user;

  state.info = user;
}), (0, _defineProperty3.default)(_mutations, USER_DESTROY, function (state) {
  state.info = { id: null };
}), (0, _defineProperty3.default)(_mutations, WX_CONNECTION_SET, function (state, params) {
  state.wxConnection = params;
}), (0, _defineProperty3.default)(_mutations, WX_CONNECTION_CHECKID_SET, function (state, cid) {
  state.wxConnectionCheckID = cid;
}), _mutations);

// actions
var actions = {
  // get user profile
  get: function get(_ref2) {
    var dispatch = _ref2.dispatch,
        state = _ref2.state,
        commit = _ref2.commit;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _user = null;
    if (state.info.id) {
      _user = state.info;
    }

    var force = params.force || false;

    return new _promise2.default(function (resolve, reject) {
      if (_user && !force) {
        resolve(_user);
      } else {
        _user3.default.show().then(function (res) {
          commit(USER_GET, { user: res.data });

          if (res.data.source === 'tbc') {
            dispatch('set_tbc_mode', true, { root: true });
          }

          // after get user, get its quotas, since it is related
          dispatch('quota/index', { force: true }, { root: true }).then(function (_) {
            resolve(res.data);
          });
        }).catch(function (err) {
          if (err && err.response && err.response.status === 401) {
            commit(USER_GET, { user: { id: false } });
            resolve(false);
          } else {
            reject(err);
          }
        });
      }
    });
  },


  // update user profile
  update: function update(_ref3, params) {
    var dispatch = _ref3.dispatch,
        commit = _ref3.commit;

    return _user3.default.update(params).then(function (res) {
      commit(USER_GET, { user: res.data });
      dispatch('quota/index', { force: true }, { root: true });
    });
  },


  // send captcha request
  captcha: function captcha(state, params) {
    return _user3.default.captcha(params);
  },


  // User sign-in
  signIn: function signIn(_ref4, params) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    return _user3.default.signIn(params).then(function (res) {
      commit(USER_GET, { user: res.data.user });
      dispatch('quota/index', { force: true }, { root: true });
    });
  },


  // User sign_out
  signOut: function signOut(_ref5, params) {
    var commit = _ref5.commit;

    return _user3.default.signOut().then(function () {
      commit(USER_DESTROY);
      commit('quota/QUOTA_CLEAN', null, { root: true });
    });
  },


  // User sign-up
  signUp: function signUp(_ref6, params) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;

    return _user3.default.signUp(params).then(function (res) {
      commit(USER_GET, { user: res.data.user });
      dispatch('quota/index', { force: true }, { root: true });
    });
  },


  // 修改密码
  changePassword: function changePassword(_ref7, params) {
    var state = _ref7.state;

    return _user3.default.changePassword(params);
  },


  // 请求重置密码
  reqResetPassword: function reqResetPassword(_, params) {
    return _user3.default.reqResetPassword(params);
  },


  // 重置密码
  resetPassword: function resetPassword(_ref8, params) {
    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;

    return _user3.default.resetPassword(params).then(function (res) {
      commit(USER_GET, { user: res.data.user });
      dispatch('quota/index', { force: true }, { root: true });
    });
  },


  // mp connection
  wxConnection: function wxConnection(_ref9) {
    var state = _ref9.state,
        commit = _ref9.commit,
        dispatch = _ref9.dispatch;

    return _user3.default.wxConnection().then(function (res) {
      var connected = res.data.connected;

      if (state.info.wechat_mp_connected !== connected) {
        dispatch('get', { force: true });
      }

      commit(WX_CONNECTION_SET, res.data);

      var clearCheckID = function clearCheckID() {
        if (state.wxConnectionCheckID) {
          window.clearTimeout(state.wxConnectionCheckID);
          commit(WX_CONNECTION_CHECKID_SET, null);
        }
      };

      // since wxConnection might expire
      if (!connected) {
        // 前端提前一分钟刷新
        var interval = res.data.expired_at * 1000 - Date.now() - 60 * 1000;

        clearCheckID();
        commit(WX_CONNECTION_CHECKID_SET, window.setTimeout(function () {
          dispatch('wxConnection');
        }, interval));
      } else {
        clearCheckID();
      }
    });
  },


  // wx auth params
  wxAuth: function wxAuth() {
    return _user3.default.wxAuth();
  },


  // wx disconnect
  wxDisconnect: function wxDisconnect(_ref10) {
    var dispatch = _ref10.dispatch;

    return _user3.default.wxDisconnect().then(function (_) {
      dispatch('get', { force: true });
    });
  }
};

exports.default = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withdraw = __webpack_require__(399);

var _withdraw2 = _interopRequireDefault(_withdraw);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// actions
var actions = {
  // get list of withdraws
  index: function index(state) {
    return _withdraw2.default.index();
  }
};

exports.default = {
  namespaced: true,
  actions: actions
};

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _accountingJs = __webpack_require__(348);

var _accountingJs2 = _interopRequireDefault(_accountingJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'vue-numeric',

  props: {
    /**
     * Currency symbol.
     */
    currency: {
      default: '',
      required: false,
      type: String
    },

    /**
     * Maximum value allowed.
     */
    max: {
      required: false,
      type: [Number, String]
    },

    /**
     * Minimum value allowed.
     */
    min: {
      default: 0,
      required: false,
      type: [Number, String]
    },

    /**
     * Enable/Disable minus value.
     */
    minus: {
      default: false,
      required: false,
      type: Boolean
    },

    /**
     * Input placeholder.
     */
    placeholder: {
      required: false,
      type: String
    },

    /**
     * Number of decimals.
     * Decimals symbol are the opposite of separator symbol.
     */
    precision: {
      required: false,
      type: [Number, String]
    },

    /**
     * Thousand separator type.
     * Separator props accept either . or , (default).
     */
    separator: {
      default: ',',
      required: false,
      type: String
    },

    /**
     * v-model value.
     */
    value: {
      required: true,
      type: [Number, String]
    },

    /**
     * Hide input and show value in text only.
     */
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    },

    /**
     * Class for the span tag when readOnly props is true.
     */
    readOnlyClass: {
      default: '',
      required: false,
      type: String
    },

    /**
     * Position of currency symbol
     * Symbol position props accept either 'suffix' or 'prefix' (default).
     */
    currencySymbolPosition: {
      default: 'prefix',
      required: false,
      type: String
    }
  },

  data: function data() {
    return {
      amount: ''
    };
  },

  computed: {
    /**
     * Number formatted user typed value.
     * @return {Number}
     */
    amountValue: function amountValue() {
      return this.formatToNumber(this.amount);
    },


    /**
     * Number type from value props.
     * @return {Number}
     */
    numberValue: function numberValue() {
      return this.formatToNumber(this.value);
    },


    /**
     * Number formatted minimum value.
     * @return {Number}
     */
    minValue: function minValue() {
      if (this.min) return this.formatToNumber(this.min);
      return 0;
    },


    /**
     * Number formatted maximum value.
     * @return {Number|undefined}
     */
    maxValue: function maxValue() {
      if (this.max) return this.formatToNumber(this.max);
      return undefined;
    },


    /**
     * Define decimal separator based on separator props.
     * @return {String} '.' or ','
     */
    decimalSeparator: function decimalSeparator() {
      if (this.separator === '.') return ',';
      return '.';
    },


    /**
     * Define thousand separator based on separator props.
     * @return {String} '.' or ','
     */
    thousandSeparator: function thousandSeparator() {
      if (this.separator === '.') return '.';
      return ',';
    },


    /**
     * Define format for currency symbol and value.
     * @return {String} format
     */
    formatString: function formatString() {
      return this.currencySymbolPosition === 'suffix' ? '%v %s' : '%s %v';
    }
  },

  methods: {
    /**
     * Check provided value againts maximum allowed.
     * @param {Number} value
     * @return {Boolean}
     */
    checkMaxValue: function checkMaxValue(value) {
      if (this.max) {
        if (value <= this.maxValue) return false;
        return true;
      }
      return false;
    },


    /**
     * Check provided value againts minimum allowed.
     * @param {Number} value
     * @return {Boolean}
     */
    checkMinValue: function checkMinValue(value) {
      if (this.min) {
        if (value >= this.minValue) return false;
        return true;
      }
      return false;
    },


    /**
     * Format provided value to number type.
     * @param {String} value
     * @return {Number}
     */
    formatToNumber: function formatToNumber(value) {
      var number = 0;

      if (this.separator === '.') {
        var cleanValue = value;
        if (typeof value !== 'string') {
          cleanValue = this.numberToString(value);
        }
        number = Number(String(cleanValue).replace(/[^0-9-,]+/g, '').replace(',', '.'));
      } else {
        number = Number(String(value).replace(/[^0-9-.]+/g, ''));
      }

      if (!this.minus) return Math.abs(number);
      return number;
    },


    /**
     * Validate value before apply to the component.
     * @param {Number} value
     */
    processValue: function processValue(value) {
      if (isNaN(value)) {
        this.updateValue(this.minValue);
      } else if (this.checkMaxValue(value)) {
        this.updateValue(this.maxValue);
      } else if (this.checkMinValue(value)) {
        this.updateValue(this.minValue);
      } else {
        this.updateValue(value);
      }
    },


    /**
     * Format value using symbol and separator.
     */
    formatValue: function formatValue() {
      this.amount = _accountingJs2.default.formatMoney(this.numberValue, {
        symbol: this.currency,
        format: this.formatString,
        precision: Number(this.precision),
        decimal: this.decimalSeparator,
        thousand: this.thousandSeparator
      });
    },


    /**
     * Update parent component model value.
     * @param {Number} value
     */
    updateValue: function updateValue(value) {
      this.$emit('input', Number(_accountingJs2.default.toFixed(value, this.precision)));
    },


    /**
     * Remove symbol and separator.
     * @param {Number} value
     */
    numberToString: function numberToString(value) {
      return _accountingJs2.default.formatMoney(value, {
        symbol: '',
        precision: Number(this.precision),
        decimal: this.decimalSeparator,
        thousand: ''
      });
    },


    /**
     * Remove symbol and separator.
     * @param {Number} value
     */
    convertToNumber: function convertToNumber(value) {
      this.amount = this.numberToString(value);
    }
  },

  watch: {
    /**
     * Watch for value change from other input.
     *
     * @param {Number} val
     * @param {Number} oldVal
     */
    numberValue: function numberValue(val, oldVal) {
      if (this.amountValue !== val && this.amountValue === oldVal) {
        this.convertToNumber(val);
        if (this.$refs.numeric !== document.activeElement) {
          this.formatValue(val);
        }
      }
    },


    /**
     * When readOnly is true, replace the span tag class.
     *
     * @param {Boolean} val
     * @param {Boolean} oldVal
     */
    readOnly: function readOnly(val, oldVal) {
      var _this = this;

      if (oldVal === false && val === true) {
        this.$nextTick(function () {
          _this.$refs.readOnly.className = _this.readOnlyClass;
        });
      }
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    // Check default value from parent v-model.
    if (this.value) {
      this.processValue(this.formatToNumber(this.value));
      this.formatValue(this.value);
    }

    // Set read-only span element's class
    if (this.readOnly) {
      this.$refs.readOnly.className = this.readOnlyClass;
    }

    // In case of delayed v-model new value.
    setTimeout(function () {
      _this2.processValue(_this2.formatToNumber(_this2.value));
      _this2.formatValue(_this2.value);
    }, 500);
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _headbar = __webpack_require__(877);

var _headbar2 = _interopRequireDefault(_headbar);

var _hintbox = __webpack_require__(878);

var _hintbox2 = _interopRequireDefault(_hintbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//

exports.default = {
  components: {
    'headbar': _headbar2.default,
    'hintbox': _hintbox2.default
  }
};

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _charts = __webpack_require__(155);

var _dialog = __webpack_require__(61);

var _project = __webpack_require__(823);

var _project2 = _interopRequireDefault(_project);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      projectsCreatedData: null,
      projectsCreatedPeriod: 'week',
      granularity: 'day',
      summary: {},
      quotas: {},
      periods: ['week', 'month', 'season', 'year'],
      recentProjects: [],
      projectDialog: (0, _dialog.createDialog)(_project2.default)
      // currentPage: 1
    };
  },

  watch: {
    projectsCreatedPeriod: function projectsCreatedPeriod(newValue) {
      this.fetch();
    }
  },
  computed: {
    projectsCreatedChartOptions: function projectsCreatedChartOptions() {
      var vm = this;

      return {
        tooltips: {
          callbacks: {
            // title: (item, data) => { return item.yLabel.toString() },
            label: function label(item, data) {
              return vm.$t('projectNum') + item.yLabel.toString();
            }
          }
        },
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              displayFormats: {
                day: 'MM-DD',
                week: 'wo',
                month: 'MMM'
              },
              isoWeekday: true, // 'true' would start with 'Monday', 'false' would start with 'Sunday'
              unit: vm.granularity,
              stepSize: vm.projectsCreatedPeriod === 'month' ? null : 1,
              tooltipFormat: vm.granularity === 'month' ? 'YYYY-MM' : 'YYYY-MM-DD'
            }
          }]
        }
      };
    }
  },
  components: {
    'line-chart': function lineChart() {
      return (0, _charts.dynamicImportChartkick)('LineChart');
    }
  },
  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.loading = true;
      vm.$store.dispatch('organization/stats', {
        orgId: vm.organization.id,
        period: vm.projectsCreatedPeriod
        // page: vm.currentPage || 1
      }).then(function (res) {
        // vm.currentPage = res.data.current_page
        vm.projectsCreatedData = res.data.projects_created.data;
        vm.granularity = res.data.projects_created.granularity;
        vm.summary = res.data.summary;
        vm.quotas = res.data.quotas;
        vm.recentProjects = res.data.recent_projects;
        // vm.projects_created_data = data.
        // vm.totalPages = res.data.total_pages
        // vm.totalItems = res.data.total_items
        // vm.pageSize = res.data.page_size
        vm.loading = false;
      });
    }
  },
  mounted: function mounted() {
    this.fetch();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      link: null,
      dialogVisible: false
    };
  },

  methods: {
    onCopy: function onCopy(e) {
      this.$message({
        message: this.$t('common.infos.copy'),
        type: 'success'
      });
    },
    open: function open(project) {
      this.dialogVisible = true;
      this.link = project.viewer_url;
    },
    close: function close() {
      this.dialogVisible = false;
      this.link = null;
    }
  }
};

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

var _info = __webpack_require__(826);

var _info2 = _interopRequireDefault(_info);

var _selector = __webpack_require__(827);

var _selector2 = _interopRequireDefault(_selector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    'info': _info2.default,
    'selector': _selector2.default
  },
  computed: {
    category: function category() {
      var vm = this;
      // find index
      var index = vm.catId ? _lodash2.default.findIndex(vm.categories, {
        id: vm.catId
      }) : -1;
      return index >= 0 ? vm.categories[index] : null;
    },
    catId: function catId() {
      return this.$route.params.id ? Number(this.$route.params.id) : null;
    },
    categories: function categories() {
      return this.$store.state.category.items;
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('category/index');
  }
}; //
//
//
//
//
//
//

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ['category']
};

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ['category', 'categories']
};

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _category = __webpack_require__(825);

var _category2 = _interopRequireDefault(_category);

var _list = __webpack_require__(829);

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// loading sub-components
exports.default = {
  data: function data() {
    return {
      hasProjects: false
    };
  },

  components: {
    'category': _category2.default,
    'projects-list': _list2.default
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.$refs['projects-list'].refreshData();
    next(true);
  }
};

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

var _vueInfiniteLoading = __webpack_require__(820);

var _vueInfiniteLoading2 = _interopRequireDefault(_vueInfiniteLoading);

var _dialog = __webpack_require__(61);

var _item = __webpack_require__(830);

var _item2 = _interopRequireDefault(_item);

var _welcome = __webpack_require__(832);

var _welcome2 = _interopRequireDefault(_welcome);

var _quotas_required = __webpack_require__(831);

var _quotas_required2 = _interopRequireDefault(_quotas_required);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var statesChecker = null;

exports.default = {
  data: function data() {
    return {
      projects: null, // 'null' is different to [], since 'null' stands for 'not initial'
      currentPage: 0,
      totalPages: 1,
      quotasDialog: (0, _dialog.createDialog)(_quotas_required2.default)
    };
  },

  watch: {
    projects: function projects(newValues) {
      this.$emit('has-projects', newValues && newValues.length && newValues.length > 0);
    }
  },
  components: {
    'infinite-loading': _vueInfiniteLoading2.default,
    'project-card': _item2.default,
    'welcome': _welcome2.default
  },
  computed: {
    catId: function catId() {
      return this.$route.params.id ? Number(this.$route.params.id) : null;
    },
    showCreateProject: function showCreateProject() {
      return this.projects && this.projects.length > 0 && (!this.organization || this.canDo('create_project'));
    },
    permanentsLeft: function permanentsLeft() {
      return this.$store.state.quota.summary.permanents_left;
    },
    permanents: function permanents() {
      return this.$store.state.quota.summary.permanents;
    }
  },
  methods: {
    update: function update(data, index) {
      if (!data) {
        this.projects.splice(index, 1);
        this.currentPage -= 1;

        if (this.projects.length <= 0) {
          this.refreshData();
        }
      } else {
        this.projects.splice(index, 1, data);
      }
    },
    createProject: function createProject() {
      var vm = this;

      var toCreate = function toCreate() {
        vm.$router.push({
          path: '/projects/new',
          query: { catId: vm.$route.params.id }
        });
      };

      vm.$store.dispatch('refresh').then(function (_) {
        // 企业用户，额度为0，都提示
        // 个人用户，额度为0，但是是首次，不提示
        if (vm.permanentsLeft === 0 && (vm.organization || vm.permanents !== 0)) {
          vm.quotasDialog({
            cancel: toCreate
          });
        } else {
          toCreate();
        }
      });
    },
    onInfinite: function onInfinite() {
      var vm = this;
      vm.$store.dispatch('project/index', {
        category_id: vm.catId,
        page: vm.currentPage + 1
      }).then(function (res) {
        // get rid of duplicate projects
        vm.projects = _lodash2.default.unionBy(vm.projects || [], res.data.list, 'id');
        vm.currentPage = res.data.current_page;
        vm.totalPages = res.data.total_pages;

        window.setTimeout(function () {
          if (res.data.current_page > res.data.total_pages || res.data.list.length === 0) {
            vm.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
          } else {
            vm.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');
          }
        });
      });
    },
    refreshData: function refreshData() {
      var vm = this;
      vm.projects = null;
      vm.currentPage = 0;
      vm.totalPages = 1;
      vm.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
    }
  },
  mounted: function mounted() {
    var vm = this;
    var checker = function checker() {
      // 检查所有状态为不是complete和halt的项目
      var ids = [];
      var idsStates = {};
      vm.projects.forEach(function (p) {
        if (['completed', 'halted'].indexOf(p.state) < 0) {
          ids.push(p.id);
          idsStates[p.id] = p.state;
        }
      });

      if (ids.length > 0) {
        // check ids
        vm.$store.dispatch('project/states', {
          ids: ids.join(',')
        }).then(function (res) {
          for (var id in res.data) {
            if (res.data[id] !== idsStates[id]) {
              var _ret = function () {
                // need update ui for this project
                console.log('need update', id);
                var oldIndex = _lodash2.default.findIndex(vm.projects, {
                  id: Number(id)
                });

                if (oldIndex < 0) return 'break';

                vm.$set(vm.projects[oldIndex], 'state', res.data[id]);

                if (res.data[id] === 'complete') {
                  // need update project info
                  vm.$store.dispatch('project/get', {
                    id: Number(id),
                    force: true
                  }).then(function (res) {
                    vm.projects.splice(oldIndex, 1, res.data);
                  });
                }
              }();

              if (_ret === 'break') break;
            }
          }
          statesChecker = window.setTimeout(checker, 10000);
        }).catch(function (error) {
          error.mute = true;
        });
      }
    };
    statesChecker = window.setTimeout(checker, 10000);
  },
  beforeDestroy: function beforeDestroy() {
    if (statesChecker) {
      window.clearTimeout(statesChecker);
      statesChecker = null;
    }
  }
};

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _regexes = __webpack_require__(80);

var _regexes2 = _interopRequireDefault(_regexes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      qrcode: false,
      hover: false
    };
  },

  props: ['project'],
  computed: {
    state: function state() {
      if (this.project.state !== 'completed') {
        return this.project.state;
      }

      if (this.project.expired_at_in_ts && this.project.expired_at_in_ts < Date.now() / 1000) {
        return 'expired';
      }

      if (!this.project.permanent) {
        return 'temp';
      }

      return this.project.state;
    },
    available: function available() {
      return this.project.state === 'completed';
    },
    readonly: function readonly() {
      return this.project.permissions.readonly;
    },
    categories: function categories() {
      return this.$store.state.category.items;
    },
    publicity: function publicity() {
      return this.project.tbc ? this.project.tbc.public : null;
    }
  },
  methods: {
    moveTo: function moveTo(command) {
      var vm = this;
      var id = this.project.id;
      var catId = command;
      var _success = function _success(res) {
        vm.$emit('refresh');
      };

      if (catId === 'new') {
        // need open category dialog to create first, then move to
        vm.$editCategory({
          success: function success(catId) {
            vm.$store.dispatch('project/update', {
              id: id,
              category_id: catId
            }).then(_success);
          }
        });
      } else {
        vm.$store.dispatch('project/update', {
          id: id,
          category_id: catId === 'all' ? null : Number(catId)
        }).then(_success);
      }
    },
    togglePublicity: function togglePublicity() {
      var vm = this;
      if (vm.publicity === null) return;

      vm.$store.dispatch('project/update', {
        id: vm.project.id,
        tbc: { public: !vm.publicity }
      }).then(function (res) {
        vm.$message('\u60A8\u7684' + vm.$t('common.project') + '"' + vm.project.name + '"\u5DF2\u8BBE\u7F6E\u6210' + (res.data.tbc.public ? '公开' : '内部') + '\u8BBF\u95EE');
        vm.$emit('update', res.data);
      });
    },
    alterSource: function alterSource() {
      var _this = this;

      var h = this.$createElement;

      var vm = this;
      if (!vm.project.permissions.change_source) {
        var expired = vm.state === 'expired';
        var description = expired ? vm.$t('projectOverdateHint') : vm.$t('projectLockedHint');
        /* beautify preserve:start */
        this.$confirm((h(
          'p',
          null,
          [description, h(
            'a',
            { 'class': 'text-btn', attrs: { href: '/price', target: '_blank' }
            },
            ['\u4E86\u89E3\u8BE6\u60C5']
          )]
        ), description), '无法操作', {
          cancelButtonClass: 'el-button--text',
          confirmButtonText: expired ? vm.$t('upgradeProject') : vm.$t('unlockProject')
        }).then(function () {
          _this.upgrade(expired ? 'upgrade' : 'unlock');
        });
        /* beautify preserve:end */
        return;
      }
      vm.$router.push({
        name: 'project_upload',
        params: {
          id: this.project.id
        }
      });
    },
    upgrade: function upgrade(operator) {
      if (typeof operator !== 'string') {
        operator = undefined;
      }
      var vm = this;
      vm.$upgradeProject({
        projectId: vm.project.id,
        logoEnabled: vm.project.permissions.change_logo,
        operator: operator || 'upgrade',
        success: function success() {
          vm.$parent.refreshData();
        }
      });
    },
    destroy: function destroy() {
      var vm = this;
      var id = vm.project.id;

      var hintMessage = '<p>该操作将使生成的二维码和网址无法再继续访问，是否继续？</p>';

      vm.$confirm(new _vue2.default().$createElement(_vue2.default.compile(hintMessage)), vm.$t('messagebox.project.delete.title', {
        name: vm.project.name
      }), {
        cancelButtonClass: 'el-button--text',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: vm.$t('common.buttons.cancel'),
        confirmButtonText: '删除'
      }).then(function (_) {
        vm.$store.dispatch('project/destroy', id).then(function (_) {
          // 发送消息
          vm.$message({
            message: vm.$t('deleteProjectCompleted'),
            type: 'success'
          });
          vm.$emit('update', null);
        });
      }).catch(function (_) {});
    },
    rename: function rename(project) {
      var vm = this;
      var id = vm.project.id;

      vm.$prompt(' ', vm.$t('messagebox.project.rename.title'), {
        cancelButtonClass: 'el-button--text',
        cancelButtonText: vm.$t('common.buttons.cancel'),
        confirmButtonText: vm.$t('common.buttons.save'),
        inputPattern: _regexes2.default.projectName, // 匹配任何只要包含一个字符的字符串  .不能匹配空格
        inputErrorMessage: vm.$t('messagebox.project.rename.inputError'),
        inputValue: vm.project.name
      }).then(function (res) {
        vm.$store.dispatch('project/update', {
          id: id,
          name: res.value
        }).then(function (res) {
          vm.$emit('update', res.data);
        }).catch(function (err) {
          var data = err.response.data;
          if (data.type === 'RecordInvalidError') {
            // 命名过长
            vm.$message({
              message: data.errors[0].details.map(function (d) {
                return d.message;
              }).join(','),
              type: 'error'
            });
          }
        });
      }).catch(function (_) {});
    },
    setThumbnail: function setThumbnail(project) {
      var vm = this;
      var id = vm.project.id;
      vm.$mediaImage({
        initTag: 'thumbnail',
        success: function success(_ref) {
          var mediaId = _ref.id;

          vm.$store.dispatch('project/update', {
            id: id,
            thumbnail: mediaId
          }).then(function (res) {
            vm.$emit('update', res.data);
          });
        }
      });
    }
  }
};

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bus = __webpack_require__(81);

var _bus2 = _interopRequireDefault(_bus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      dialogVisible: false,
      cancel: null
    };
  },

  computed: {
    overdate: function overdate() {
      return this.$store.getters['quota/overdate'];
    }
  },
  methods: {
    open: function open(params) {
      var vm = this;
      vm.dialogVisible = true;
      if (params.cancel) {
        vm.cancel = params.cancel;
      }

      _bus2.default.$on('GetPermanentsQuota', vm.onGetQuota);
    },
    close: function close() {
      this.dialogVisible = false;
      _bus2.default.$off('GetPermanentsQuota', this.onGetQuota);
    },
    onGetQuota: function onGetQuota(diff) {
      var _diff = diff === null ? '不限次数' : diff + '\u6B21';
      this.$message('\u5DF2\u4E3A\u60A8\u6DFB\u52A0\u6C38\u4E45\u9879\u76EE\u989D\u5EA6\uFF1A' + _diff);
      this.close();
      this.$parent.refreshData();
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  computed: {
    showCreateProject: function showCreateProject() {
      return !this.organization || this.canDo('create_project');
    }
  }
};

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      dialogVisible: false,
      name: null,
      email: null,
      department: null,
      role: null,
      orgId: null,
      memId: null,
      success: null,
      roles: ['owner', 'admin', 'member']
    };
  },

  methods: {
    open: function open(params) {
      // only need name and id
      if (params.member && params.member.user) {
        this.name = params.member.user.nickname;
        this.email = params.member.user.email;
        this.department = params.member.department;
        this.role = params.member.role;
      }
      this.orgId = params.orgId;
      this.memId = params.memId;
      this.success = params.success;
      this.dialogVisible = true;
    },
    close: function close() {
      this.dialogVisible = false;
      this.name = null;
      this.email = null;
      this.department = null;
      this.role = null;
      this.orgId = null;
      this.memId = null;
      this.success = null;
    },
    save: function save() {
      var vm = this;
      vm.$store.dispatch('organization/editMember', {
        orgId: vm.orgId,
        memId: vm.memId,
        department: vm.department,
        role: vm.role
      }).then(function (_) {
        vm.$message('保存成功');
        if (typeof vm.success === 'function') {
          vm.success();
        }
        vm.close();
      });
    }
  }
};

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(39);

var _stringify2 = _interopRequireDefault(_stringify);

var _edit_member = __webpack_require__(833);

var _edit_member2 = _interopRequireDefault(_edit_member);

var _dialog = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// let messageListener = null

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      members: [],
      currentPage: 1,
      totalPages: 1,
      totalItems: 1,
      pageSize: 1,
      loading: false,
      editMemberDialog: (0, _dialog.createDialog)(_edit_member2.default)
    };
  },

  computed: {
    showAddMembers: function showAddMembers() {
      // display show members when
      // 1. the user has authenticated to add members
      // 2. currently only open to TBC
      return this.tbcMode && window.postMessage;
    }
  },
  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.loading = true;
      vm.$store.dispatch('organization/members', {
        orgId: vm.organization.id,
        page: vm.currentPage || 1
      }).then(function (res) {
        // vm.currentPage = res.data.current_page
        vm.members = res.data.list;
        vm.totalPages = res.data.total_pages;
        vm.totalItems = res.data.total_items;
        vm.pageSize = res.data.page_size;
        vm.loading = false;
      });
    },
    removeMember: function removeMember(memId) {
      var vm = this;
      vm.$confirm('确定从组织中移除该成员？', '删除成员？', {
        cancelButtonClass: 'el-button--text',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: vm.$t('common.buttons.cancel'),
        confirmButtonText: vm.$t('common.buttons.ok')
      }).then(function (_) {
        vm.$store.dispatch('organization/removeMember', {
          orgId: vm.organization.id,
          memId: memId
        }).then(function (_) {
          // 重新载入当前页面
          vm.fetch();
        });
      }).catch(function (_) {});
    },
    editMember: function editMember(member) {
      var vm = this;
      vm.editMemberDialog({
        member: JSON.parse((0, _stringify2.default)(member)),
        orgId: vm.organization.id,
        memId: member.id,
        success: function success() {
          vm.fetch();
        }
      });
    }
  },
  mounted: function mounted() {
    this.fetch();
  }
};

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _details = __webpack_require__(834);

var _details2 = _interopRequireDefault(_details);

var _logs = __webpack_require__(836);

var _logs2 = _interopRequireDefault(_logs);

var _permissions = __webpack_require__(837);

var _permissions2 = _interopRequireDefault(_permissions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    'details-card': _details2.default,
    'logs-card': _logs2.default,
    'permissions-card': _permissions2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      logs: [],
      currentPage: 1,
      totalPages: 1,
      pageSize: 1,
      totalItems: 1,
      loading: false
    };
  },

  methods: {
    fetch: function fetch() {
      var vm = this;
      vm.loading = true;
      vm.$store.dispatch('organization/logs', {
        orgId: vm.organization.id,
        page: vm.currentPage || 1
      }).then(function (res) {
        vm.logs = res.data.list;
        vm.totalPages = res.data.total_pages;
        vm.pageSize = res.data.page_size;
        vm.totalItems = res.data.total_items;
        vm.loading = false;
      });
    }
  },
  mounted: function mounted() {
    this.fetch();
  }
};

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      members: [],
      currentPage: 1,
      totalPages: 1,
      pageSize: 1,
      totalItems: 1,
      loading: false
    };
  },

  methods: {
    setPermissions: function setPermissions(memId, permissions) {
      var vm = this;
      var index = _lodash2.default.findIndex(vm.members, {
        id: memId
      });
      var oldPermissions = vm.members[index].permissions;
      var newPermissions = permissions.join(',');
      vm.$set(vm.members[index], 'permissions', newPermissions);

      // async
      vm.$store.dispatch('organization/editMember', {
        orgId: vm.organization.id,
        memId: memId,
        permissions: newPermissions
      }).then(function (_) {}).catch(function (_) {
        // might cannot be modified due to accessibility
        vm.$set(vm.members[index], 'permissions', oldPermissions);
      });
    },
    fetch: function fetch() {
      var vm = this;
      vm.loading = true;
      vm.$store.dispatch('organization/members', {
        orgId: vm.organization.id,
        page: vm.currentPage || 1
      }).then(function (res) {
        vm.members = res.data.list;
        vm.totalPages = res.data.total_pages;
        vm.pageSize = res.data.page_size;
        vm.totalItems = res.data.total_items;
        vm.loading = false;
      });
    }
  },
  mounted: function mounted() {
    this.fetch();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validator = __webpack_require__(31);

var _validator2 = _interopRequireDefault(_validator);

var _packages = __webpack_require__(157);

var _packages2 = _interopRequireDefault(_packages);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var i18n = {
  messages: {
    'zh-cn': {}
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      promoteCode: null,
      promoteDescription: null,
      originalPrice: null,
      actualPrice: null,
      discount: null,
      payType: 'wechat',
      priceChecking: false
    };
  },

  mixins: [_validator2.default],
  computed: {
    product: function product() {
      var _index = _lodash2.default.findIndex(_packages2.default, { type: this.$route.query.type });

      return _index ? _packages2.default[_index] : null;
    }
  },
  methods: {
    placeOrder: function placeOrder() {
      var vm = this;

      if (vm.errors.count() > 0) {
        return;
      }

      vm.$order({
        package: vm.product.package,
        promote_code: vm.promoteCode,
        payment_method: vm.payType,
        success: function success() {
          vm.$router.push('/profile');
        },
        error: function error(_error) {
          if (_error.type === 'InvalidPromoteCodeError') {
            vm.errors.add('promoteCode', _error.message);
          }
        }
      });
    },
    checkPrice: function checkPrice() {
      var vm = this;
      vm.priceChecking = true;
      vm.errors.remove('promoteCode');
      vm.$store.dispatch('quota/price', {
        package: vm.product.package,
        promote_code: vm.promoteCode
      }).then(function (res) {
        vm.priceChecking = false;
        var data = res.data;
        vm.discount = data.discount_total;
        vm.originalPrice = data.item_total;
        vm.actualPrice = data.total;
        vm.promoteCode = data.promote_code;

        if (data.valid_promote) {
          vm.promoteDescription = data.message;
          vm.errors.remove('promoteCode');
        } else {
          vm.errors.add('promoteCode', data.message);
          vm.promoteDescription = null;
        }
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.checkPrice();
    });
  },

  i18n: i18n
};

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _packages = __webpack_require__(157);

var _packages2 = _interopRequireDefault(_packages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// i18n setting locale i18n
var i18n = {
  messages: {
    'zh-cn': {
      reportType: {
        base: '基础',
        advanced: '高级'
      },
      tooltips: {
        permanent: '超出套餐包含的永久项目，按照 49 元/个收费',
        export: '超出套餐包含的导出功能，按照 120 元/次收费',
        logo: '超出套餐包含的自定义 Logo 功能，按照 99 元/次收费',
        subAccount: '企业拥有的最大子账号数量',
        cdn: '由PP匠提供的网页流量，超出部分按照 1 元/GB 收费',
        log: '可通过专用接口获得项目的访问日志',
        report: 'PP匠提供网页大数据分析'
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var addClass = function addClass(elem, className) {
  if (elem.classList) {
    elem.classList.add(className);
  } else {
    if (elem.className.indexOf(className) === -1) {
      elem.className = elem.className + ' ' + className + ' ';
    }
  }
};

var hasClass = function hasClass(elem, className) {
  if (elem.classList) {
    return elem.classList.contains(className);
  } else {
    return elem.className.indexOf(className) > -1;
  }
};

var removeClass = function removeClass(elem, className) {
  if (elem.classList) {
    elem.classList.remove(className);
  } else {
    if (hasClass(elem, className)) {
      elem.className = elem.className.replace(new RegExp('(\\s|^)' + className + '(\\s|$)'), ' ').replace(/^\s+|\s+$/g, '');
    }
  }
};

var mouseenter = function mouseenter(e) {
  var elem = e.target;
  if (!hasClass(elem, 'em')) return;

  var type = e.target.dataset && e.target.dataset.type || e.target.getAttribute('data-type');
  if (!type) return;

  var elements = document.querySelectorAll("span.em[data-type='" + type + "']");
  for (var i = 0; i < elements.length; i++) {
    addClass(elements[i], 'hover');
  }
};

var mouseleave = function mouseleave(e) {
  var elem = e.target;
  if (!hasClass(elem, 'em')) return;

  var type = e.target.dataset && e.target.dataset.type || e.target.getAttribute('data-type');
  if (!type) return;

  var elements = document.querySelectorAll("span.em[data-type='" + type + "']");
  for (var i = 0; i < elements.length; i++) {
    removeClass(elements[i], 'hover');
  }
};

exports.default = {
  data: function data() {
    return {
      products: _packages2.default.filter(function (i) {
        return i.show !== false;
      }),
      hover: null
    };
  },

  computed: {
    session: function session() {
      return this.$store.getters['user/session'];
    },
    curPackage: function curPackage() {
      var vm = this;
      var list = vm.$store.state.quota.list;
      if (!vm.session || list.length <= 0) {
        return null;
      }

      list.forEach(function (item) {
        if (['yearly_basic', 'yearly_pro', 'yearly_enterprise'].indexOf(item['package']) >= 0) {
          return item['package'];
        }
      });

      return null;
    }
  },
  methods: {
    purchase: function purchase(_type) {
      var vm = this;

      if (!vm.session) {
        vm.$alert('请先登录后购买').then(function (_) {
          vm.$router.push({
            path: '/login',
            query: {
              returnTo: '/price'
            }
          });
        });
        return;
      }

      if (vm.curPackage) {
        vm.$alert('您已经购买了某一款套餐，暂时不支持升降级。如需转化套餐模式请联系我们');
        return;
      }

      vm.$router.push({
        name: 'order',
        query: {
          type: _type
        }
      });
    }
  },
  i18n: i18n,
  mounted: function mounted() {
    this.$el.addEventListener('mouseenter', mouseenter, true);
    this.$el.addEventListener('mouseleave', mouseleave, true);
  },
  beforeDestroy: function beforeDestroy() {
    this.$el.removeEventListener('mouseenter', mouseenter, true);
    this.$el.removeEventListener('mouseleave', mouseleave, true);
  }
};

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      cellphone: null,
      captcha: null,
      dialogVisible: false
    };
  },

  methods: {
    open: function open() {
      this.cellphone = this.$store.state.user.info.cellphone;
      this.dialogVisible = true;
    },
    close: function close() {
      this.cellphone = null;
      this.captcha = null;
      this.dialogVisible = false;
    },
    save: function save() {
      var vm = this;
      var cellphoneInput = vm.$refs['cellphoneInput'];
      // do save for cellphone-input
      cellphoneInput.save().then(function (_) {
        // when save passed validation
        vm.$store.dispatch('user/update', {
          cellphone: vm.cellphone,
          captcha: vm.captcha
        }).then(function (_) {
          vm.close();
        }).catch(function (err) {
          var data = err.response.data;
          if (data.type === 'RecordInvalidError') {
            // 手机已被占用
            data.errors.forEach(function (err) {
              var field = err.field;
              var message = err.details.map(function (d) {
                return d.message;
              }).join(',');
              cellphoneInput.addErrors(field, message);
            });
          } else if (data.type === 'CaptchaIncorrectError') {
            cellphoneInput.addErrors('captcha', data.message);
          }
        });
      }).catch(function (_) {});
    }
  }
};

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validator = __webpack_require__(31);

var _validator2 = _interopRequireDefault(_validator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      form: {
        oldPassword: null,
        newPassword: null,
        passwordConfirmation: null
      },
      dialogVisible: false
    };
  },

  mixins: [_validator2.default],
  rules: {
    confirmed: { target: 'passwordConfirmation', original: 'newPassword', recursion: 'form' },
    required: ['oldPassword', 'newPassword']
  },
  methods: {
    open: function open() {
      this.dialogVisible = true;
    },
    close: function close() {
      this.$refs['form'].resetFields();
      this.dialogVisible = false;
    },
    save: function save() {
      var vm = this;
      vm.$refs['form'].validate(function (res) {
        if (res) {
          // 验证通过
          vm.$store.dispatch('user/changePassword', {
            current_password: vm.form.oldPassword,
            password: vm.form.newPassword
          }).then(function (_) {
            vm.$message({
              message: '修改密码成功',
              type: 'success'
            });
            vm.close();
          }).catch(function (err) {
            var data = err.response.data;
            if (data.type === 'PasswordIncorrectError') {
              vm.errors.add('oldPassword', data.message);
            }
          });
        }
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(492);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(330);

var _dialog = __webpack_require__(61);

var _wx_connection = __webpack_require__(843);

var _wx_connection2 = _interopRequireDefault(_wx_connection);

var _cellphone = __webpack_require__(840);

var _cellphone2 = _interopRequireDefault(_cellphone);

var _change_password = __webpack_require__(841);

var _change_password2 = _interopRequireDefault(_change_password);

var _ss_uploader = __webpack_require__(79);

var _ss_uploader2 = _interopRequireDefault(_ss_uploader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      // uploader parameters
      avatarUploadUrl: "/api/" + 'profile',
      extensions: ['png', 'gif', 'jpeg', 'jpg'],
      accept: '.png, .gif, .jpeg, .jpg, image/*',
      avatarOnUploading: false,
      wxConnectionDialog: (0, _dialog.createDialog)(_wx_connection2.default),
      cellphoneDialog: (0, _dialog.createDialog)(_cellphone2.default),
      changePasswordDialog: (0, _dialog.createDialog)(_change_password2.default)
    };
  },

  components: {
    // 'cellphone-dialog': CellphoneDialog,
    // 'change-password-dialog': ChangePasswordDialog,
    // 'wx-connection-dialog': WxConnectionDialog,
    'ssuploader': _ss_uploader2.default
  },
  computed: (0, _extends3.default)({
    name: {
      get: function get() {
        return this.user.nickname;
      },
      set: function set(value) {
        this.$store.dispatch('user/update', {
          nickname: value
        });
      }
    }
  }, (0, _vuex.mapState)({
    user: function user(state) {
      return state.user.info;
    },
    quotas: function quotas(state) {
      return state.quota.summary;
    }
  })),
  methods: {
    rename: function rename() {
      var vm = this;
      vm.$prompt(' ', '修改昵称', {
        confirmButtonText: '保存',
        cancelButtonClass: 'el-button--text',
        inputPattern: /^\S+$/,
        inputErrorMessage: '昵称不能为空或包含空格',
        inputValue: vm.name
      }).then(function (res) {
        vm.name = res.value;
      }).catch(function (_) {});
    },
    avatarUploadComplete: function avatarUploadComplete() {
      this.$store.dispatch('refresh');
    },
    wxDisconnected: function wxDisconnected() {
      var vm = this;

      vm.$confirm(vm.$t('disconnectWXhint'), '解除微信绑定', {
        confirmButtonText: '确定',
        confirmButtonClass: 'el-button--danger',
        cancelButtonClass: 'el-button--text'
      }).then(function (_) {
        vm.$store.dispatch('user/wxDisconnect').then(function (_) {
          vm.$message('解绑成功');
        });
      }).catch(function (_) {});
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      // if there is a query parameter called 'verify', prompt related dialog
      vm.$store.dispatch('refresh');

      if (to.query.verify === 'mobile') {
        vm.$refs['cellphone-dialog'].open();
      }
    });
  }
};

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      dialogVisible: false
    };
  },

  computed: {
    wxConnection: function wxConnection() {
      return this.$store.state.user.wxConnection;
    }
  },
  methods: {
    open: function open() {
      this.dialogVisible = true;
      this.$store.dispatch('user/wxConnection');
    },
    close: function close() {
      this.dialogVisible = false;
    }
  }
};

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      dialogVisable: false,
      application: {
        name: null,
        phone: null,
        company: null,
        scenario: null,
        estimate_ppts: null
      }
    };
  },

  methods: {
    open: function open() {
      this.dialogVisable = true;
    },
    close: function close() {
      this.dialogVisable = false;
    },
    sendApplication: function sendApplication() {
      var vm = this;
      vm.$store.dispatch('apis/sendApplication', vm.application).then(function (res) {
        vm.$contactMarket();
        vm.close();
      });
    }
  }
};

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(39);

var _stringify2 = _interopRequireDefault(_stringify);

var _dialog = __webpack_require__(61);

var _validator = __webpack_require__(31);

var _validator2 = _interopRequireDefault(_validator);

var _application = __webpack_require__(844);

var _application2 = _interopRequireDefault(_application);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      applyDialog: (0, _dialog.createDialog)(_application2.default),
      form: {
        api_endpoint: null,
        access_key: null,
        secret_key: null,
        notify_url: null,
        sandbox: null,
        quotas: null,
        quotas_left: null,
        ip_whitelist: null,
        page_ctrl_api_entitled: false,
        injected_code: null
      }
    };
  },

  mixins: [_validator2.default],
  computed: {
    apiEnabled: function apiEnabled() {
      return this.$store.state.user.info.api_entitled || this.$store.getters['user/organization'] && this.$store.getters['user/organization'].api_entitled;
    }
  },
  methods: {
    apiApplication: function apiApplication() {
      this.applyDialog();
    },
    save: function save(paramsSelector) {
      var vm = this;

      var _params = {};
      if (paramsSelector === 'request') {
        _params = {
          notify_url: vm.form.notify_url,
          ip_whitelist: vm.form.ip_whitelist
        };
      } else if (paramsSelector === 'generate') {
        _params = {
          injected_code: vm.form.injected_code
        };
      }

      vm.$store.dispatch('apis/updateApis', _params).then(function (res) {
        vm.form = JSON.parse((0, _stringify2.default)(res.data));
      }).catch(function (err) {
        var data = err.response.data;

        if (data.type === 'RecordInvalidError') {
          data.errors.forEach(function (e) {
            vm.errors.add(e.field, e.details[0].message);
          });
        }
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.$store.dispatch('apis/apiInfo').then(function (res) {
        vm.form = JSON.parse((0, _stringify2.default)(res.data));
      });
    });
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      formData: [],
      withdrawData: []
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.$store.dispatch('income/index').then(function (res) {
        vm.formData = res.data.list;
      });

      vm.$store.dispatch('withdraw/index').then(function (res) {
        vm.withdrawData = res.data.list;
      });
    });
  }
};

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  computed: {
    apiEnabled: function apiEnabled() {
      return this.$store.state.user.info.api_entitled || this.$store.getters['user/organization'] && this.$store.getters['user/organization'].api_entitled;
    }
  }
};

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _steps = __webpack_require__(865);

var _steps2 = _interopRequireDefault(_steps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      showSteps: false,
      loaded: false,
      upperPath: null
    };
  },

  computed: {
    project: function project() {
      var id = this.$route.params.id;
      return id ? this.$store.state.project.items[id] : null;
    },
    step: function step() {
      var vm = this;

      if (vm.$route.name === 'project_upload') {
        return 'upload';
      }

      if (vm.project) {
        switch (vm.project.state) {
          case 'uploading':
          case 'converting':
          case 'rendering':
          case 'disting':
          case 'finishing':
          case 'redisting':
            return 'convert';
          case 'halted':
            return 'error';
          case 'completed':
            return 'complete';
        }
      }
      return 'loading';
    }
  },
  components: {
    'steps': _steps2.default
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 来自index page的需要重载， location.href 以避免内存堆积
    if (from.name === 'category') {
      location.href = to.fullPath;
      return;
    }
    next(function (vm) {
      // vm.upperPath = from.fullPath
      if (to.query.catId) {
        vm.upperPath = '/categories/' + to.query.catId;
      }

      // 如果来于 project_upload, 则需要显示步骤条
      if (to.name === 'project_upload' || from.name === 'project_upload') {
        vm.showSteps = true;
        vm.loaded = true;
      }

      if (to.params.id) {
        vm.$store.dispatch('project/get', {
          id: to.params.id,
          force: true
        }).then(function (res) {
          vm.loaded = true;
        });
      }
    });
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  computed: {
    project: function project() {
      return this.$store.state.project.items[this.$route.params.id];
    },
    wxConnection: function wxConnection() {
      return this.$store.state.user.wxConnection;
    },
    estimatedTime: function estimatedTime() {
      return this.$store.state.project.checks[this.project.id] || { lowerEt: 1, upperEt: 3 };
    }
  }
};

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  computed: {
    project: function project() {
      return this.$store.state.project.items[this.$route.params.id];
    }
  }
};

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _convert = __webpack_require__(849);

var _convert2 = _interopRequireDefault(_convert);

var _setting = __webpack_require__(859);

var _setting2 = _interopRequireDefault(_setting);

var _error = __webpack_require__(850);

var _error2 = _interopRequireDefault(_error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    'convert-step': _convert2.default,
    'setting-step': _setting2.default,
    'error-step': _error2.default
  },
  computed: {
    project: function project() {
      return this.$store.state.project.items[this.$route.params.id];
    },
    step: function step() {
      if (!this.project) {
        return 'loading';
      }

      switch (this.project.state) {
        case 'uploading':
        case 'converting':
        case 'rendering':
        case 'disting':
        case 'finishing':
        case 'redisting':
          return 'convert';
        case 'halted':
          return 'error';
        case 'completed':
          return 'complete';
        default:
          return 'loading';
      }
    }
  },
  methods: {
    checkState: function checkState() {
      var vm = this;
      vm.$store.dispatch('project/checkState', vm.project.id);
    }
  },
  watch: {
    step: function step(newValue) {
      if (newValue === 'convert') {
        this.checkState();
      }
    }
  },
  mounted: function mounted() {
    if (this.step === 'convert') {
      this.checkState();
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      // check wx connection
      vm.$store.dispatch('user/wxConnection');
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('project/cancelCheckState', this.project.id).then(function (_) {
      next(true);
    });
  }
}; //
//
//
//
//
//
//
//

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(44);

var _assign2 = _interopRequireDefault(_assign);

var _lazyLoadModule = __webpack_require__(48);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      type: null,
      config: {},
      price: 0.0
    };
  },

  components: {
    'vue-numeric': function vueNumeric() {
      return (0, _lazyLoadModule.lazyload)('vue-numeric');
    }
  },
  props: ['value', 'project'],
  computed: {
    disabled: function disabled() {
      var state = this.project.permanent ? 0 : this.project.expired_at_in_ts && this.project.expired_at_in_ts < Date.now() / 1000 ? 2 : 1;

      return {
        'none': state === 2,
        'code': state === 2,
        'pay': !this.project.permissions.set_special_auth_type,
        'spell': !this.project.permissions.set_special_auth_type,
        'msg': state === 0 ? '' : this.$t(state === 1 ? 'accessDisableReasonTemp' : 'accessDisableReasonOverdate')
      };
    }
  },
  watch: {
    value: function value(newValue) {
      var vm = this;
      vm.type = newValue.type;
      vm.config = (0, _assign2.default)({}, vm.config, newValue.config);
      vm.price = newValue.price || 0;
    }
  },
  methods: {
    wechatTips: function wechatTips() {
      var vm = this;
      var h = vm.$createElement;

      vm.$msgbox({
        message: h('img', {
          style: 'width: 80%;margin-left: 10%;',
          attrs: {
            src: '/static/images/setting-wechat-hint.png'
          }
        }),
        confirmButtonText: vm.$t('common.buttons.close')
      });
    },
    dataInit: function dataInit() {
      this.type = null;
      this.config = {
        code: null,
        hint: null,
        wechat: null,
        wechat_spell: null,
        preview_pages: 0
      };
      this.price = 0.0;
    },
    randomCode: function randomCode(position) {
      if (this.disabled[position]) {
        return;
      }

      var possible = '0123456789';
      var value = '';

      for (var i = 0; i < 8; i++) {
        value += possible.charAt(Math.floor(Math.random() * possible.length));
      }

      this.config.code = value;
    },

    save: function save(e) {
      // do validation
      this.$emit('input', {
        type: this.type,
        config: this.config,
        price: this.price
      });
    }
  },
  mounted: function mounted() {
    this.dataInit();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import MediaAudioDialog from '@/components/media/audio.dialog'
exports.default = {
  data: function data() {
    return {
      mediaId: null,
      name: null,
      url: null,
      player: null,
      volume: 100,
      paused: true
    };
  },

  // components: {
  //   'media-audio-dialog': MediaAudioDialog
  // },
  props: ['value'],
  watch: {
    value: function value(newValue) {
      this.setData(newValue);
    },
    volume: function volume(newValue) {
      var vm = this;
      if (vm.player) {
        vm.player.volume = newValue * 1.0 / 100;
      }
    }
  },
  methods: {
    editBgm: function editBgm() {
      var vm = this;
      //   vm.$refs['media-audio-dialog'].open()
      vm.$mediaAudio({
        success: vm.setData
      });
    },
    setData: function setData() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!value) return;
      var vm = this;

      vm.url = value.file_url || value.url || null;
      vm.name = value.name || null;
      vm.mediaId = value.id || value.url || null;
      vm.volume = value.volume === undefined || value.volume === null ? 100 : Math.floor(value.volume * 100);

      if (vm.player) {
        vm.player.pause();
        vm.paused = true;
      }

      if (vm.url) {
        if (!vm.player) {
          try {
            vm.player = new Audio();
            vm.player.volume = vm.volume * 1.0 / 100;
          } catch (e) {
            console.log(e);
          }
        }
        vm.player.src = vm.url;
        vm.paused = true;
      }
    },
    save: function save() {
      this.$emit('input', {
        mediaId: this.mediaId,
        name: this.name,
        url: this.url,
        volume: this.volume * 1.0 / 100
      });
    }
  }
};

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(39);

var _stringify2 = _interopRequireDefault(_stringify);

var _logo = __webpack_require__(855);

var _logo2 = _interopRequireDefault(_logo);

var _access = __webpack_require__(852);

var _access2 = _interopRequireDefault(_access);

var _bgm = __webpack_require__(853);

var _bgm2 = _interopRequireDefault(_bgm);

var _permanent = __webpack_require__(857);

var _permanent2 = _interopRequireDefault(_permanent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var timeoutHandler = null;

exports.default = {
  data: function data() {
    return {
      form: {
        tbc: {}
      },
      perm: null
    };
  },

  components: {
    'logo-setting': _logo2.default,
    'access-setting': _access2.default,
    'bgm-setting': _bgm2.default,
    'permanent-setting': _permanent2.default
  },
  computed: {
    project: function project() {
      return this.$store.state.project.items[this.$route.params.id];
    },
    readonly: function readonly() {
      return this.project.permissions.readonly;
    },
    expired: function expired() {
      return this.project.expired_at_in_ts && this.project.expired_at_in_ts < Date.now() / 1000;
    },
    locked: function locked() {
      return this.project.locked;
    },
    permanent: function permanent() {
      return this.project.permanent;
    },

    arrowMode: {
      get: function get() {
        return this.form.arrow_mode === 'show';
      },
      set: function set(value) {
        this.form.arrow_mode = value ? 'show' : 'hidden';
      }
    },
    accessSetting: {
      get: function get() {
        return {
          type: this.form.auth_type,
          config: this.form.auth_config,
          price: this.form.pay_to_read_price
        };
      },
      set: function set(value) {
        this.form.auth_type = value.type;
        this.form.auth_config = value.config;
        this.form.pay_to_read_price = value.price;
      }
    },
    logoSetting: {
      get: function get() {
        return this.form._logo || {
          type: this.form.logo,
          logo: this.form.logo_url
        };
      },
      set: function set(value) {
        // value is object
        this.$set(this.form, '_logo', value);

        // set this.form.logo
        if (value.type === 'default') {
          this.form.logo = 'default';
        } else if (value.type === 'hide') {
          this.form.logo = null;
        } else {
          this.form.logo = value.logo;
        }
      }
    },
    bgmSetting: {
      get: function get() {
        return {
          name: this.form.bgm_name,
          url: this.form.bgm_url,
          volume: this.form.bgm_volume
        };
      },
      set: function set(value) {
        // value: {mediaId: 1, name: bgm_name}
        this.$set(this.form, 'bgm', value.mediaId);
        this.$set(this.form, 'bgm_name', value.name);
        this.$set(this.form, 'bgm_url', value.url);
        this.$set(this.form, 'bgm_volume', value.volume);
      }
    },
    cover: {
      get: function get() {
        return this.form.cover || this.form.cover_url;
      },
      set: function set(value) {
        this.$set(this.form, 'cover', value);
      }
    }
  },
  watch: {
    project: function project(value) {
      this.setData(value);
    }
  },
  mounted: function mounted() {
    var vm = this;
    vm.$nextTick(function () {
      if (vm.project) {
        vm.setData(vm.project);
      }
    });
  },

  methods: {
    setData: function setData(value) {
      this.form = JSON.parse((0, _stringify2.default)(value));
    },
    save: function save() {
      var vm = this;
      if (vm.readonly) {
        vm.$alert(vm.$t('lockedProjectHint'), '注意');
        return;
      }
      // force children component to hand in current data
      vm.$refs['access-setting'] && vm.$refs['access-setting'].save();
      vm.$refs['logo-setting'] && vm.$refs['logo-setting'].save();
      vm.$refs['bgm-setting'] && vm.$refs['bgm-setting'].save();

      var _save = function _save() {
        var ret = vm.$store.dispatch('project/update', vm.form).then(function (res) {
          if (vm.tbcMode) {
            window.parent.postMessage({ 'status': 'save-success' }, '*');
            return;
          }
          vm.$message({
            message: '保存成功',
            type: 'success'
          });
        });
        if (vm.tbcMode) {
          var message = '服务器暂时异常，请重试操作或刷新页面';
          ret.catch(function (error) {
            if (error.response && error.response.status >= 400 && error.response.status !== 401) {
              message = error.response.data.message;
              window.parent.postMessage({ 'status': 'save-fail', 'err-msg': message }, '*');
            }
          });
        }
      };

      // if need to unlock permanent
      if (vm.$refs['permanent-setting']) {
        vm.$refs['permanent-setting'].save().then(_save).catch(function (err) {
          // handle error
          console.log(err);
        });
      } else {
        _save();
      }
    },
    reset: function reset() {
      this.setData(this.project);
    }
  },
  beforeRouteLeave: function beforeRouteLeave() {
    if (timeoutHandler) {
      clearTimeout(timeoutHandler);
      timeoutHandler = null;
    }
  }
};

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(11);

var _vue2 = _interopRequireDefault(_vue);

var _order = __webpack_require__(856);

var _order2 = _interopRequireDefault(_order);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

_vue2.default.component('order-logo-dialog', _order2.default);

exports.default = {
  data: function data() {
    return {
      type: null,
      logo: null
    };
  },

  props: ['value', 'editable'],
  computed: {
    project: function project() {
      return this.$store.state.project.items[this.$route.params.id];
    }
  },
  watch: {
    value: function value(newValue) {
      this.setData(newValue);
    }
  },
  methods: {
    setData: function setData(value) {
      var vm = this;
      switch (value.type) {
        case 'default':
          vm.type = 'default';
          break;
        case null:
        case 'hide':
          vm.type = 'hide';
          break;
        default:
          vm.type = 'custom';
      }
      vm.logo = value.logo;
    },
    save: function save() {
      this.$emit('input', {
        type: this.type,
        logo: this.logo
      });
    },
    openOrder: function openOrder() {
      this.$refs['order-logo-dialog'].open({
        name: this.project.name,
        id: this.project.id
      });
    }
  }
};

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      payType: 'wechat',
      name: null,
      id: null,
      dialogVisible: false
    };
  },

  computed: {
    logosLeft: function logosLeft() {
      return this.$store.state.quota.summary.logos_left;
    }
  },
  methods: {
    placeOrder: function placeOrder() {
      var vm = this;

      var success = function success() {
        vm.$store.dispatch('project/get', {
          id: vm.id,
          force: true
        }).then(function (_) {
          vm.close();
        });
        vm.$message('该项目已可以修改 logo');
      };

      if (vm.logosLeft !== 0) {
        vm.$store.dispatch('quota/consume', {
          key: 'logo',
          project_id: vm.id
        }).then(success);
      } else {
        vm.$order({
          package: 'one_time_logo',
          project_id: vm.id,
          payment_method: vm.payType,
          success: success
        });
      }
    },
    open: function open(params) {
      var vm = this;
      vm.$store.dispatch('refresh').then(function (_) {
        vm.name = params.name;
        vm.id = params.id;
        vm.dialogVisible = true;
      });
    },
    close: function close() {
      this.name = null;
      this.id = null;
      this.dialogVisible = false;
    }
  }
};

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(12);

var _promise2 = _interopRequireDefault(_promise);

var _quotas_required = __webpack_require__(858);

var _quotas_required2 = _interopRequireDefault(_quotas_required);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      permanent: null
    };
  },

  components: {
    'quotas-required-dialog': _quotas_required2.default
  },
  computed: {
    project: function project() {
      return this.$store.state.project.items[this.$route.params.id];
    }
  },
  methods: {
    change: function change(value) {
      var vm = this;
      if (value === 'permanent' && !vm.project.permanent) {
        // check quotas first
        vm.$store.dispatch('quota/index', { force: true }).then(function (res) {
          if (res.summary.permanents_left === 0) {
            // no data
            vm.$refs['quotas-required-dialog'].open();
          }
        });
      }
    },
    close: function close() {
      var vm = this;
      // recheck quota again, and alter to temp if there is no quota getted
      vm.$store.dispatch('quota/index').then(function (res) {
        if (res.summary.permanents_left === 0) {
          vm.permanent = 'temp';
        }
      });
    },
    save: function save() {
      // handle on parent save
      var vm = this;
      return vm.permanent === 'temp' || vm.project.permanent ? _promise2.default.resolve() : new _promise2.default(function (resolve, reject) {
        // vm.permanent = permanent, and vm.project.permanent = false, try to unlock project
        vm.$store.dispatch('quota/consume', {
          key: 'permanent',
          project_id: vm.project.id
        }).then(resolve).catch(reject);
      });
    }
  },
  mounted: function mounted() {
    this.permanent = this.project.permanent ? 'permanent' : 'temp';
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bus = __webpack_require__(81);

var _bus2 = _interopRequireDefault(_bus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      dialogVisible: false
    };
  },

  computed: {
    project: function project() {
      return this.$store.state.project.items[this.$route.params.id];
    },
    overdate: function overdate() {
      return this.$store.getters['quota/overdate'];
    }
  },
  methods: {
    open: function open() {
      var vm = this;
      vm.dialogVisible = true;

      _bus2.default.$on('GetPermanentsQuota', vm.onGetQuota);
    },
    close: function close() {
      this.dialogVisible = false;
      _bus2.default.$off('GetPermanentsQuota', this.onGetQuota);
      this.$emit('close');
    },
    onGetQuota: function onGetQuota(diff) {
      var _diff = diff === null ? '不限次数' : diff + '\u6B21';
      this.$message('\u5DF2\u4E3A\u60A8\u6DFB\u52A0\u6C38\u4E45\u9879\u76EE\u989D\u5EA6\uFF1A' + _diff);
      this.close();
    },
    purchase: function purchase() {
      var vm = this;
      vm.$upgradeProject({
        projectId: vm.project.id,
        logoEnabled: vm.project.permissions.change_logo,
        success: function success() {
          alert('购买成功！');
          window.location.reload();
        }
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _form = __webpack_require__(854);

var _form2 = _interopRequireDefault(_form);

var _infos = __webpack_require__(861);

var _infos2 = _interopRequireDefault(_infos);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//

exports.default = {
  components: {
    'setting-form': _form2.default,
    'setting-infos': _infos2.default
  }
};

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      payType: 'wechat',
      orderDialogVisible: false,
      exportDialogVisible: false,
      formatType: 'html5',
      message: null,
      checkID: null,
      state: null,
      archiveUrl: null
    };
  },

  props: ['loading'],
  computed: {
    project: function project() {
      return this.$store.state.project.items[this.$route.params.id];
    },
    exportsLeft: function exportsLeft() {
      return this.$store.state.quota.summary.exports_left;
    }
  },
  methods: {
    initCheck: function initCheck() {
      var vm = this;
      var check = function check() {
        vm.$store.dispatch('project/checkExport', vm.project.id).then(function (res) {
          vm.clearCheck();
          vm.state = res.data.state;
          if (vm.state === 'completed') {
            vm.archiveUrl = res.data.archive_url;
          } else {
            vm.checkID = window.setTimeout(check, 2000);
          }
        });
      };

      check();
    },
    clearCheck: function clearCheck() {
      var vm = this;
      if (vm.checkID) {
        window.clearTimeout(vm.checkID);
      }
      vm.checkID = null;
    },
    placeOrder: function placeOrder() {
      var vm = this;

      var success = function success() {
        vm.createExportRequest();
      };

      if (vm.exportsLeft !== 0) {
        vm.$store.dispatch('quota/consume', {
          key: 'export',
          project_id: vm.project.id
        }).then(success);
      } else {
        vm.$order({
          package: 'one_time_export',
          project_id: vm.project.id,
          payment_method: vm.payType,
          success: success
        });
      }
    },
    createExportRequest: function createExportRequest() {
      var vm = this;
      vm.$store.dispatch('project/createExport', {
        id: vm.project.id,
        export_format: vm.formatType
      }).then(function (res) {
        // 根据返回处理前端
        vm.state = res.data.state;
        vm.archiveUrl = res.data.archive_url;

        if (vm.state !== 'completed') {
          vm.initCheck();
        }

        vm.$emit('update:loading', false);
        // 此时应该打开Export-dialog 而不是下单 dialog
        vm.orderDialogVisible = false;
        vm.exportDialogVisible = true;
      }).catch(function (err) {
        vm.$emit('update:loading', false);

        var type = err.response.data.type;
        if (type === 'ExceedExportAllowanceError') {
          vm.state = 'exceed_error';
          vm.message = err.response.data.message;
          vm.orderDialogVisible = false;
          vm.exportDialogVisible = true;
        } else if (type === 'NoQuotaError') {
          // check quota to determine whether we can consume quota or not
          vm.$store.dispatch('refresh').then(function (_) {
            vm.orderDialogVisible = true;
            vm.exportDialogVisible = false;
          });
        }
      });
    },
    open: function open(formatType) {
      // need check status
      var vm = this;
      vm.formatType = formatType;
      //   vm.exportDialogVisible = true
      vm.$emit('update:loading', true);
      // create export
      vm.createExportRequest();
    },
    close: function close() {
      this.clearCheck();
    }
  }
};

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _export = __webpack_require__(860);

var _export2 = _interopRequireDefault(_export);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import RecordDialog from './record.dialog'

exports.default = {
  data: function data() {
    return {
      exportLoading: false
    };
  },

  components: {
    'export-dialog': _export2.default
    //'record-dialog': RecordDialog
  },
  computed: {
    project: function project() {
      return this.$store.state.project.items[this.$route.params.id];
    },
    readonly: function readonly() {
      return this.project.permissions.readonly;
    }
  },
  methods: {
    onCopy: function onCopy(e) {
      this.$message({
        message: this.$t('common.infos.copy'),
        type: 'success'
      });
    },
    openExportDialog: function openExportDialog(type) {
      this.$refs['export-dialog'].open(type);
    },

    exportDropdownCommand: function exportDropdownCommand(command) {
      this.openExportDialog(command);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(161);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      combined_form: {},
      list: [],
      current_page: 1,
      total_pages: 1,
      total_items: 0,
      page_size: 1
    };
  },

  computed: {
    labels: function labels() {
      var _this = this;

      if (!this.combined_form) return null;

      return (0, _keys2.default)(this.combined_form).map(function (k) {
        return {
          key: k,
          name: _this.combined_form[k]
        };
      });
    }
  },
  methods: {
    fetchData: function fetchData() {
      var vm = this;
      vm.$store.dispatch('project/formRecords', { id: vm.$route.params.id, page: vm.current_page }).then(function (res) {
        vm.combined_form = res.data.combined_form;
        vm.list = res.data.list;
        vm.current_page = res.data.current_page;
        vm.total_pages = res.data.total_pages;
        vm.total_items = res.data.total_items;
        vm.page_size = res.data.page_size;
      });
    },
    handleCurrentChange: function handleCurrentChange() {
      this.fetchData();
    },
    removeSelections: function removeSelections() {
      var vm = this;
      var selections = vm.$refs['table'].store.states.selection;

      if (!selections || selections.length <= 0) {
        vm.$alert('暂无选中').catch(function (_) {});
        return;
      }

      vm.$confirm('删除的数据暂不能恢复', '确定删除选中的数据？', {
        cancelButtonClass: 'el-button--text',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: vm.$t('common.buttons.cancel'),
        confirmButtonText: vm.$t('common.buttons.ok')
      }).then(function (_) {
        vm.$store.dispatch('project/deleteFormRecords', {
          id: vm.$route.params.id,
          batch_ids: selections.map(function (v) {
            return v.id;
          }).join(',')
        }).then(function (_) {
          // reload current page
          vm.fetchData();
        });
      }).catch(function (_) {});
    }
  },
  mounted: function mounted() {
    this.fetchData();
  }
};

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  computed: {
    id: function id() {
      return this.$route.params.id;
    },
    project: function project() {
      return this.$store.state.project.items[this.id];
    }
  }

};

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _entries = __webpack_require__(490);

var _entries2 = _interopRequireDefault(_entries);

var _keys = __webpack_require__(161);

var _keys2 = _interopRequireDefault(_keys);

var _charts = __webpack_require__(155);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    'bar-chart': function barChart() {
      return (0, _charts.dynamicImportChartkick)('BarChart');
    },
    'column-chart': function columnChart() {
      return (0, _charts.dynamicImportChartkick)('ColumnChart');
    },
    'line-chart': function lineChart() {
      return (0, _charts.dynamicImportChartkick)('LineChart');
    }
  },
  data: function data() {
    return {
      tag: 'today',
      summary: {
        pv: {
          today: 0,
          total: 0,
          yesterday: 0
        }
      },
      pv_by_source: null,
      shares_by_target: null,
      pvPercentageOptions: {
        tooltips: {
          callbacks: {
            label: function label(item, data) {
              return '\u6D4F\u89C8\u6B21\u6570: ' + item.xLabel;
            }
          }
        },
        scales: {
          xAxes: [{
            display: false
          }],
          yAxes: [{
            barThickness: 30,
            gridLines: {
              display: false
            }
          }]
        }
      },
      pvChartOptions: {
        tooltips: {
          callbacks: {
            title: function title(item, data) {
              return new Date(item[0].xLabel).toLocaleDateString("zh-cn");
            }
          }
        },
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              displayFormats: {
                day: 'YYYY-MM-DD'
              },
              unit: 'day'
            }
          }]
        }
      },
      behaviorOptions: {
        tooltips: {
          callbacks: {
            label: function label(item, data) {
              return '\u5206\u4EAB\u6B21\u6570: ' + item.yLabel;
            }
          }
        },
        scales: {
          xAxes: [{
            barThickness: 30
          }]
        }
      }
    };
  },
  computed: {
    pvPercentageData: function pvPercentageData() {
      // total, yesterday, today
      var vm = this;
      if (!vm.pv_by_source) {
        return false;
      }

      var keys = (0, _keys2.default)(vm.pv_by_source);
      var result = {};
      var tags = ['today', 'yesterday', 'total'];

      tags.forEach(function (tag) {
        result[tag] = keys.map(function (k) {
          return [vm.$t('pv_by_source.' + k), vm.pv_by_source[k][tag]];
        });
      });

      return result;
    },
    behaviorData: function behaviorData() {
      var vm = this;
      if (!vm.shares_by_target) {
        return false;
      }

      var keys = (0, _keys2.default)(vm.shares_by_target);
      var result = {};
      var tags = ['today', 'yesterday', 'total'];

      tags.forEach(function (tag) {
        result[tag] = keys.map(function (k) {
          return [vm.$t('shares_by_target.' + k), vm.shares_by_target[k][tag]];
        });
      });

      return result;
    },
    trendData: function trendData() {
      var vm = this;
      var pvs = this.pv_by_source;
      if (!pvs) {
        return;
      }
      var total = {};
      var result = (0, _keys2.default)(pvs).map(function (source) {
        return {
          name: vm.$t('pv_by_source.' + source),
          data: (0, _keys2.default)(pvs[source]['by_date']).map(function (date) {
            // date format is 20170101 need to parse into a date
            var dateInFormat = new Date(date.substr(0, 4), date.substr(4, 2) - 1, date.substr(6, 2));
            var pv = pvs[source]['by_date'][date];

            total[dateInFormat] = pv + (total[dateInFormat] || 0);

            return [dateInFormat, pv];
          })
        };
      });

      result.push({
        name: vm.$t('pv_by_source.total'),
        data: (0, _entries2.default)(total)
      });
      return result;
    }
  },
  mounted: function mounted() {
    var vm = this;
    vm.$store.dispatch('project/stats', vm.$route.params.id).then(function (res) {
      vm.summary = res.data.summary;
      vm.pv_by_source = res.data.pv_by_source;
      vm.shares_by_target = res.data.shares_by_target;
    });
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ['step']
};

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(39);

var _stringify2 = _interopRequireDefault(_stringify);

var _logger = __webpack_require__(62);

var _logger2 = _interopRequireDefault(_logger);

var _ss_uploader = __webpack_require__(79);

var _ss_uploader2 = _interopRequireDefault(_ss_uploader);

var _nginx_uploader = __webpack_require__(880);

var _nginx_uploader2 = _interopRequireDefault(_nginx_uploader);

var _qiniu_uploader = __webpack_require__(881);

var _qiniu_uploader2 = _interopRequireDefault(_qiniu_uploader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var supportXHRUpload = !!(window.ProgressEvent && window.FileReader) || !!window.FormData;

var checkTimer = null;
var interval = 0;

var check = function check() {
  var create = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var vm = undefined;
  interval += 1;
  _logger2.default.info('interval: ' + interval + ' * 5 seconds');

  if (interval % 60 === 0) {
    _logger2.default.error('\u5F53\u524D\u4E0A\u4F20\u65F6\u95F4\u5DF2\u7ECF\u4E3A ' + interval + ' * 5 seconds, \u8FDB\u5EA6\u4E3A ' + vm.progress + ', \u5927\u5C0F\u4E3A ' + vm.sizeReadable(vm.filesize));
  }

  if (create || checkTimer) {
    checkTimer = setTimeout(check, 5000);
  }
};

var clearCheck = function clearCheck() {
  if (checkTimer) {
    clearTimeout(checkTimer);
    checkTimer = null;
    interval = 0;
  }
};

exports.default = {
  data: function data() {
    return {
      uploader: supportXHRUpload ? 'qiniu' : 'ss', // 'qiniu', 'nginx', 'ss'
      project_id: null,
      onUploading: false,
      filename: null,
      filesize: null,
      progress: 0,
      accept: '.pptx, .ppt, .dps, .pdf, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.ms-powerpoint, application/pdf, application/dps',
      allowedExtensions: ['ppt', 'pptx', 'dps', 'pdf']
    };
  },

  components: {
    'ssuploader': _ss_uploader2.default,
    'nginxuploader': _nginx_uploader2.default,
    'qiniuuploader': _qiniu_uploader2.default
  },
  watch: {
    onUploading: function onUploading(newValue) {
      newValue ? check.call(this, true) : clearCheck();
    }
  },
  computed: {
    targetUrl: function targetUrl() {
      return this.supportXHRUpload ? "/api/" + 'uploads' : "/api/" + 'misc/fast_upload';
    },
    tbcMode: function tbcMode() {
      return this.$store.state.tbcMode;
    }
  },
  methods: {
    uploadDone: function uploadDone(params) {
      var vm = this;
      var success = function success(res) {
        clearCheck();
        // 导航到 project 查看页面
        vm.$router.push('/projects/' + res.data.id);
        // update this view's ui
        vm.onUploading = false;
      };

      var failure = function failure(err) {
        var data = err.response.data;
        _logger2.default.error('upload success, fail on create project: ' + (0, _stringify2.default)(data));
        // possible error:
        if (data.type === 'UploadedFileNotExistsError') {
          vm.$message({
            message: err.response.data.message,
            type: 'error',
            showClose: true,
            duration: 0
          });
        }

        // update this view's ui
        vm.onUploading = false;
      };

      if (!params || !(params.session_id || params.qn_file_id)) {
        _logger2.default.error('file_id is not appropriately get.');
        vm.$message({ message: '未知错误，请重新上传', type: 'error' });
        return;
      }
      var fileId = params.session_id;
      var qnFileId = params.qn_file_id;
      if (!vm.$route.params.id) {
        // new project need to create
        vm.$store.dispatch('project/create', {
          source_filename: vm.filename,
          category_id: vm.$route.query.catId,
          file_id: fileId,
          qn_file_id: qnFileId
        }).then(success).catch(failure);
      } else {
        vm.$store.dispatch('project/update', {
          id: vm.$route.params.id,
          source_filename: vm.filename,
          file_id: fileId,
          qn_file_id: qnFileId
        }).then(success).catch(failure);
      }
    },
    uploadFail: function uploadFail(params) {
      // do not send $message here
      clearCheck();
      _logger2.default.error('upload failure, fallback from ' + params + ' to ss');
      if (params !== 'ss') {
        this.uploader = 'ss';
      }
      this.onUploading = false;
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    clearCheck();
    next();
  }
};

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regexes = __webpack_require__(80);

var _regexes2 = _interopRequireDefault(_regexes);

var _validator = __webpack_require__(31);

var _validator2 = _interopRequireDefault(_validator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      sended: false,
      application: {
        name: null,
        phone: null,
        company: null,
        scenario: null,
        estimate_ppts: null
      }
    };
  },

  mixins: [_validator2.default],
  methods: {
    sendApplication: function sendApplication() {
      var vm = this;
      if (vm.sended) {
        vm.$contactApiApplication();
        return;
      }

      // do validation
      vm.errors.clear();
      if (!_regexes2.default.cellphone.test(vm.application.phone)) {
        vm.errors.add('cellphone', '手机号码格式不正确');
        return;
      }

      vm.$store.dispatch('apis/sendApplication', vm.application).then(function (res) {
        vm.$contactApiApplication();
        vm.sended = true;
      });
    }
  }
};

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(12);

var _promise2 = _interopRequireDefault(_promise);

var _validator = __webpack_require__(31);

var _validator2 = _interopRequireDefault(_validator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      cellphone: null,
      captcha: null,
      form: {
        password: null,
        passwordConfirmation: null
      }
    };
  },

  mixins: [_validator2.default],
  rules: {
    confirmed: { target: 'passwordConfirmation', original: 'password', recursion: 'form' },
    required: 'password'
  },
  methods: {
    signUp: function signUp() {
      var _this = this;

      var vm = this;
      var cellphoneInput = vm.$refs['cellphoneInput'];

      var p1 = new _promise2.default(function (resolve, reject) {
        _this.$refs['form'].validate(function (res) {
          res ? resolve() : reject('form');
        });
      });

      var p2 = cellphoneInput.save();

      _promise2.default.all([p1, p2]).then(function (values) {
        // all validation passed
        vm.$store.dispatch('user/signUp', {
          cellphone: vm.cellphone,
          captcha: vm.captcha,
          password: vm.form.password,
          sign_up_ref: vm.$route.query.code
        }).then(function (_) {
          vm.$router.push({
            path: '/'
          });
        }).catch(function (err) {
          var data = err.response.data;
          if (data.type === 'RecordInvalidError') {
            // 手机已被占用
            data.errors.forEach(function (err) {
              var field = err.field;
              var message = err.details.map(function (d) {
                return d.message;
              }).join(',');
              vm.errors.add(field, message);
              cellphoneInput.addErrors(field, message);
            });
          } else if (data.type === 'CaptchaIncorrectError') {
            // 验证码错误
            cellphoneInput.addErrors('captcha', data.message);
          }
        });
      }).catch(function (err) {
        console.log(err);
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(12);

var _promise2 = _interopRequireDefault(_promise);

var _validator = __webpack_require__(31);

var _validator2 = _interopRequireDefault(_validator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      form: {
        emailOrCellphone: null,
        password: null
      }
    };
  },

  mixins: [_validator2.default],
  rules: {
    required: ['emailOrCellphone', 'password']
  },
  methods: {
    signIn: function signIn() {
      var vm = this;

      var p1 = new _promise2.default(function (resolve, reject) {
        vm.errors.clear();
        vm.$refs['form'].validate(function (res) {
          res ? resolve() : reject('form');
        });
      });

      p1.then(function (_) {
        vm.$store.dispatch('user/signIn', {
          login: vm.form.emailOrCellphone,
          password: vm.form.password
        }).then(function (_) {
          vm.$router.push({
            path: '/'
          });
        }).catch(function (err) {
          var data = err.response.data;

          if (data.type === 'PasswordIncorrectError') {
            vm.errors.add('password', data.message);
          } else if (data.type === 'EmailOrPhoneNotExistError') {
            vm.errors.add('emailOrCellphone', data.message);
          }
        });
      }).catch(function (err) {
        console.log('未通过前端验证', err);
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(12);

var _promise2 = _interopRequireDefault(_promise);

var _validator = __webpack_require__(31);

var _validator2 = _interopRequireDefault(_validator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      findType: 'email', // or 'cellphone'
      form: {
        email: null
      },
      cellphone: null,
      captcha: null,
      mailSended: false
    };
  },

  mixins: [_validator2.default],
  rules: {
    required: 'email',
    email: 'email'
  },
  methods: {
    resetPassword: function resetPassword() {
      var _this = this;

      var vm = this;
      var cellphoneInput = vm.$refs['cellphoneInput'];

      var p1 = vm.findType === 'email' ? new _promise2.default(function (resolve, reject) {
        _this.$refs['form'].validate(function (res) {
          res ? resolve() : reject('form');
        });
      }) : _promise2.default.resolve();
      var p2 = vm.findType === 'cellphone' ? cellphoneInput.save() : _promise2.default.resolve();

      _promise2.default.all([p1, p2]).then(function (_) {
        vm.$store.dispatch('user/reqResetPassword', {
          findType: vm.findType,
          email: vm.form.email,
          cellphone: vm.cellphone,
          captcha: vm.captcha
        }).then(function (res) {
          // depend on via attribute
          var data = res.data;

          if (data.via === 'email') {
            vm.mailSended = true;
          } else if (data.via === 'cellphone') {
            vm.$router.push({
              path: '/password/reset',
              query: {
                token: data.token
              }
            });
          }
        }).catch(function (err) {
          //   vm.errors.add('email', res.response.data.msg, 'custom_uplicate')
          var data = err.response.data;
          if (data.type === 'EmailOrPhoneNotExistError') {
            // 邮箱不存在
            vm.findType === 'email' ? vm.errors.add('email', data.message) : cellphoneInput.addErrors('cellphone', data.message);
          } else if (data.type === 'CaptchaIncorrectError') {
            // 验证码错误
            cellphoneInput.addErrors('captcha', data.message);
          }
        });
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.mailSended = false;
    next();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(12);

var _promise2 = _interopRequireDefault(_promise);

var _validator = __webpack_require__(31);

var _validator2 = _interopRequireDefault(_validator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      form: {
        email: null,
        password: null,
        passwordConfirmation: null
      }
    };
  },

  mixins: [_validator2.default],
  rules: {
    confirmed: { target: 'passwordConfirmation', original: 'password', recursion: 'form' },
    required: ['email', 'password'],
    email: 'email'
  },
  methods: {
    signUp: function signUp() {
      var vm = this;

      // 前端验证
      var p1 = new _promise2.default(function (resolve, reject) {
        vm.errors.clear();
        vm.$refs['form'].validate(function (res) {
          res ? resolve() : reject('form');
        });
      });

      p1.then(function (_) {
        vm.$store.dispatch('user/signUp', {
          email: vm.form.email,
          password: vm.form.password,
          sign_up_ref: vm.$route.query.code
        }).then(function (_) {
          vm.$router.push({
            path: '/'
          });
        }).catch(function (err) {
          var data = err.response.data;
          if (data.type === 'RecordInvalidError') {
            // 邮箱已被占用
            data.errors.forEach(function (err) {
              vm.errors.add(err.field, err.details.map(function (d) {
                return d.message;
              }).join(','));
            });
          }
        });
      }).catch(function (err) {
        console.log('cannot pass front validation', err);
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(12);

var _promise2 = _interopRequireDefault(_promise);

var _validator = __webpack_require__(31);

var _validator2 = _interopRequireDefault(_validator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      form: {
        newPassword: null,
        passwordConfirmation: null
      }
    };
  },

  mixins: [_validator2.default],
  rules: {
    confirmed: { target: 'passwordConfirmation', original: 'newPassword', recursion: 'form' },
    required: 'newPassword'
  },
  methods: {
    reset: function reset() {
      var _this = this;

      var vm = this;

      // 前端验证
      var p1 = new _promise2.default(function (resolve, reject) {
        _this.$refs['form'].validate(function (res) {
          res ? resolve() : reject('form');
        });
      });

      p1.then(function (_) {
        vm.$store.dispatch('user/resetPassword', {
          reset_password_token: vm.$route.query.token,
          password: vm.form.newPassword
        }).then(function (_) {
          vm.$router.push({
            path: '/'
          });
        });
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      form: {
        email: null,
        password: null
      }
    };
  },

  methods: {
    wxbind: function wxbind() {
      alert('send wxbind request');
    }
  }
};

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _logger = __webpack_require__(62);

var _logger2 = _interopRequireDefault(_logger);

var _lazyLoadModule = __webpack_require__(48);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  mounted: function mounted() {
    var vm = this;
    vm.$store.dispatch('user/wxAuth').then(function (res) {
      (0, _lazyLoadModule.lazyload)('wxlogin').then(function (_) {
        var obj = new window.WxLogin({
          id: 'login_container',
          appid: res.data.appid,
          scope: res.data.scope,
          state: res.data.state,
          redirect_uri: res.data.redirect_uri,
          href: '//' + "ppj.io" + '/static/stylesheets/wxlogin.css'
        });
        _logger2.default.debug(obj);
      });
    });
  }
};

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(12);

var _promise2 = _interopRequireDefault(_promise);

var _provinces = __webpack_require__(962);

var _provinces2 = _interopRequireDefault(_provinces);

var _validator = __webpack_require__(31);

var _validator2 = _interopRequireDefault(_validator);

var _ss_uploader = __webpack_require__(79);

var _ss_uploader2 = _interopRequireDefault(_ss_uploader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      form: {
        realname: null,
        province: null,
        organization: null,
        certificate: null,
        filename: null
      },
      provinces: _provinces2.default,
      supportPreview: true,
      // route related
      pathFrom: null,
      // uploader related
      uploadUrl: "/api/" + 'occupation_verification',
      accept: '.png, .gif, .jpeg, .jpg, image/*',
      extensions: ['png', 'gif', 'jpeg', 'jpg']
    };
  },

  mixins: [_validator2.default],
  rules: {
    required: ['realname', 'province', 'organization', 'certificate']
  },
  components: {
    'ssuploader': _ss_uploader2.default
  },
  computed: {
    uploadData: function uploadData() {
      return {
        'verification[realname]': this.form.realname,
        'verification[province]': this.form.province,
        'verification[organization]': this.form.organization
      };
    }
  },
  methods: {
    preview: function preview(params) {
      var vm = this;

      vm.clearErrors('certificate');
      vm.form.certificate = params.file;
      vm.form.filename = params.filename;

      try {
        var reader = new FileReader();
        reader.addEventListener('load', function () {
          vm.$refs['preview-image'].src = reader.result;
        }, false);
        if (vm.form.certificate) {
          reader.readAsDataURL(vm.form.certificate);
        }
      } catch (e) {
        vm.supportPreview = false;
      }
    },
    save: function save() {
      var vm = this;
      var p1 = new _promise2.default(function (resolve, reject) {
        vm.$refs['form'].validate(function (res) {
          res ? resolve() : reject('form');
        });
      });

      p1.then(function (_) {
        // after validator
        vm.$refs['uploader'].submit();
      }).catch(function (_) {});
    },
    complete: function complete() {
      var _this = this;

      var vm = this;
      vm.$store.dispatch('refresh');
      this.$alert('认证成功，您已获得1折购买教育专业版的优惠。', '恭喜', {
        callback: function callback() {
          _this.$router.push('/order?type=edu');
        }
      });
    },
    finish: function finish() {
      this.$router.push(this.pathFrom && this.pathFrom.path || '/profile');
    },
    error: function error(res) {
      if (parseInt(res.status) === 400) {
        this.$router.push('/order?type=edu');
      }
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (from && from.path !== '/') {
        vm.pathFrom = from;
      }
    });
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(12);

var _promise2 = _interopRequireDefault(_promise);

var _regexes = __webpack_require__(80);

var _regexes2 = _interopRequireDefault(_regexes);

var _validator = __webpack_require__(31);

var _validator2 = _interopRequireDefault(_validator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      mutableCellphone: this.cellphone,
      mutableCaptcha: this.captcha,
      sended: null,
      cooldown: 0,
      cooldownTimeout: null
    };
  },

  mixins: [_validator2.default],
  props: {
    cellphone: [String, Number],
    captcha: [String, Number],
    reset: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  methods: {
    sendCaptcha: function sendCaptcha() {
      var vm = this;

      vm.errors.clear();
      if (!_regexes2.default.cellphone.test(vm.mutableCellphone)) {
        vm.errors.add('cellphone', '手机号码格式不正确');
        return;
      }

      var cooldown = function cooldown() {
        if (vm.cooldown <= 0) {
          vm.sended = false;
          window.clearTimeout(vm.cooldownTimeout);
          vm.cooldownTimeout = null;
        } else {
          vm.cooldown -= 1;
          vm.cooldownTimeout = window.setTimeout(cooldown, 1000);
        }
      };

      vm.$store.dispatch('user/captcha', {
        cellphone: vm.mutableCellphone,
        reset: vm.reset
      }).then(function (_) {
        vm.sended = true;
        // init cooldown
        vm.cooldown = 61;
        cooldown();
      }).catch(function (err) {
        vm.errors.add('cellphone', err.response.data.message);
      });
    },
    save: function save() {
      var vm = this;

      // do validation
      vm.errors.clear();
      if (!_regexes2.default.cellphone.test(vm.mutableCellphone)) {
        vm.errors.add('cellphone', '手机号码格式不正确');
        return _promise2.default.reject('validation');
      }

      if (!_regexes2.default.captcha.test(vm.mutableCaptcha)) {
        vm.errors.add('captcha', '验证码格式不正确');
        return _promise2.default.reject('validation');
      }

      vm.$emit('update:cellphone', vm.mutableCellphone);
      vm.$emit('update:captcha', vm.mutableCaptcha);
      return _promise2.default.resolve('saved');
    },
    addErrors: function addErrors(field, message) {
      this.errors.add(field, message);
    }
  }
};

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'headbar',
  computed: {
    showNav: function showNav() {
      return this.$store.getters['user/session'] !== null;
    },
    sneakyMode: function sneakyMode() {
      return this.$store.state.sneakyMode;
    }
  },
  methods: {
    signOut: function signOut() {
      var vm = this;
      vm.$store.dispatch('user/signOut').then(function () {
        vm.$message(vm.$t('actions.headbar.logoutMessage'));
        vm.$router.push({
          name: 'login'
        });
      });
    }
  }
};

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      full: true
    };
  }
};

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      image: null
    };
  },

  props: {
    value: [String, Number, Object],
    title: String,
    tag: {
      type: String,
      default: 'thumbnail'
    }
  },
  watch: {
    value: function value(newValue) {
      this.setImage(newValue);
    }
  },
  methods: {
    setImage: function setImage(value) {
      var vm = this;
      if (typeof value === 'string') {
        vm.image = value;
      } else if (!value) {
        vm.image = null;
      } else {
        if (value.file_url) {
          vm.image = value.file_url;
        }

        if (value.id) {
          vm.$emit('input', value.id);
        }
      }
    },
    openMediaImageDialog: function openMediaImageDialog() {
      var vm = this;

      vm.$mediaImage({
        initTag: vm.tag,
        success: vm.setImage
      });
    }
  },
  mounted: function mounted() {
    var vm = this;
    vm.$nextTick(function () {
      // init value
      if (vm.value) {
        vm.setImage(vm.value);
      }
    });
  }
};

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(39);

var _stringify2 = _interopRequireDefault(_stringify);

var _logger = __webpack_require__(62);

var _logger2 = _interopRequireDefault(_logger);

var _lazyLoadModule = __webpack_require__(48);

var _misc = __webpack_require__(156);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// according to jquery-file-upload:
// https://github.com/blueimp/jQuery-File-Upload/blob/master/js/jquery.fileupload.js#L314
var supportXHRUpload = !!(window.ProgressEvent && window.FileReader) || !!window.FormData; //
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      sessionID: null,
      retries: 0,
      uploadedBytes: 0
    };
  },

  props: {
    label: {
      type: String,
      default: '本地上传'
    },
    onUploadingLabel: {
      type: String,
      default: '上传中...'
    },
    url: String,
    accept: String,
    extensions: Array
  },
  computed: {
    uploadOptions: function uploadOptions() {
      var vm = this;
      var file = {};
      return {
        url: supportXHRUpload ? "/api/" + 'uploads' : "/api/" + 'misc/fast_upload',
        maxChunkSize: 1024 * 256,
        maxRetries: 2,
        retryTimeout: 1000,
        multipart: false,
        forceIframeTransport: !supportXHRUpload,
        dataType: supportXHRUpload ? '' : 'json',

        // hand-in sessionID if upload as iframe, the server need sessionID to store the file
        formData: function formData() {
          return [{
            name: 'sessionID',
            value: vm.sessionID
          }];
        },

        // Collect some basic information about the file.
        add: function add(e, data) {
          _logger2.default.info('file added', data);
          file = data.files[0];

          // shallow file extension validation
          var extension = file.name.split('.').pop().toLowerCase();
          if (vm.extensions.indexOf(extension) < 0) {
            vm.$message({
              message: '文件名不包含指定格式',
              type: 'error'
            });
            return;
          }
          // update filename and filesize
          vm.$emit('update:filename', file.name);
          vm.$emit('update:filesize', file.size || 0);

          // get sessionID
          vm.sessionID = (0, _misc.generateSessionID)(vm.$store.state.user.info.id, file);
          console.log('sessionID', vm.sessionID);

          // update ui
          vm.$emit('update:uploading', true);

          data.submit();
        },


        /*
         * Do something when the upload is done.
         */
        done: function done(e, data) {
          var result = data.result;
          if (result && typeof result === 'string') {
            vm.sessionID = result;
          } else if (result && result.session_id) {
            vm.sessionID = result.session_id;
          }
          _logger2.default.info('upload done, sessionID is ' + vm.sessionID);

          // 清理cookie存的Token
          (0, _misc.generateSessionID)(vm.$store.state.user.info.id, file, { clean: true });

          vm.$emit('complete', { session_id: vm.sessionID });
        },

        /*
         * This method is called whenever progress is reported back from nginx.
         */
        progress: function progress(e, data) {
          vm.$emit('update:progress', parseInt(data.loaded / data.total * 100, 10) || 0);
          _logger2.default.debug('progress', data.loaded, data.total);
        },

        /*
         * This method prepares the chunk that is about to be uploaded.
         */
        beforeSend: function beforeSend(e, files, index, xhr, handler, callback) {
          // Set uploadedBytes on the context to ensure that if this upload was
          // resumed, it will continue from where it left off.
          vm.uploadedBytes = files.uploadedBytes;
          //
          // Set the required headers for the nginx upload module
          e.setRequestHeader('Session-ID', vm.sessionID);
          e.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

          var device = navigator.userAgent.toLowerCase();
          var ios = device.match(/(iphone|ipod|ipad)/);
          var chrome = device.match(/crios/);

          if (ios && !chrome) {
            e.setRequestHeader('Cache-Control', 'no-cache');
          }
        },

        /*
         * This method will be called whenever an upload (or a single chunk) fails
         * to complete. In this case, we're setting up an auto-resume feature to
         * attempt the upload again (respecting our retry and timeout settings).
         */
        fail: function fail(e, data) {
          _logger2.default.error('nginx upload fail (' + vm.retries + '/' + data.maxRetries + '): ' + (0, _stringify2.default)(data.response()));
          // If we can still attempt a retry
          if (vm.retries < data.maxRetries) {
            // Increment the retry count
            vm.retries += 1;
            window.setTimeout(function () {
              // Reassign the uploadedBytes, then submit to start the upload again.
              data.uploadedBytes = vm.uploadedBytes;
              data.data = null;
              data.submit();
            }, vm.retries * data.retryTimeout);
          } else {
            // We've met our retry limit. Indicate that this upload has failed.
            // force file to be sent via simple-a
            vm.retries = 0;
            _logger2.default.debug('totally failure after retry several times');
            vm.$message({
              message: '网络好像有点问题，重新上传试试吧~',
              type: 'error',
              duration: 5000
              // showClose: true,
            });
            vm.$emit('error', 'nginx');
          }
        }
      };
    }
  },
  methods: {
    init: function init() {
      var vm = this;
      (0, _lazyLoadModule.lazyload)('jquery').then(function ($) {
        (0, _lazyLoadModule.lazyload)('blueimp-file-upload').then(function (_) {
          vm.$nextTick(function (_) {
            $(vm.$el).find('input#fileupload').fileupload(vm.uploadOptions);
          });
        });
      });
    },
    destroy: function destroy() {
      var vm = this;
      (0, _lazyLoadModule.lazyload)('jquery').then(function ($) {
        var target = $(vm.$el).find('input#fileupload');
        if (target && target.fileupload) {
          target.fileupload('destroy');
        }
      });
    }
  },
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
};

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _logger = __webpack_require__(62);

var _logger2 = _interopRequireDefault(_logger);

var _lazyLoadModule = __webpack_require__(48);

var _misc = __webpack_require__(156);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      uploader: null,
      onUploading: false
    };
  },

  props: {
    label: {
      type: String,
      default: '本地上传'
    },
    onUploadingLabel: {
      type: String,
      default: '上传中...'
    },
    url: String,
    accept: String,
    extensions: Array,
    btnType: {
      type: String,
      default: 'default'
    },
    btnPlain: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    init: function init() {
      var vm = this;
      (0, _lazyLoadModule.lazyload)('plupload').then(function (plupload) {
        window.plupload = plupload;
        window.moxie = plupload.moxie;
        (0, _lazyLoadModule.lazyload)('qiniu').then(function (_) {
          vm.uploader = window.Qiniu.uploader({
            runtimes: 'html5,flash,html4', // 上传模式，依次退化
            browse_button: 'qiniu-uploader-btn', // 上传选择的点选按钮，必需
            // 在初始化时，uptoken，uptoken_url，uptoken_func三个参数中必须有一个被设置
            // 切如果提供了多个，其优先级为uptoken > uptoken_url > uptoken_func
            // 其中uptoken是直接提供上传凭证，uptoken_url是提供了获取上传凭证的地址，如果需要定制获取uptoken的过程则可以设置uptoken_func
            // uptoken: '0Lh8Tid6OqWrdSYUXTBOZdyE4AU0KGZb2T1dLdI4:IF5IkkldT5u9QgJQKpe20m3X_1s=:eyJzY29wZSI6InBwdC1zb3VyY2U6dGVzdC5wcHR4IiwiZGVhZGxpbmUiOjE1MTI1NTA4NjF9', // uptoken是上传凭证，由其他程序生成
            uptoken_url: "/api/" + 'misc/uptoken', // Ajax请求uptoken的Url，强烈建议设置（服务端提供）
            // uptoken_func: function(){    // 在需要获取uptoken时，该方法会被调用
            //    // do something
            //    return uptoken;
            // },
            multi_selection: false, // 设置每次只能选择一个文件
            get_new_uptoken: false, // 设置上传文件的时候是否每次都重新获取新的uptoken
            // downtoken_url: '/downtoken',
            // Ajax请求downToken的Url，私有空间时使用，JS-SDK将向该地址POST文件的key和domain，服务端返回的JSON必须包含url字段，url值为该文件的下载地址
            // unique_names: true,              // 默认false，key为文件名。若开启该选项，JS-SDK会为每个文件自动生成key（文件名）
            // save_key: true,                  // 默认false。若在服务端生成uptoken的上传策略中指定了sava_key，则开启，SDK在前端将不对key进行任何处理
            domain: 'p0ha59qxb.bkt.clouddn.com', // bucket域名，下载资源时用到，必需
            container: 'qiniu-uploader-wrapper', // 上传区域DOM ID，默认是browser_button的父元素
            max_retries: 1, // 上传失败最大重试次数
            dragdrop: true, // 开启可拖曳上传
            drop_element: 'qiniu-uploader-wrapper', // 拖曳上传区域元素的ID，拖曳文件或文件夹后可触发上传
            chunk_size: '4mb', // 分块上传时，每块的体积
            auto_start: true, // 选择文件后自动上传，若关闭需要自己绑定事件触发上传
            // 可以使用该参数来限制上传文件的类型，大小等，该参数以对象的形式传入，它包括三个属性：
            filters: {
              max_file_size: '2gb',
              // Specify what files to browse for
              mime_types: [{ title: 'Custom Files', extensions: vm.extensions.join(',') // 限定flv后缀上传格式上传
              }]
            },
            init: {
              'BeforeUpload': function BeforeUpload(up, file) {
                vm.$emit('update:filename', file.name);
                vm.$emit('update:filesize', file.size || 0);
                vm.$emit('update:uploading', true);
              },
              'UploadProgress': function UploadProgress(up, file) {
                // 每个文件上传时，处理相关的事情
                vm.$emit('update:progress', file.percent);
                _logger2.default.debug('progress', file.percent);
              },
              'FileUploaded': function FileUploaded(up, file, info) {
                // 每个文件上传成功后，处理相关的事情
                var domain = up.getOption('domain');
                var res = typeof info.response === 'string' ? JSON.parse(info.response) : info.response;
                var sourceLink = domain + '/' + res.key; // 获取上传成功后的文件的Url
                _logger2.default.info('file uploaded', sourceLink);

                // 清理cookie存的Token
                (0, _misc.generateSessionID)(vm.$store.state.user.info.id, file, { clean: true });

                vm.$emit('complete', { qn_file_id: res.key });
              },
              'Error': function Error(up, err, errTip) {
                // 上传出错时，处理相关的事情
                if (err.code === -600) {
                  vm.$message({
                    message: '您的文件大小已超出上限',
                    type: 'error'
                  });
                  vm.$emit('update:uploading', false);
                  return;
                }
                // 当前session上传的文件与之前上传的不一致，七牛服务端验证不通过
                if (err.status === 614) {
                  vm.$message({
                    message: '文件发生修改，继续请重新选择',
                    type: 'error'
                  });

                  // 清理cookie存的Token
                  (0, _misc.generateSessionID)(vm.$store.state.user.info.id, err.file, { clean: true });

                  vm.$emit('update:uploading', false);
                  return;
                }
                vm.$emit('error', 'qiniu');
                _logger2.default.error('qiniu upload fail: ' + errTip);
                vm.$message({
                  message: errTip,
                  type: 'error'
                });
              },
              'Key': function Key(up, file) {
                // 若想在前端对每个文件的key进行个性化处理，可以配置该函数
                // 该配置必须要在unique_names: false，save_key: false时才生效
                return (0, _misc.generateSessionID)(vm.$store.state.user.info.id, file);
              }
            }
          });
        });
      });
    }
  },
  mounted: function mounted() {
    this.init();
  },
  destroyed: function destroyed() {
    this.uploader.stop();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    size: {
      type: Number,
      default: 180
    },
    text: {
      type: String
    },
    percentage: {
      type: Number,
      default: 100
    }
  }
};

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _logger = __webpack_require__(62);

var _logger2 = _interopRequireDefault(_logger);

var _lazyLoadModule = __webpack_require__(48);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      uploader: null,
      onUploading: false
    };
  },

  props: {
    label: {
      type: String,
      default: '本地上传'
    },
    onUploadingLabel: {
      type: String,
      default: '上传中...'
    },
    url: String,
    accept: String,
    extensions: Array,
    name: {
      type: String,
      default: 'file'
    },
    data: Object,
    btnType: {
      type: String,
      default: 'default'
    },
    btnPlain: {
      type: Boolean,
      default: true
    },
    defaultBtn: {
      type: Boolean,
      default: true
    },
    autoSubmit: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    onUploading: function onUploading(newValue) {
      this.$emit('update:uploading', newValue);
    }
  },
  methods: {
    init: function init() {
      var vm = this;
      (0, _lazyLoadModule.lazyload)('simple-ajax-uploader').then(function (ss) {
        vm.uploader = new ss.SimpleUpload({
          button: vm.$el,
          name: vm.name,
          debug: "production" !== 'production',
          url: vm.url,
          accept: vm.accept,
          autoSubmit: vm.autoSubmit,
          allowedExtensions: vm.extensions,
          nginxProgressUrl: "/api/" + 'misc/fast_upload/progress',
          responseType: 'json',
          hoverClass: 'hover',
          onSubmit: function onSubmit(filename, extension, uploadBtn, filesize) {
            // update filename and filesize
            vm.$emit('update:filename', filename);
            vm.$emit('update:filesize', filesize && filesize * 1024);

            // set uploading state as true
            vm.onUploading = true;

            // prepare for upload contained data
            this.setData(vm.data);
          },
          onChange: function onChange(filename, extension, uploadBtn, filesize, file) {
            vm.$emit('change', {
              filename: filename,
              extension: extension,
              file: file
            });
          },
          onUpdateFileSize: function onUpdateFileSize(filesize) {
            vm.$emit('update:filesize', filesize && filesize * 1024);
          },
          onComplete: function onComplete(filename, response, uploadBtn, filesize) {
            vm.onUploading = false;
            vm.$emit('complete', response);
          },
          onExtError: function onExtError(filename, extension) {
            vm.$message({
              message: '\u6682\u4E0D\u652F\u6301 ' + extension + ' \u6587\u4EF6\uFF0C\u652F\u6301\u7684\u683C\u5F0F\u4E3A\uFF1A' + vm.extensions.join('，'),
              type: 'error'
            });
          },
          onError: function onError(filename, errorType, status, statusText, response, uploadBtn, filesize) {
            vm.onUploading = false;
            // if return is 204, it would cause ssuploader error, but it is actually a successful issue
            if (status === 204) {
              vm.$emit('complete');
              return;
            }
            _logger2.default.error('ssuploader upload error: ' + filename + ' - ' + errorType + ' - ' + status + ' - ' + statusText + ' - ' + response);

            // 上传失败
            // send message
            if (status === 413) {
              vm.$message({
                message: '上传文件超过限制大小',
                type: 'error'
              });
              return;
            }

            // handle external
            try {
              var data = JSON.parse(response);
              vm.$message({
                message: data && data.message || '上传失败：未知原因',
                type: 'error'
              });
            } catch (e) {
              vm.$message({
                message: response || '上传失败：未知原因',
                type: 'error'
              });
            } finally {
              vm.$emit('error', {
                status: status,
                statusText: statusText,
                response: response
              });
            }
          },
          onProgress: function onProgress(pct) {
            vm.$emit('update:progress', pct);
          }
        });
      });
    },
    submit: function submit() {
      this.uploader.submit();
    }
  },
  mounted: function mounted() {
    this.init();
  }
};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(39);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      category: {
        id: null,
        cover: null,
        name: null,
        description: null,
        publicity: null
      },
      dialogVisible: false
    };
  },

  methods: {
    open: function open(params) {
      var vm = this;
      var id = Number(params.id);
      if (!isNaN(id)) {
        // vm.category = JSON.parse(JSON.stringify(vm.$store.state.categories.items.find(value => Number(value.id) === id)))
        vm.$store.dispatch('category/get', {
          id: id
        }).then(function (res) {
          vm.category = JSON.parse((0, _stringify2.default)(res));
          // since return data has no cover but required on upload
          vm.$set(vm.category, 'cover', vm.category.cover_url);
        });
      }
      if (params.success) {
        vm.$data.success = params.success;
      }

      vm.dialogVisible = true;
    },
    openMediaImageDialog: function openMediaImageDialog() {
      var vm = this;
      // 编辑分组的dialog唤起外层的资源库dialog
      vm.$mediaImage({
        tag: 'thumbnail',
        success: function success(mediaId) {
          vm.$set(vm.category, 'cover', mediaId);
        }
      });
    },
    update: function update() {
      var vm = this;
      vm.$store.dispatch('category/create_or_update', vm.category).then(function (id) {
        if (typeof vm.$data.success === 'function') {
          vm.$data.success(id);
        }
        vm.close();
      });
    },
    close: function close() {
      this.category = {
        id: null,
        cover: null,
        name: null,
        description: null,
        publicity: null
      };
      this.dialogVisible = false;
    },
    removeGroup: function removeGroup() {
      var vm = this;

      // warning hint
      vm.$confirm(vm.$t('messagebox.category.delete.message'), vm.$t('messagebox.category.delete.title', {
        name: vm.category.name
      }), {
        cancelButtonClass: 'el-button--text',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: vm.$t('common.buttons.cancel'),
        confirmButtonText: vm.$t('common.buttons.ok')
      }).then(function (_) {
        vm.$store.dispatch('category/destroy', vm.category.id).then(function (_) {
          // close and go to '/'
          vm.close();
          vm.$router.push({
            path: '/'
          });
        });
      }).catch(function (_) {});
    }
  }
};

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(39);

var _stringify2 = _interopRequireDefault(_stringify);

var _ss_uploader = __webpack_require__(79);

var _ss_uploader2 = _interopRequireDefault(_ss_uploader);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      // data stored related
      audios: {}, // audios: {'tag': [list]}
      currentTag: 'bgm',
      tags: ['bgm', 'pub'],
      selected: null,
      success: null,
      // ui update related
      dialogVisible: false,
      onUploading: false,
      uploadingFilename: null,
      progress: 0, // uploading percentage
      // player related
      player: null,
      paused: false,
      currentPlayIndex: null,
      currentAt: null,
      // uploader parameters
      extensions: ['mp3', 'wav', 'm4a', 'acc', 'ogg', 'wma'],
      accept: '.mp3, .wav, .m4a, .acc, .ogg, .wma, audio/*',
      // page related
      currentPage: 1,
      totalPages: 1,
      totalItems: 1,
      pageSize: 1
    };
  },

  components: {
    'ssuploader': _ss_uploader2.default
  },
  computed: {
    uploadUrl: function uploadUrl() {
      var organization = this.$store.getters['user/organization'];
      return organization ? "/api/" + 'organizations/' + organization.id + '/media' : "/api/" + 'media';
    },
    uploadData: function uploadData() {
      return { 'medium[type]': 'audio', 'medium[tag]': this.currentTag };
    }
  },
  watch: {
    onUploading: function onUploading(newValue) {
      if (newValue) {
        this.currentTag = 'bgm';
      }
    }
  },
  methods: {
    open: function open(params) {
      this.fetchData();
      this.success = params.success;
      this.dialogVisible = true;
    },
    fetchData: function fetchData() {
      var vm = this;
      vm.$store.dispatch('media/index', {
        type: 'audio',
        tag: 'bgm',
        public: vm.currentTag === 'pub',
        page: vm.currentPage
      }).then(function (res) {
        var data = res.data;
        vm.$set(vm.audios, vm.currentTag, data.list || []);
        vm.pageSize = data.page_size;
        vm.totalItems = data.total_items;
        vm.totalPages = data.total_pages;
      });
    },

    // player related methods
    update: function update(e) {
      this.currentAt = this.durationReadable(this.player.currentTime);
    },
    play: function play(index) {
      var vm = this;
      var fileUrl = vm.audios[vm.currentTag][index].file_url;
      if (!fileUrl) {
        vm.$message({
          message: '目标文件音频地址有问题，请刷新或联系客服',
          type: 'error'
        });
        return;
      }

      if (!vm.player) {
        vm.player = new Audio();
      }

      vm.currentPlayIndex = index;
      if (vm.player.src !== fileUrl) {
        vm.player.src = fileUrl;
      }
      vm.player.addEventListener('timeupdate', vm.update);
      vm.paused = false;
      vm.player.play();
    },
    pause: function pause() {
      var vm = this;
      if (vm.player) {
        vm.currentPlayIndex = null;
        vm.paused = true;
        vm.player.removeEventListener('timeupdate', vm.update);
        vm.player.pause();
      }
    },
    remove: function remove(index) {
      var vm = this;
      var target = vm.audios[vm.currentTag][index];
      vm.$confirm(vm.$t('messagebox.remove.message'), vm.$t('messagebox.remove.title'), {
        cancelButtonClass: 'el-button--text',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: vm.$t('common.buttons.cancel'),
        confirmButtonText: vm.$t('common.buttons.ok')
      }).then(function (_) {
        if (vm.currentPlayIndex === index) {
          vm.pause();
        }
        vm.$store.dispatch('media/destroy', target.id).then(function (_) {
          vm.audios[vm.currentTag].splice(index, 1);
        });
      }).catch(function (_) {});
    },
    save: function save() {
      var vm = this;
      if (!vm.selected) {
        // 未选中音乐
        vm.$alert(vm.$t('messagebox.save.message'), vm.$t('messagebox.save.title'), {
          confirmButtonText: vm.$t('common.buttons.ok')
        }).then(function (_) {}).catch(function (_) {});
      } else {
        var list = vm.audios[vm.currentTag];

        if (vm.success) {
          vm.success(JSON.parse((0, _stringify2.default)(list[_lodash2.default.findIndex(list, { id: vm.selected })])));
        }
        vm.close();
      }
    },
    close: function close() {
      var vm = this;

      if (vm.onUploading) {
        // 文件上传中
        vm.$alert(vm.$t('messagebox.close.message'), vm.$t('messagebox.close.title'), {
          confirmButtonText: vm.$t('common.buttons.ok')
        }).then(function (_) {}).catch(function (_) {});
      } else {
        vm.pause();
        vm.selected = null;
        vm.dialogVisible = false;
      }
    },
    uploadComplete: function uploadComplete(data) {
      var vm = this;
      vm.$refs['table'][0].setCurrentRow();
      vm.audios[vm.currentTag].splice(0, 0, data);
      vm.$nextTick(function () {
        vm.selected = data.id;

        if (vm.currentPlayIndex !== null) {
          vm.currentPlayIndex = vm.currentPlayIndex + 1;
        }
      });
    }
  }
};

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(39);

var _stringify2 = _interopRequireDefault(_stringify);

var _ss_uploader = __webpack_require__(79);

var _ss_uploader2 = _interopRequireDefault(_ss_uploader);

var _lodash = __webpack_require__(15);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      // data stored related
      images: {}, // images: {'tag', [list]}
      currentTag: 'thumbnail',
      initTag: 'thumbnail',
      //   tags: ['thumbnail', 'cover', 'logo'],
      selected: null,
      success: null,
      // ui update related
      dialogVisible: false,
      onUploading: false,
      progress: 0,
      // uploader parameters
      extensions: ['png', 'gif', 'jpeg', 'jpg'],
      accept: '.png, .gif, .jpeg, .jpg, image/*',
      // page related
      currentPage: 1,
      totalPages: 1,
      totalItems: 1,
      pageSize: 1
    };
  },

  components: {
    'ssuploader': _ss_uploader2.default
  },
  watch: {
    onUploading: function onUploading(newValue) {
      if (newValue) {
        this.currentTag = this.initTag;
      }
    }
  },
  computed: {
    uploadUrl: function uploadUrl() {
      var organization = this.$store.getters['user/organization'];
      return organization ? "/api/" + 'organizations/' + organization.id + '/media' : "/api/" + 'media';
    },
    uploadData: function uploadData() {
      return { 'medium[type]': 'image', 'medium[tag]': this.initTag };
    },
    tags: function tags() {
      return this.$store.state.tbcMode ? ['thumbnail', 'cover'] : ['thumbnail', 'cover', 'logo'];
    }
  },
  methods: {
    fetchData: function fetchData() {
      var vm = this;
      vm.$store.dispatch('media/index', {
        type: 'image',
        tag: vm.currentTag,
        page: vm.currentPage
      }).then(function (res) {
        var data = res.data;
        vm.$set(vm.images, vm.currentTag, data.list || []);
        vm.pageSize = data.page_size;
        vm.totalItems = data.total_items;
        vm.totalPages = data.total_pages;
      });
    },
    open: function open() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.success = params.success;
      this.initTag = params.initTag || this.initTag;
      this.currentTag = this.initTag;
      this.fetchData();
      this.dialogVisible = true;
    },
    remove: function remove(index) {
      var vm = this;
      var target = vm.images[vm.currentTag][index];

      vm.$confirm(vm.$t('messagebox.remove.message'), vm.$t('messagebox.remove.title'), {
        cancelButtonClass: 'el-button--text',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: vm.$t('common.buttons.cancel'),
        confirmButtonText: vm.$t('common.buttons.ok')
      }).then(function (_) {
        vm.$store.dispatch('media/destroy', target.id).then(function (_) {
          vm.images[vm.currentTag].splice(index, 1);
        });
      }).catch(function (_) {});
    },
    save: function save() {
      var vm = this;
      if (!vm.selected) {
        // 未选中图片
        vm.$alert(vm.$t('messagebox.save.message'), vm.$t('messagebox.save.title'), {
          confirmButtonText: vm.$t('common.buttons.ok')
        }).then(function (_) {}).catch(function (_) {});
      } else {
        var list = vm.images[vm.currentTag];
        var output = JSON.parse((0, _stringify2.default)(list[_lodash2.default.findIndex(list, { id: vm.selected })]));
        if (typeof vm.success === 'function') {
          vm.success(output);
        }
        vm.close();
      }
    },
    close: function close() {
      var vm = this;

      if (vm.onUploading) {
        // 文件上传中
        vm.$alert(vm.$t('messagebox.close.message'), vm.$t('messagebox.close.title'), {
          confirmButtonText: vm.$t('common.buttons.ok')
        }).then(function (_) {}).catch(function (_) {});
      } else {
        vm.selected = null;
        vm.dialogVisible = false;
      }
    },
    uploadComplete: function uploadComplete(data) {
      this.selected = data.id;
      this.images[this.initTag].splice(0, 0, data);
      this.currentTag = this.initTag;
    }
  }
};

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      qrcode: null,
      order: null,
      payType: null,
      paid: false,
      success: null,
      error: null,
      dialogVisible: false,
      openWindow: null,
      errorMsg: null
    };
  },

  watch: {
    paid: function paid(newValue) {
      // 自动关闭
      if (newValue === true) {
        var vm = this;
        setTimeout(function () {
          vm.close();
        }, 3000);
      }
    }
  },
  methods: {
    orderPaid: function orderPaid() {
      this.paid = true;

      if (this.openWindow) {
        this.openWindow.close();
        this.openWindow = null;
      }

      if (this.success) {
        if (typeof this.success === 'function') {
          this.success(this.order);
        }
      }
    },
    open: function open(params) {
      var vm = this;
      vm.dialogVisible = true;

      vm.success = params.success || function () {};
      vm.error = params.error || function () {};

      if (params.payment_method === 'alipay') {
        // 使用弹框来避免open被拦截
        vm.openWindow = window.open('/static/alipay.html');
      }

      // get order config
      vm.$store.dispatch('quota/buy', {
        package: params.package,
        project_id: params.project_id,
        promote_code: params.promote_code,
        payment_method: params.payment_method,
        return_path: '/static/alipay.html?close=true'
      }).then(function (res) {
        var data = res.data;
        vm.order = data.order_id;
        vm.payType = data.payment_method;

        if (data.paid) {
          vm.orderPaid();
          return;
        } else if (data.payment_method === 'wxpay') {
          vm.qrcode = data.payment_params.code_url;
        } else if (data.payment_method === 'alipay') {
          vm.openWindow.location.href = data.payment_params.url;
        }

        vm.$store.dispatch('order/checkState', vm.order).then(function () {
          vm.orderPaid();
        });
      }).catch(function (err) {
        // handle error for promote code invalid
        if (vm.openWindow) {
          vm.openWindow.close();
        }

        var data = err.response.data;
        if (data.type === 'InvalidPromoteCodeError') {
          if (vm.error && typeof vm.error === 'function') {
            vm.error(data);
          }
          vm.close();
        } else {
          vm.errorMsg = data.message;
        }
      });
    },
    close: function close() {
      this.$store.dispatch('order/cancelCheckState', this.order);
      this.qrcode = null;
      this.order = null;
      this.success = null;
      this.payType = null;
      this.paid = false;
      this.dialogVisible = false;
      this.errorMsg = null;
      this.openWindow = null;
    }
  }
};

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      operator: 'upgrade', // could be 'unlock'
      dialogVisable: false,
      payType: 'wechat',
      projectId: null,
      success: null,
      logoEnabled: false,
      packageType: 'one_time_permanent'
    };
  },

  computed: {
    permanentsLeft: function permanentsLeft() {
      return this.$store.state.quota.summary.permanents_left;
    },
    overdate: function overdate() {
      return this.$store.getters['quota/overdate'];
    }
  },
  methods: {
    open: function open(params) {
      var vm = this;
      // set config
      vm.projectId = params.projectId;
      vm.operator = params.operator || 'upgrade';
      vm.success = params.success || function () {};
      vm.logoEnabled = params.logoEnabled || false;

      if (!vm.logoEnabled) {
        vm.packageType = 'one_time_permanent_logo';
      }

      vm.$store.dispatch('refresh').then(function (_) {
        vm.dialogVisable = true;
      });
    },
    close: function close() {
      this.dialogVisable = false;
      this.projectId = null;
      this.success = null;
    },
    placeOrder: function placeOrder() {
      var vm = this;

      var success = function success() {
        vm.$message(vm.$t(vm.operator === 'upgrade' ? 'upgradeComplete' : 'unlockComplete'));

        if (typeof vm.success === 'function') {
          vm.success();
        }
        vm.close();
      };

      if (vm.permanentsLeft !== 0) {
        // directly use quotas to unlock
        vm.$store.dispatch('quota/consume', {
          key: 'permanent',
          project_id: vm.projectId
        }).then(success);
      } else {
        vm.$order({
          package: vm.packageType,
          project_id: vm.projectId,
          payment_method: vm.payType,
          success: success
        });
      }
    }
  }
};

/***/ }),
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 745 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 746 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 747 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 748 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 749 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 750 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 751 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 752 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 753 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 754 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 755 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 756 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 759 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 760 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 762 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 763 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 764 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 765 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 767 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 769 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 770 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 772 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 773 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 774 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 775 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 776 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 777 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 778 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 779 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 780 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 781 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 782 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 783 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 784 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 785 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 786 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 787 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 788 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 789 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 794 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 796 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 797 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 799 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 800 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 801 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 802 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 803 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 804 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 805 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 806 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 807 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 213,
	"./af.js": 213,
	"./ar": 220,
	"./ar-dz": 214,
	"./ar-dz.js": 214,
	"./ar-kw": 215,
	"./ar-kw.js": 215,
	"./ar-ly": 216,
	"./ar-ly.js": 216,
	"./ar-ma": 217,
	"./ar-ma.js": 217,
	"./ar-sa": 218,
	"./ar-sa.js": 218,
	"./ar-tn": 219,
	"./ar-tn.js": 219,
	"./ar.js": 220,
	"./az": 221,
	"./az.js": 221,
	"./be": 222,
	"./be.js": 222,
	"./bg": 223,
	"./bg.js": 223,
	"./bn": 224,
	"./bn.js": 224,
	"./bo": 225,
	"./bo.js": 225,
	"./br": 226,
	"./br.js": 226,
	"./bs": 227,
	"./bs.js": 227,
	"./ca": 228,
	"./ca.js": 228,
	"./cs": 229,
	"./cs.js": 229,
	"./cv": 230,
	"./cv.js": 230,
	"./cy": 231,
	"./cy.js": 231,
	"./da": 232,
	"./da.js": 232,
	"./de": 235,
	"./de-at": 233,
	"./de-at.js": 233,
	"./de-ch": 234,
	"./de-ch.js": 234,
	"./de.js": 235,
	"./dv": 236,
	"./dv.js": 236,
	"./el": 237,
	"./el.js": 237,
	"./en-au": 238,
	"./en-au.js": 238,
	"./en-ca": 239,
	"./en-ca.js": 239,
	"./en-gb": 240,
	"./en-gb.js": 240,
	"./en-ie": 241,
	"./en-ie.js": 241,
	"./en-nz": 242,
	"./en-nz.js": 242,
	"./eo": 243,
	"./eo.js": 243,
	"./es": 245,
	"./es-do": 244,
	"./es-do.js": 244,
	"./es.js": 245,
	"./et": 246,
	"./et.js": 246,
	"./eu": 247,
	"./eu.js": 247,
	"./fa": 248,
	"./fa.js": 248,
	"./fi": 249,
	"./fi.js": 249,
	"./fo": 250,
	"./fo.js": 250,
	"./fr": 253,
	"./fr-ca": 251,
	"./fr-ca.js": 251,
	"./fr-ch": 252,
	"./fr-ch.js": 252,
	"./fr.js": 253,
	"./fy": 254,
	"./fy.js": 254,
	"./gd": 255,
	"./gd.js": 255,
	"./gl": 256,
	"./gl.js": 256,
	"./gom-latn": 257,
	"./gom-latn.js": 257,
	"./he": 258,
	"./he.js": 258,
	"./hi": 259,
	"./hi.js": 259,
	"./hr": 260,
	"./hr.js": 260,
	"./hu": 261,
	"./hu.js": 261,
	"./hy-am": 262,
	"./hy-am.js": 262,
	"./id": 263,
	"./id.js": 263,
	"./is": 264,
	"./is.js": 264,
	"./it": 265,
	"./it.js": 265,
	"./ja": 266,
	"./ja.js": 266,
	"./jv": 267,
	"./jv.js": 267,
	"./ka": 268,
	"./ka.js": 268,
	"./kk": 269,
	"./kk.js": 269,
	"./km": 270,
	"./km.js": 270,
	"./kn": 271,
	"./kn.js": 271,
	"./ko": 272,
	"./ko.js": 272,
	"./ky": 273,
	"./ky.js": 273,
	"./lb": 274,
	"./lb.js": 274,
	"./lo": 275,
	"./lo.js": 275,
	"./lt": 276,
	"./lt.js": 276,
	"./lv": 277,
	"./lv.js": 277,
	"./me": 278,
	"./me.js": 278,
	"./mi": 279,
	"./mi.js": 279,
	"./mk": 280,
	"./mk.js": 280,
	"./ml": 281,
	"./ml.js": 281,
	"./mr": 282,
	"./mr.js": 282,
	"./ms": 284,
	"./ms-my": 283,
	"./ms-my.js": 283,
	"./ms.js": 284,
	"./my": 285,
	"./my.js": 285,
	"./nb": 286,
	"./nb.js": 286,
	"./ne": 287,
	"./ne.js": 287,
	"./nl": 289,
	"./nl-be": 288,
	"./nl-be.js": 288,
	"./nl.js": 289,
	"./nn": 290,
	"./nn.js": 290,
	"./pa-in": 291,
	"./pa-in.js": 291,
	"./pl": 292,
	"./pl.js": 292,
	"./pt": 294,
	"./pt-br": 293,
	"./pt-br.js": 293,
	"./pt.js": 294,
	"./ro": 295,
	"./ro.js": 295,
	"./ru": 296,
	"./ru.js": 296,
	"./sd": 297,
	"./sd.js": 297,
	"./se": 298,
	"./se.js": 298,
	"./si": 299,
	"./si.js": 299,
	"./sk": 300,
	"./sk.js": 300,
	"./sl": 301,
	"./sl.js": 301,
	"./sq": 302,
	"./sq.js": 302,
	"./sr": 304,
	"./sr-cyrl": 303,
	"./sr-cyrl.js": 303,
	"./sr.js": 304,
	"./ss": 305,
	"./ss.js": 305,
	"./sv": 306,
	"./sv.js": 306,
	"./sw": 307,
	"./sw.js": 307,
	"./ta": 308,
	"./ta.js": 308,
	"./te": 309,
	"./te.js": 309,
	"./tet": 310,
	"./tet.js": 310,
	"./th": 311,
	"./th.js": 311,
	"./tl-ph": 312,
	"./tl-ph.js": 312,
	"./tlh": 313,
	"./tlh.js": 313,
	"./tr": 314,
	"./tr.js": 314,
	"./tzl": 315,
	"./tzl.js": 315,
	"./tzm": 317,
	"./tzm-latn": 316,
	"./tzm-latn.js": 316,
	"./tzm.js": 317,
	"./uk": 318,
	"./uk.js": 318,
	"./ur": 319,
	"./ur.js": 319,
	"./uz": 321,
	"./uz-latn": 320,
	"./uz-latn.js": 320,
	"./uz.js": 321,
	"./vi": 322,
	"./vi.js": 322,
	"./x-pseudo": 323,
	"./x-pseudo.js": 323,
	"./yo": 324,
	"./yo.js": 324,
	"./zh-cn": 325,
	"./zh-cn.js": 325,
	"./zh-hk": 326,
	"./zh-hk.js": 326,
	"./zh-tw": 327,
	"./zh-tw.js": 327
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 813;

/***/ }),
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(772)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(917),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(765)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(909),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(333)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(768)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(913),
  /* scopeId */
  "data-v-3d71c15c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(749)

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(891),
  /* scopeId */
  "data-v-023b063c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(763)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(907),
  /* scopeId */
  "data-v-2dd685bc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(787)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(934),
  /* scopeId */
  "data-v-7def82e4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(785)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(932),
  /* scopeId */
  "data-v-7cdf693f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(806)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(956),
  /* scopeId */
  "data-v-f1e5947e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(807)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(957),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(778)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(924),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(334)
if (typeof customBlock === "function") {customBlock(Component)}
var customBlock = __webpack_require__(347)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(786)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(933),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(799)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(946),
  /* scopeId */
  "data-v-c712ac5c",
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(335)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(904),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(751)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(893),
  /* scopeId */
  "data-v-0d8232bb",
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(336)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(800)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(947),
  /* scopeId */
  "data-v-ca12b770",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(790)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(937),
  /* scopeId */
  "data-v-895ad228",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(754)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(896),
  /* scopeId */
  "data-v-1036ab7d",
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(337)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(794)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(941),
  /* scopeId */
  "data-v-a766ad86",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(753)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(895),
  /* scopeId */
  "data-v-0fb6d578",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(911),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(767)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(912),
  /* scopeId */
  "data-v-3c7b3878",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(759)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(901),
  /* scopeId */
  "data-v-19c2dd76",
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(338)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(801)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(948),
  /* scopeId */
  "data-v-cad83cf4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(747)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(889),
  /* scopeId */
  "data-v-01902038",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(748)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(890),
  /* scopeId */
  "data-v-01c5dff8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(761)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(905),
  /* scopeId */
  "data-v-28f70356",
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(339)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(796)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(943),
  /* scopeId */
  "data-v-b82a1e50",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(764)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(908),
  /* scopeId */
  "data-v-3504b370",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(755)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(897),
  /* scopeId */
  "data-v-11596f5e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(776)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(921),
  /* scopeId */
  "data-v-5abbd173",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(952),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(756)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(898),
  /* scopeId */
  "data-v-16ff49b6",
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(340)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(770)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(915),
  /* scopeId */
  "data-v-412a7bca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(760)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(903),
  /* scopeId */
  "data-v-23a49c2e",
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(341)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(792)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(939),
  /* scopeId */
  "data-v-9db90b62",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(779)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(925),
  /* scopeId */
  "data-v-5f4a0228",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(788)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(935),
  /* scopeId */
  "data-v-82ad2cb8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(762)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(906),
  /* scopeId */
  "data-v-29d33608",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(793)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(940),
  /* scopeId */
  "data-v-a154008a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(750)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(892),
  /* scopeId */
  "data-v-04cb37e1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(784)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(930),
  /* scopeId */
  "data-v-6a1392f1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(954),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(769)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(914),
  /* scopeId */
  "data-v-40395350",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(757)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(899),
  /* scopeId */
  "data-v-184e8752",
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(342)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(782)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(928),
  /* scopeId */
  "data-v-66d61e1d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(771)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(916),
  /* scopeId */
  "data-v-4c832e3e",
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(343)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(802)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(949),
  /* scopeId */
  "data-v-d402dbb6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(931),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(902),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(774)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(919),
  /* scopeId */
  "data-v-4f8900cb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(795)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(942),
  /* scopeId */
  "data-v-b1f6d47a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(955),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(758)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(900),
  /* scopeId */
  "data-v-197e7ee8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(804)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(951),
  /* scopeId */
  "data-v-de093570",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(783)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(929),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(789)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(936),
  /* scopeId */
  "data-v-87878398",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(797)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(944),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(803)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(950),
  /* scopeId */
  "data-v-dbdb5520",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(775)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(920),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(798)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(945),
  /* scopeId */
  "data-v-c4bdb79a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(777)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(923),
  /* scopeId */
  "data-v-5e794c6a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(791)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(938),
  /* scopeId */
  "data-v-8a9eb1b6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(773)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(918),
  /* scopeId */
  "data-v-4f849b62",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(781)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(927),
  /* scopeId */
  "data-v-614c1ddf",
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(344)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(780)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(926),
  /* scopeId */
  null,
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(345)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(805)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(953),
  /* scopeId */
  "data-v-e2d97d86",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(752)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(894),
  /* scopeId */
  "data-v-0d9149c4",
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(346)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(922),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "apis-application-dialog",
    attrs: {
      "title": "申请使用 API 服务",
      "size": "small",
      "visible": _vm.dialogVisable
    },
    on: {
      "close": _vm.close,
      "update:visible": function($event) {
        _vm.dialogVisable = $event
      }
    }
  }, [_c('el-form', {
    ref: "application",
    staticClass: "application-form",
    attrs: {
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.application.name),
      callback: function($$v) {
        _vm.application.name = $$v
      },
      expression: "application.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.application.phone),
      callback: function($$v) {
        _vm.application.phone = $$v
      },
      expression: "application.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.application.company),
      callback: function($$v) {
        _vm.application.company = $$v
      },
      expression: "application.company"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "使用场景"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "如教育课件，市场营销，微信运营等"
    },
    model: {
      value: (_vm.application.scenario),
      callback: function($$v) {
        _vm.application.scenario = $$v
      },
      expression: "application.scenario"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "使用数量"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "预计转化数量，可使用描述性文字，如一年两万次转化等"
    },
    model: {
      value: (_vm.application.estimate_ppts),
      callback: function($$v) {
        _vm.application.estimate_ppts = $$v
      },
      expression: "application.estimate_ppts"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.sendApplication()
      }
    }
  }, [_vm._v("提交表格，并联系我们")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 890 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-api"
  }, [(_vm.apiEnabled) ? _c('div', [_c('div', {
    staticClass: "pane"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n        API 信息\n      ")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "160px",
      "label-position": "right"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "API 服务器"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": true
    },
    model: {
      value: (_vm.form.api_endpoint),
      callback: function($$v) {
        _vm.form.api_endpoint = $$v
      },
      expression: "form.api_endpoint"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Access Key"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": true
    },
    model: {
      value: (_vm.form.access_key),
      callback: function($$v) {
        _vm.form.access_key = $$v
      },
      expression: "form.access_key"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "API 类型"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.sandbox ? '测试' : '正式'))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "调用统计"
    }
  }, [_c('span', [_vm._v(_vm._s(Number(_vm.form.quotas) - Number(_vm.form.quotas_left)) + "/" + _vm._s(Number(_vm.form.quotas)))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开发文档"
    }
  }, [_c('a', {
    staticClass: "text-btn",
    attrs: {
      "href": "https://ppninja.github.io/saas-docs/#introduction",
      "target": "_blank"
    }
  }, [_vm._v("点击访问")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pane"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n        调用配置\n      ")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "160px",
      "label-position": "right"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "回调地址",
      "error": _vm.errors.first('notify_url')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "可选"
    },
    model: {
      value: (_vm.form.notify_url),
      callback: function($$v) {
        _vm.form.notify_url = $$v
      },
      expression: "form.notify_url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "IP 白名单",
      "error": _vm.errors.first('ip_whitelist')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "可选"
    },
    model: {
      value: (_vm.form.ip_whitelist),
      callback: function($$v) {
        _vm.form.ip_whitelist = $$v
      },
      expression: "form.ip_whitelist"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save('request')
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pane"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n        生成配置\n      ")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "160px",
      "label-position": "right"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开放页面控制接口"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.form.page_ctrl_api_entitled,
      "content": "请联系管理员打开权限",
      "effect": "dark",
      "placement": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "35px"
    }
  }, [_c('el-switch', {
    attrs: {
      "reserve": "",
      "disabled": true,
      "theme": "info",
      "width": 35,
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.page_ctrl_api_entitled),
      callback: function($$v) {
        _vm.form.page_ctrl_api_entitled = $$v
      },
      expression: "form.page_ctrl_api_entitled"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "嵌入js代码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "console.log('hello, world!');"
    },
    model: {
      value: (_vm.form.injected_code),
      callback: function($$v) {
        _vm.form.injected_code = $$v
      },
      expression: "form.injected_code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save('generate')
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)]) : _c('div', {
    staticClass: "pane"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("您尚未开通 API 服务，"), _c('a', {
    on: {
      "click": _vm.apiApplication
    }
  }, [_vm._v("点击申请")])])])])
},staticRenderFns: []}

/***/ }),
/* 891 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v("临时项目与永久项目的区别")])]), _vm._v(" "), _c('ul', {
    staticClass: "features"
  }, [_c('li', [_c('div', {
    staticClass: "img clock"
  }), _vm._v(" 8小时无阅读限制\n    ")]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "img redpack"
  }), _vm._v(" 过期后读者只能预览部分内容，完整浏览需支付 1 元\n    ")]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "img gold"
  }), _vm._v(" 可通过购买会员套餐或者项目额度来解除限制\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('p', [_vm._v("PP匠一直坚持"), _c('em', [_vm._v("不限制")]), _vm._v("免费用户上传项目的数量，所有的项目链接都是"), _c('em', [_vm._v("永久有效")]), _vm._v("，为此支付了巨额的服务器和流量费用。")]), _vm._v(" "), _c('p', [_vm._v("为了平台长久发展和带来更好的服务，PP匠针对免费用户推出了临时项目的概念，这部分项目在过期后，需要读者付费打赏才能完整浏览。")]), _vm._v(" "), _c('p', [_vm._v("临时项目只适合个人用户用来做短时间非正式分享，如果是正式场合、商用或者是企业用户，"), _c('em', [_vm._v("建议购买合适的会员套餐")]), _vm._v("，以获得最佳的阅读体验和客户服务。")])]), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/faq-permanents-example.jpg"
    }
  }), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "text-btn",
    attrs: {
      "href": "http://h5.ppj.io/dBdSoWJo/index.html?v=3",
      "target": "_blank"
    }
  }, [_vm._v("查看临时项目案例")])])])
}]}

/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "export-dialog"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.$t('actions.export.unpaid.title'),
      "size": "small",
      "visible": _vm.orderDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.orderDialogVisible = $event
      },
      "close": _vm.close
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#333"
    }
  }, [_vm._v(_vm._s(_vm.$t('hint.project.export.main')))]), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$t('hint.project.export.secondary')))]), _vm._v(" "), (_vm.exportsLeft === 0) ? _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.order.labels.price')
    }
  }, [_vm._v("\n        ￥ 120 / " + _vm._s(_vm.$t('common.project')) + "\n        "), _c('a', {
    staticClass: "price-link",
    attrs: {
      "href": "/price?closeOnPQuota=true",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "ppj-icon-gift"
  }), _vm._v("升级账户，导出100个项目只需￥1999！")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.order.labels.payType')
    }
  }, [_c('el-radio-group', {
    staticClass: "payment",
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.payType),
      callback: function($$v) {
        _vm.payType = $$v
      },
      expression: "payType"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "wechat"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.order.wechat')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "alipay"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.order.alipay')))])], 1)], 1)], 1) : _c('div', {
    staticClass: "has-quotas"
  }, [_c('el-checkbox', {
    attrs: {
      "theme": "info",
      "checked": true,
      "disabled": true
    }
  }, [_vm._v("\n        使用账号导出额度（" + _vm._s(_vm.exportsLeft === null ? '不限次数' : ("还剩" + _vm.exportsLeft + "次")) + "）\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.orderDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.placeOrder()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.submit')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('actions.export.paid.title'),
      "size": "small",
      "visible": _vm.exportDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.exportDialogVisible = $event
      },
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "export-content"
  }, [(_vm.state === 'completed') ? _c('div', [_c('a', {
    staticClass: "link",
    attrs: {
      "href": _vm.archiveUrl,
      "target": "_blank"
    }
  }, [_vm._v("点击链接下载")]), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v("\n          请用浏览器直接下载，暂不支持第三方下载工具。遇到问题请加QQ群：461571276，联系我们\n        ")])]) : (_vm.state === 'exceed_error') ? _c('div', [_c('p', [_c('span', {
    staticClass: "danger"
  }, [_vm._v("注意：")]), _vm._v("您的导出额度已使用完毕")]), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v("您可以新建项目，重新上传PPT源文件，并支付导出费用，来获得最新的导出文件。")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v("您仍然可以下载之前导出的文件，但该文件"), _c('span', {
    staticClass: "danger"
  }, [_vm._v("可能")]), _vm._v("与现在上传的源文件效果不一致")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "href": ("/projects/" + (_vm.project.id) + "/export?send_file=true"),
      "target": "_blank"
    }
  }, [_vm._v("点击链接下载上次导出的文件")]), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v("\n          请用浏览器直接下载，暂不支持第三方下载工具。遇到问题请加QQ群：461571276，联系我们\n        ")])]) : _c('div', {
    staticClass: "hint"
  }, [_c('p', [_c('i', {
    staticClass: "ppj-icon-spinner",
    staticStyle: {
      "margin-right": "0.5em"
    }
  }), _vm._v("服务器正在生成导出的zip包，请保持该页面打开，等待打包完成后下载。若长时间转化不成功，请加QQ群：461571276，联系我们\n        ")])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 893 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details"
  }, [_c('table', {
    staticClass: "members-table"
  }, [_c('tr', [_vm._m(0), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("角色")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.project')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("部门")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("账号状态")]), _vm._v(" "), (_vm.canDo('edit_members') && !_vm.tbcMode) ? _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("操作")]) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('tr', [_vm._m(1)]) : _vm._l((_vm.members), function(member) {
    return _c('tr', {
      key: member.id
    }, [_vm._o(_c('td', {
      staticClass: "profile"
    }, [_c('div', {
      staticClass: "img avatar",
      style: ({
        backgroundImage: 'url(' + member.user.profile_picture + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "nickname"
    }, [_vm._v(_vm._s(member.user.nickname))]), _vm._v(" "), _c('div', {
      staticClass: "email"
    }, [_vm._v(_vm._s(member.user.email))])]), 0, member.id), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t(("roles." + (member.role)))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(member.projects_count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(member.department))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t(("memberState." + (member.state)))))]), _vm._v(" "), (_vm.canDo('edit_members') && !_vm.tbcMode) ? _c('td', [_c('el-button', {
      attrs: {
        "type": "text",
        "theme": "info"
      },
      on: {
        "click": function($event) {
          _vm.editMember(member)
        }
      }
    }, [_vm._v("编辑")]), _vm._v(" "), (member.role !== 'owner') ? _c('el-button', {
      attrs: {
        "type": "text",
        "theme": "danger"
      },
      on: {
        "click": function($event) {
          _vm.removeMember(member.id)
        }
      }
    }, [_vm._v("删除")]) : _vm._e()], 1) : _vm._e()])
  })], 2), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "small": "",
      "layout": "prev, pager, next",
      "total": _vm.totalItems,
      "page-count": _vm.totalPages,
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "current-change": _vm.fetch
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('span', [_vm._v("所有成员")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "loading-cell",
    attrs: {
      "colspan": "10"
    }
  }, [_c('div', {
    staticClass: "spinner-wrapper"
  }, [_c('i', {
    staticClass: "ppj-icon-spinner"
  })])])
}]}

/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "upgrade-project-dialog",
    attrs: {
      "title": _vm.$t(_vm.operator === 'upgrade' ? 'upgradeProject' : 'unlockProject'),
      "size": "small",
      "visible": _vm.dialogVisable
    },
    on: {
      "close": _vm.close,
      "update:visible": function($event) {
        _vm.dialogVisable = $event
      }
    }
  }, [_c('p', [_vm._v("\n    " + _vm._s(_vm.operator === 'upgrade' ? _vm.$t('upgradeHint') : _vm.$t('unlockHint')) + "\n  ")]), _vm._v(" "), (_vm.permanentsLeft !== 0) ? _c('div', {
    staticClass: "has-quotas"
  }, [_c('el-checkbox', {
    attrs: {
      "theme": "info",
      "checked": true,
      "disabled": true
    }
  }, [_vm._v("\n      使用账号额度（" + _vm._s(_vm.permanentsLeft === null ? '不限次数' : ("还剩" + _vm.permanentsLeft + "次")) + "）\n    ")])], 1) : (!_vm.organization) ? _c('el-form', {
    attrs: {
      "label-thin": "",
      "label-width": "66px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "金额"
    }
  }, [_c('el-radio-group', {
    staticClass: "package-type",
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.packageType),
      callback: function($$v) {
        _vm.packageType = $$v
      },
      expression: "packageType"
    }
  }, [(!_vm.logoEnabled) ? _c('el-radio-button', {
    attrs: {
      "label": "one_time_permanent_logo"
    }
  }, [_vm._v("\n          ￥99/永久" + _vm._s(_vm.$t('common.project')) + "+去除加载页LOGO "), _c('span', {
    staticClass: "recommand"
  }, [_vm._v("限时优惠")])]) : _vm._e(), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "one_time_permanent"
    }
  }, [_vm._v("\n          ￥49/" + _vm._s(_vm.$t('common.project')) + "\n        ")])], 1), _vm._v(" "), _c('a', {
    staticClass: "price-link",
    attrs: {
      "href": "/price?closeOnPQuota=true",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "ppj-icon-gift"
  }), _vm._v("升级会员，套餐更优惠")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.order.labels.payType')
    }
  }, [_c('el-radio-group', {
    staticClass: "payment",
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.payType),
      callback: function($$v) {
        _vm.payType = $$v
      },
      expression: "payType"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "wechat"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.order.wechat')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "alipay"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.order.alipay')))])], 1)], 1)], 1) : _c('div', [(_vm.overdate) ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("企业套餐已过期，请联系管理员续费或升级")]) : _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("企业套餐额度不足，请联系管理员续费或升级")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [(_vm.organization && _vm.permanentsLeft === 0) ? _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.cancel')))])], 1) : _c('div', [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.placeOrder()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.submit')))])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 895 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "price"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "cards"
  }, _vm._m(2))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg2"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("2.0  全新发布")]), _vm._v(" "), _c('div', {
    staticClass: "frame"
  }, [_c('div', {
    staticClass: "section left"
  }, [_c('p', {
    staticClass: "large"
  }, [_vm._v("免费不限量")]), _vm._v(" "), _c('p', [_vm._v("个人用户")]), _vm._v(" "), _c('p', [_vm._v("不限量临时项目")]), _vm._v(" "), _c('p', [_vm._v("适合短时分享")])]), _vm._v(" "), _c('div', {
    staticClass: "section right"
  }, [_c('p', {
    staticClass: "large"
  }, [_vm._v("会员新升级")]), _vm._v(" "), _c('p', [_vm._v("专业用户和企业客户")]), _vm._v(" "), _c('p', [_vm._v("正式场景，专业需求")]), _vm._v(" "), _c('p', [_vm._v("专属会员特权")])]), _vm._v(" "), _c('i', {
    staticClass: "ppj-icon-cancel-thin"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-banner"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("价格方案")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("升级会员获得充足的项目额度，满足专业需求，享受贴心服务")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._l((_vm.products), function(product) {
    return _c('div', {
      key: product.type,
      staticClass: "card",
      class: {
        prefer: product.prefer
      }
    }, [_c('div', {
      staticClass: "header"
    }, [_c('p', {
      staticClass: "product-name"
    }, [_vm._v("\n          " + _vm._s(product.name) + "\n          "), (product.prefer) ? _c('span', {
      staticClass: "recommand"
    }, [_vm._v("推荐")]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "product-price"
    }, [(product.price === 0) ? _c('span', {
      staticClass: "em"
    }, [_vm._v("免费")]) : _c('span', {
      staticClass: "price"
    }, [_c('span', {
      staticClass: "em"
    }, [_vm._v(_vm._s(product.price))]), _vm._v(" /年\n          ")])]), _vm._v(" "), (product.type === 'beta') ? _c('el-button', {
      staticClass: "prouct-action",
      attrs: {
        "disabled": Boolean(_vm.session)
      },
      on: {
        "click": function($event) {
          _vm.$router.push('/register')
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.session ? '已获得' : '立即注册') + "\n        ")]) : _c('el-button', {
      staticClass: "prouct-action",
      on: {
        "click": function($event) {
          _vm.purchase(product.type)
        }
      }
    }, [_vm._v("立即购买")])], 1), _vm._v(" "), _c('div', {
      staticClass: "details feature"
    }, [_c('p', [_vm._v("\n          项目额度\n          "), _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": _vm.$t('tooltips.permanent'),
        "popper-options": {
          removeOnDestroy: true
        },
        "open-delay": 200
      }
    }, [(product.permanent === 0) ? _c('span', {
      staticClass: "em",
      attrs: {
        "data-type": "permanent"
      }
    }, [_vm._v("￥49")]) : _c('span', {
      staticClass: "em",
      attrs: {
        "data-type": "permanent"
      }
    }, [_vm._v(_vm._s(product.permanent === null ? '不限个数' : product.permanent))])]), _vm._v(" "), (product.permanent === 0) ? _c('span', [_vm._v("/个")]) : _vm._e(), _vm._v(" "), (product.permanent) ? _c('span', [_vm._v("个")]) : _vm._e()], 1), _vm._v(" "), _c('p', [_vm._v("\n          导出\n          "), _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": _vm.$t('tooltips.export'),
        "popper-options": {
          removeOnDestroy: true
        },
        "open-delay": 200
      }
    }, [_c('span', {
      staticClass: "em",
      class: {
        'price': product.export
      },
      attrs: {
        "data-type": "export"
      }
    }, [_vm._v(_vm._s(product.export === null ? '免费' : product.export))])]), _vm._v(" "), (product.export) ? _c('span', [_vm._v("/个")]) : _vm._e()], 1), _vm._v(" "), _c('p', [_vm._v("自定义LOGO\n          "), _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": _vm.$t('tooltips.logo'),
        "popper-options": {
          removeOnDestroy: true
        },
        "open-delay": 200
      }
    }, [_c('span', {
      staticClass: "em",
      class: {
        'price': product.logo
      },
      attrs: {
        "data-type": "logo"
      }
    }, [_vm._v(_vm._s(product.logo === null ? '免费' : product.logo))])]), _vm._v(" "), (product.logo) ? _c('span', [_vm._v("/个")]) : _vm._e()], 1), _vm._v(" "), (product.sub_account) ? _c('p', [_vm._v("\n          子账号\n          "), _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": _vm.$t('tooltips.subAccount'),
        "popper-options": {
          removeOnDestroy: true
        },
        "open-delay": 200
      }
    }, [_c('span', {
      staticClass: "em",
      attrs: {
        "data-type": "subAccount"
      }
    }, [_vm._v(_vm._s(product.sub_account))])]), _vm._v("\n          个\n        ")], 1) : _vm._e(), _vm._v(" "), (product.custom_domain) ? _c('p', [_vm._v("支持独立域名")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "cdn feature"
    }, [_c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('p', [_vm._v("\n          CDN流量\n          "), _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": _vm.$t('tooltips.cdn'),
        "popper-options": {
          removeOnDestroy: true
        },
        "open-delay": 200
      }
    }, [_c('span', {
      staticClass: "em cdn",
      attrs: {
        "data-type": "cdn"
      }
    }, [_vm._v(_vm._s(product.cdn_amount))])]), _vm._v("\n          /年\n        ")], 1), _vm._v(" "), (product.custom_queue) ? _c('p', [_vm._v("专用转换队列")]) : _vm._e(), _vm._v(" "), (product.custom_encryption) ? _c('p', [_vm._v("企业级请求加密")]) : _vm._e(), _vm._v(" "), (product.custom_cdnspeedup) ? _c('p', [_vm._v("CDN优化加速")]) : _vm._e(), _vm._v(" "), (product.custom_cs) ? _c('p', [_vm._v("专属客服")]) : _vm._e(), _vm._v(" "), (product.online_tutor2) ? _c('p', [_vm._v("赠送1次线上培训")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "log feature"
    }, [_c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('p', [_vm._v("\n          数据报告\n          "), _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": _vm.$t('tooltips.report'),
        "popper-options": {
          removeOnDestroy: true
        },
        "open-delay": 200
      }
    }, [_c('span', {
      staticClass: "em",
      attrs: {
        "data-type": "report"
      }
    }, [_vm._v(_vm._s(_vm.$t(("reportType." + (product.report_type)))))])])], 1), _vm._v(" "), (product.data_export) ? _c('p', [_vm._v("数据导出")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "remark feature"
    }, [_c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('p', [_vm._v("表单答题")]), _vm._v(" "), _c('p', [_vm._v("微信录音")]), _vm._v(" "), _c('p', [_vm._v("音视频")]), _vm._v(" "), (product.wxpay) ? _c('p', [_vm._v("付费阅读")]) : _vm._e(), _vm._v(" "), (product.wechat_support) ? _c('p', [_vm._v("公众号推广")]) : _vm._e()])])
  })
}]}

/***/ }),
/* 896 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "permissions"
  }, [_c('table', {
    staticClass: "members-table"
  }, [_c('tr', [_c('th', [_vm._v("\n        所有成员\n      ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "width": "60%"
    }
  }, [_vm._m(2)], 1)]), _vm._v(" "), (_vm.loading) ? _c('tr', [_vm._m(3)]) : _vm._l((_vm.members), function(member) {
    return _c('tr', {
      key: member.id
    }, [_vm._o(_c('td', {
      staticClass: "profile"
    }, [_c('div', {
      staticClass: "img avatar",
      style: ({
        backgroundImage: 'url(' + member.user.profile_picture + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "nickname"
    }, [_vm._v(_vm._s(member.user.nickname))]), _vm._v(" "), _c('div', {
      staticClass: "email"
    }, [_vm._v(_vm._s(member.user.email))])]), 0, member.id), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('el-checkbox-group', {
      attrs: {
        "value": member.permissions.split(',')
      },
      on: {
        "input": function($event) {
          _vm.setPermissions(member.id, $event)
        }
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-checkbox', {
      attrs: {
        "label": "edit_members",
        "disabled": member.role === 'owner'
      }
    }, [_vm._v(" ")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-checkbox', {
      attrs: {
        "label": "view_members",
        "disabled": member.role === 'owner'
      }
    }, [_vm._v(" ")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-checkbox', {
      attrs: {
        "label": "view_projects",
        "disabled": member.role === 'owner'
      }
    }, [_vm._v(" ")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-checkbox', {
      attrs: {
        "label": "edit_projects",
        "disabled": member.role === 'owner'
      }
    }, [_vm._v(" ")])], 1)], 1)], 1)], 1)])
  })], 2), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "small": "",
      "layout": "prev, pager, next",
      "total": _vm.totalItems,
      "page-count": _vm.totalPages,
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "current-change": _vm.fetch
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(_vm._s(_vm.$t('browseProject')))])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(_vm._s(_vm.$t('editProject')))])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("管理账号")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("查看成员")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "loading-cell",
    attrs: {
      "colspan": "10"
    }
  }, [_c('div', {
    staticClass: "spinner-wrapper"
  }, [_c('i', {
    staticClass: "ppj-icon-spinner"
  })])])
}]}

/***/ }),
/* 897 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "convert-wrapper"
  }, [_c('h1', [_vm._v("正在生成中，大概需要 " + _vm._s(_vm.estimatedTime.lowerEt) + " - " + _vm._s(_vm.estimatedTime.upperEt) + " 分钟，请稍候...")]), _vm._v(" "), _c('div', {
    staticClass: "progress-wrapper"
  }, [_c('spinner', {
    staticClass: "spinner",
    attrs: {
      "size": 160,
      "text": _vm.$t(("project.state." + (_vm.project.state)))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "background-image img"
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$t('hint.project.convert.secondary')))]), _vm._v(" "), (!_vm.user.wechat_mp_connected && _vm.wxConnection.url && !_vm.tbcMode) ? _c('div', {
    staticClass: "qrcode wechat"
  }, [_c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: 'url(' + '//qrcode.ppj.io/' + _vm.wxConnection.url + ')'
    })
  }), _vm._v(" "), _c('p', {
    staticClass: "hint",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('qrcode.convert'))
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    staticClass: "access-setting",
    attrs: {
      "label": _vm.$t('actions.project.settings.access')
    }
  }, [_c('el-radio-group', {
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "disabled": _vm.disabled.none,
      "label": "none"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": !_vm.disabled.none,
      "effect": "dark",
      "content": _vm.disabled.msg,
      "placement": "top"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('actions.project.settings.accessTypes.none')))])])], 1), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "disabled": _vm.disabled.code,
      "label": "code"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": !_vm.disabled.code,
      "effect": "dark",
      "content": _vm.disabled.msg,
      "placement": "top"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('actions.project.settings.accessTypes.code')))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "access-content"
  }, [(_vm.type === 'none') ? _c('div', {
    staticClass: "none"
  }, [_c('p', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$t('hint.project.edit.access.none')))])]) : _vm._e(), _vm._v(" "), (_vm.type === 'code') ? _c('div', {
    staticClass: "code"
  }, [_c('el-form', {
    staticClass: "sub-form",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('actions.project.settings.accessLabels.code')
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": _vm.disabled.code,
      "placeholder": _vm.$t('placeholder.project.auth_config.code')
    },
    model: {
      value: (_vm.config.code),
      callback: function($$v) {
        _vm.config.code = $$v
      },
      expression: "config.code"
    }
  }, [_c('el-button', {
    staticClass: "random-code-btn",
    on: {
      "click": function($event) {
        _vm.randomCode('code')
      }
    },
    slot: "append"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('actions.project.settings.accessLabels.random')) + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('actions.project.settings.accessLabels.hint')
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": _vm.disabled.code,
      "placeholder": _vm.$t('placeholder.project.auth_config.hint')
    },
    model: {
      value: (_vm.config.hint),
      callback: function($$v) {
        _vm.config.hint = $$v
      },
      expression: "config.hint"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('actions.project.settings.accessLabels.previewPages')
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": _vm.disabled.code,
      "min": 0,
      "max": _vm.project.total_pages
    },
    model: {
      value: (_vm.config.preview_pages),
      callback: function($$v) {
        _vm.config.preview_pages = $$v
      },
      expression: "config.preview_pages"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'pay') ? _c('div', {
    staticClass: "pay"
  }, [_c('el-form', {
    staticClass: "sub-form",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', {
    slot: "label"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('actions.project.settings.accessLabels.price')) + "\n                "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://mp.weixin.qq.com/s/cyI_HAJp0P_fXOFHxZ_cdA"
    }
  }, [_c('i', {
    staticClass: "ppj-icon-help-circled"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "el-input",
    staticStyle: {
      "width": "180px"
    }
  }, [_c('vue-numeric', {
    staticClass: "el-input__inner",
    attrs: {
      "read-only": _vm.disabled.pay,
      "precision": 2,
      "currency": "￥"
    },
    model: {
      value: (_vm.price),
      callback: function($$v) {
        _vm.price = $$v
      },
      expression: "price"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('actions.project.settings.accessLabels.previewPages')
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": _vm.disabled.pay,
      "min": 0,
      "max": _vm.project.total_pages
    },
    model: {
      value: (_vm.config.preview_pages),
      callback: function($$v) {
        _vm.config.preview_pages = $$v
      },
      expression: "config.preview_pages"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'spell') ? _c('div', {
    staticClass: "spell"
  }, [_c('el-form', {
    staticClass: "sub-form",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('actions.project.settings.accessLabels.code')
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": _vm.disabled.spell,
      "placeholder": _vm.$t('placeholder.project.auth_config.code')
    },
    model: {
      value: (_vm.config.code),
      callback: function($$v) {
        _vm.config.code = $$v
      },
      expression: "config.code"
    }
  }, [_c('el-button', {
    staticClass: "random-code-btn",
    on: {
      "click": function($event) {
        _vm.randomCode('spell')
      }
    },
    slot: "append"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('actions.project.settings.accessLabels.random')) + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', {
    slot: "label"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('actions.project.settings.accessLabels.wechat')) + "\n                "), _c('a', {
    on: {
      "click": _vm.wechatTips
    }
  }, [_c('i', {
    staticClass: "ppj-icon-help-circled"
  })])]), _vm._v(" "), _c('el-input', {
    attrs: {
      "readonly": _vm.disabled.spell,
      "placeholder": _vm.$t('placeholder.project.auth_config.wechat')
    },
    model: {
      value: (_vm.config.wechat),
      callback: function($$v) {
        _vm.config.wechat = $$v
      },
      expression: "config.wechat"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', {
    slot: "label"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('actions.project.settings.accessLabels.spell')) + "\n              "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://mp.weixin.qq.com/s?__biz=MzAxNTc4NjY1NA==&mid=100000024&idx=1&sn=5433384086766586e47833b99260eadb&chksm=1bfff6e92c887fffad42d48ce2cc399796e31316ec85987f5d88f3692ba5e4790137ef9377be&mpshare=1&scene=23&srcid=11220bkdzdzMRr0b2hCt41Fs#rd"
    }
  }, [_c('i', {
    staticClass: "ppj-icon-help-circled"
  })])]), _vm._v(" "), _c('el-input', {
    attrs: {
      "readonly": _vm.disabled.spell,
      "placeholder": _vm.$t('placeholder.project.auth_config.spell')
    },
    model: {
      value: (_vm.config.wechat_spell),
      callback: function($$v) {
        _vm.config.wechat_spell = $$v
      },
      expression: "config.wechat_spell"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('actions.project.settings.accessLabels.previewPages')
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": _vm.disabled.spell,
      "min": 0,
      "max": _vm.project.total_pages
    },
    model: {
      value: (_vm.config.preview_pages),
      callback: function($$v) {
        _vm.config.preview_pages = $$v
      },
      expression: "config.preview_pages"
    }
  })], 1)], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 899 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary"
  }, [_c('div', {
    staticClass: "pane"
  }, [_c('table', {
    staticClass: "browse-count-table"
  }, [_vm._m(0), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.summary.pv.yesterday))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.summary.pv.today))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.summary.pv.total))])])])]), _vm._v(" "), _c('div', {
    staticClass: "pane"
  }, [_c('p', [_vm._v("来源统计")]), _vm._v(" "), _c('el-radio-group', {
    staticClass: "selector",
    model: {
      value: (_vm.tag),
      callback: function($$v) {
        _vm.tag = $$v
      },
      expression: "tag"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "today"
    }
  }, [_vm._v("今天")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "yesterday"
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "total"
    }
  }, [_vm._v("总计")])], 1), _vm._v(" "), (_vm.pvPercentageData) ? _c('div', {
    staticClass: "pv-percentage-chart chart-wrapper"
  }, [_c('bar-chart', {
    attrs: {
      "data": _vm.pvPercentageData[_vm.tag],
      "min": 0,
      "library": _vm.pvPercentageOptions
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v("用户阅读来源统计")])], 1) : _vm._e(), _vm._v(" "), (_vm.behaviorData) ? _c('div', {
    staticClass: "actions-chart chart-wrapper"
  }, [_c('column-chart', {
    staticClass: "actions-chart",
    attrs: {
      "data": _vm.behaviorData[_vm.tag],
      "library": _vm.behaviorOptions,
      "min": 0
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v("用户分享行为统计")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "pane"
  }, [_c('p', [_vm._v("浏览量走势")]), _vm._v(" "), (_vm.trendData) ? _c('line-chart', {
    staticClass: "pv-chart",
    attrs: {
      "data": _vm.trendData,
      "min": 0,
      "library": _vm.pvChartOptions
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("昨日浏览量")]), _vm._v(" "), _c('th', [_vm._v("今日浏览量")]), _vm._v(" "), _c('th', [_vm._v("总浏览量")])])
}]}

/***/ }),
/* 900 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wx-bind-view login-form"
  }, [_c('h1', [_vm._v("抱歉，该页面功能正在开发中...")])])
}]}

/***/ }),
/* 901 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-account"
  }, [_c('div', {
    staticClass: "infos pane"
  }, [_c('h1', {
    staticClass: "email"
  }, [_vm._v(_vm._s(_vm.user.email || _vm.user.cellphone))]), _vm._v(" "), _c('div', {
    staticClass: "sub-infos"
  }, [_c('div', {
    staticClass: "avatar img",
    style: ({
      'backgroundImage': 'url(' + _vm.user.profile_picture + ')'
    })
  }, [_c('ssuploader', {
    staticClass: "avatar-uploader-btn",
    attrs: {
      "defaultBtn": false,
      "url": _vm.avatarUploadUrl,
      "data": {
        '_method': 'PUT'
      },
      "name": "user[profile_picture]",
      "extensions": _vm.extensions,
      "accept": _vm.accept,
      "uploading": _vm.avatarOnUploading
    },
    on: {
      "update:uploading": function($event) {
        _vm.avatarOnUploading = $event
      },
      "complete": _vm.avatarUploadComplete
    }
  }), _vm._v(" "), (_vm.avatarOnUploading) ? _c('div', {
    staticClass: "ppj-icon-spinner",
    staticStyle: {
      "margin-left": "42.222222%",
      "margin-top": "42.2222222%"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('table', {
    staticClass: "text-table"
  }, [_c('tr', [_c('td', {
    staticClass: "label"
  }, [_vm._v("用户名称")]), _vm._v(" "), _c('td', {
    staticClass: "data"
  }, [_vm._v("\n            " + _vm._s(_vm.user.nickname) + "\n            "), _c('a', {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        _vm.rename()
      }
    }
  }, [_vm._v("修改")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("账户类型")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.$store.getters['user/organization'] ? '企业用户' : '个人账户') + "\n            ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("手机号")]), _vm._v(" "), (_vm.user.cellphone) ? _c('td', [_vm._v("\n            " + _vm._s(_vm.user.cellphone) + "\n            "), _c('a', {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        _vm.cellphoneDialog()
      }
    }
  }, [_vm._v("修改")])]) : _c('td', [_vm._v("\n            无\n            "), _c('a', {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        _vm.cellphoneDialog()
      }
    }
  }, [_vm._v("绑定手机号")])])]), _vm._v(" "), (_vm.user.occupation_verified) ? _c('tr', [_c('td', [_vm._v("教师认证")]), _vm._v(" "), _c('td', [_c('span', [_vm._v("已认证")]), _vm._v(" "), _c('router-link', {
    staticClass: "text-btn",
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "to": "/teacher"
    }
  }, [_vm._v("去认证")])], 1)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "quota pane"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("账户额度")]), _vm._v(" "), _c('div', {
    staticClass: "quota-item"
  }, [(_vm.quotas.permanents === null) ? _c('span', {
    staticClass: "numbers"
  }, [_vm._v("无限制")]) : _c('span', {
    staticClass: "numbers"
  }, [_vm._v("\n          " + _vm._s(_vm.quotas.permanents_left) + "/" + _vm._s(_vm.quotas.permanents) + "\n      ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "quota-item"
  }, [(_vm.quotas.logos === null) ? _c('span', {
    staticClass: "numbers"
  }, [_vm._v("无限制")]) : _c('span', {
    staticClass: "numbers"
  }, [_vm._v("\n            " + _vm._s(_vm.quotas.logos_left) + "/" + _vm._s(_vm.quotas.logos) + "\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("LOGO 设置")])]), _vm._v(" "), _c('div', {
    staticClass: "quota-item"
  }, [(_vm.quotas.exports === null) ? _c('span', {
    staticClass: "numbers"
  }, [_vm._v("无限制")]) : _c('span', {
    staticClass: "numbers"
  }, [_vm._v("\n            " + _vm._s(_vm.quotas.exports_left) + "/" + _vm._s(_vm.quotas.exports) + "\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("导出次数")])])]), _vm._v(" "), _c('div', {
    staticClass: "actions pane"
  }, [_c('table', [_c('tr', [_c('td', [_vm._v("微信绑定")]), _vm._v(" "), _c('td', [(_vm.user.wechat_nickname) ? _c('span', {
    staticStyle: {
      "margin-left": "1.5em"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.user.wechat_nickname) + "\n              "), _c('a', {
    staticClass: "text-btn",
    on: {
      "click": _vm.wxDisconnected
    }
  }, [_vm._v("解除绑定")])]) : _c('a', {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        _vm.wxConnectionDialog()
      }
    }
  }, [_vm._v("去绑定")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("密码")]), _vm._v(" "), _c('td', [_c('a', {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        _vm.changePasswordDialog()
      }
    }
  }, [_vm._v("修改密码")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "sub-title"
  }, [_vm._v(_vm._s(_vm.$t('projectQuota')))])
}]}

/***/ }),
/* 902 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-view login-form"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('actions.login.title')))]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "emailOrCellphone",
      "error": _vm.errors.first('emailOrCellphone')
    }
  }, [_c('el-input', {
    attrs: {
      "name": "ppj-account",
      "placeholder": _vm.$t('placeholder.user.emailOrCellphone')
    },
    model: {
      value: (_vm.form.emailOrCellphone),
      callback: function($$v) {
        _vm.form.emailOrCellphone = $$v
      },
      expression: "form.emailOrCellphone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password",
      "error": _vm.errors.first('password')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('placeholder.user.password')
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.form.password = $$v
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary submit-btn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.signIn($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.login.login')))])], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "left"
  }, [_c('router-link', {
    attrs: {
      "to": "/wxlogin"
    }
  }, [_c('i', {
    staticClass: "ppj-icon-wechat",
    staticStyle: {
      "margin-right": "0.5em"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('actions.login.wxlogin')) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.login.register')))]), _vm._v(" |\n        "), _c('router-link', {
    attrs: {
      "to": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.login.password')))])], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 903 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting-form"
  }, [_c('el-form', {
    staticClass: "settings-form",
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), (!_vm.expired && !_vm.locked && !_vm.readonly) ? _c('router-link', {
    staticClass: "reupload-btn el-tabs__item",
    attrs: {
      "to": {
        name: 'project_upload',
        params: {
          id: _vm.project.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "ppj-icon-up-big"
  }), _vm._v("更新PPT\n    ")]) : _vm._e(), _vm._v(" "), _c('el-tabs', {
    staticClass: "tabs",
    attrs: {
      "theme": "info",
      "value": _vm.tbcMode ? 'third' : 'first'
    }
  }, [(!_vm.tbcMode) ? _c('el-tab-pane', {
    attrs: {
      "label": "常用设置",
      "name": "first"
    }
  }, [_c('el-form-item', {
    staticClass: "wechat-share",
    attrs: {
      "label": _vm.$t('actions.project.settings.wxshare')
    }
  }, [_c('image-uploader', {
    staticClass: "cover-wrapper",
    attrs: {
      "title": _vm.$t('actions.project.settings.wxcover'),
      "tag": "cover"
    },
    model: {
      value: (_vm.cover),
      callback: function($$v) {
        _vm.cover = $$v
      },
      expression: "cover"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inputs"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('placeholder.project.title')
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.form.title = $$v
      },
      expression: "form.title"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "resize": "false",
      "placeholder": _vm.$t('placeholder.project.description')
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.form.description = $$v
      },
      expression: "form.description"
    }
  })], 1)], 1), _vm._v(" "), _c('bgm-setting', {
    ref: "bgm-setting",
    model: {
      value: (_vm.bgmSetting),
      callback: function($$v) {
        _vm.bgmSetting = $$v
      },
      expression: "bgmSetting"
    }
  }), _vm._v(" "), _c('logo-setting', {
    ref: "logo-setting",
    attrs: {
      "editable": _vm.form.allow_to_modify_logo
    },
    model: {
      value: (_vm.logoSetting),
      callback: function($$v) {
        _vm.logoSetting = $$v
      },
      expression: "logoSetting"
    }
  }), _vm._v(" "), _c('permanent-setting', {
    ref: "permanent-setting"
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.tbcMode) ? _c('el-tab-pane', {
    attrs: {
      "label": "高级设置",
      "name": "second"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('actions.project.settings.arrow')
    }
  }, [_c('el-switch', {
    staticClass: "arrow-switch",
    attrs: {
      "width": 35,
      "theme": "info",
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.arrowMode),
      callback: function($$v) {
        _vm.arrowMode = $$v
      },
      expression: "arrowMode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "tansition-ctrl",
    attrs: {
      "label": "翻页控制"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.form.transition_ctrl),
      callback: function($$v) {
        _vm.form.transition_ctrl = $$v
      },
      expression: "form.transition_ctrl"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "click"
    }
  }, [_vm._v("\n              默认手动\n            ")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "strict"
    }
  }, [_vm._v("\n              还原PPT\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "auto-play",
    attrs: {
      "label": _vm.$t('actions.project.settings.autoplayLabel')
    }
  }, [_c('el-radio-group', {
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.form.auto_play),
      callback: function($$v) {
        _vm.form.auto_play = $$v
      },
      expression: "form.auto_play"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "enabled"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('actions.project.settings.autoplay.enabled')) + "\n            ")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "original"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('actions.project.settings.autoplay.original')) + "\n            ")])], 1)], 1), _vm._v(" "), _c('access-setting', {
    ref: "access-setting",
    attrs: {
      "project": _vm.project
    },
    model: {
      value: (_vm.accessSetting),
      callback: function($$v) {
        _vm.accessSetting = $$v
      },
      expression: "accessSetting"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tbcMode) ? _c('el-tab-pane', {
    attrs: {
      "label": "常用设置",
      "name": "third"
    }
  }, [_c('el-form-item', {
    staticClass: "wechat-share",
    attrs: {
      "label": _vm.$t('actions.project.settings.wxshare')
    }
  }, [_c('image-uploader', {
    staticClass: "cover-wrapper",
    attrs: {
      "title": _vm.$t('actions.project.settings.wxcover'),
      "tag": "cover"
    },
    model: {
      value: (_vm.cover),
      callback: function($$v) {
        _vm.cover = $$v
      },
      expression: "cover"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inputs"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('placeholder.project.title')
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.form.title = $$v
      },
      expression: "form.title"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "resize": "false",
      "placeholder": _vm.$t('placeholder.project.description')
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.form.description = $$v
      },
      expression: "form.description"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('actions.project.settings.arrow')
    }
  }, [_c('el-switch', {
    staticClass: "arrow-switch",
    attrs: {
      "width": 35,
      "theme": "info",
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.arrowMode),
      callback: function($$v) {
        _vm.arrowMode = $$v
      },
      expression: "arrowMode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "tansition-ctrl",
    attrs: {
      "label": "翻页控制"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.form.transition_ctrl),
      callback: function($$v) {
        _vm.form.transition_ctrl = $$v
      },
      expression: "form.transition_ctrl"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "click"
    }
  }, [_vm._v("\n              默认手动\n            ")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "strict"
    }
  }, [_vm._v("\n              还原PPT\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "auto-play",
    attrs: {
      "label": _vm.$t('actions.project.settings.autoplayLabel')
    }
  }, [_c('el-radio-group', {
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.form.auto_play),
      callback: function($$v) {
        _vm.form.auto_play = $$v
      },
      expression: "form.auto_play"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "enabled"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('actions.project.settings.autoplay.enabled')) + "\n            ")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "original"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('actions.project.settings.autoplay.original')) + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "page-setup",
    attrs: {
      "label": _vm.$t('actions.project.settings.stretch')
    }
  }, [_c('el-radio-group', {
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.form.stretch_mode),
      callback: function($$v) {
        _vm.form.stretch_mode = $$v
      },
      expression: "form.stretch_mode"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "auto"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('actions.project.settings.stretchValue.auto')) + "\n            ")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "fullscreen"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('actions.project.settings.stretchValue.fullscreen')) + "\n            ")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "restrict"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('actions.project.settings.stretchValue.restrict')) + "\n            ")])], 1)], 1), _vm._v(" "), _c('bgm-setting', {
    ref: "bgm-setting",
    model: {
      value: (_vm.bgmSetting),
      callback: function($$v) {
        _vm.bgmSetting = $$v
      },
      expression: "bgmSetting"
    }
  }), _vm._v(" "), (_vm.project.tbc) ? _c('el-form-item', {
    attrs: {
      "label": "观看设置"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.form.tbc.public),
      callback: function($$v) {
        _vm.form.tbc.public = $$v
      },
      expression: "form.tbc.public"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": true
    }
  }, [_vm._v("\n              公开\n            ")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": false
    }
  }, [_vm._v("\n              内部\n            ")])], 1), _vm._v(" "), _c('div', [(_vm.form.tbc.public) ? _c('p', {
    staticClass: "hint"
  }, [_vm._v("所有人都可以通过分享出去的H5链接查看微课")]) : _vm._e(), _vm._v(" "), (!_vm.form.tbc.public) ? _c('p', {
    staticClass: "hint"
  }, [_vm._v("需要验证网络学院账号才可以查看微课")]) : _vm._e()])], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.save')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.project.settings.cancel')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 904 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "edit-member-dialog",
    attrs: {
      "title": "编辑成员信息",
      "size": "small",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "成员姓名",
      "disabled": ""
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6,
      "offset": 1
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.role === 'owner'
    },
    model: {
      value: (_vm.role),
      callback: function($$v) {
        _vm.role = $$v
      },
      expression: "role"
    }
  }, _vm._l((_vm.roles), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": _vm.$t(("organization.roles." + item)),
        "value": item,
        "disabled": item === 'owner'
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱地址"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "邮箱地址",
      "disabled": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属部门"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.department),
      callback: function($$v) {
        _vm.department = $$v
      },
      expression: "department"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.ok')))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 905 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-income"
  }, [_c('div', {
    staticClass: "summary pane"
  }, [_c('table', [_c('tr', {
    staticClass: "number"
  }, [_c('td', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.priceReadableInHtml(_vm.user.total_income))
    }
  })]), _vm._v(" "), _c('td', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.priceReadableInHtml(Number(_vm.user.total_income) - Number(_vm.user.balance)))
    }
  })]), _vm._v(" "), _c('td', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.priceReadableInHtml(_vm.user.balance))
    }
  })]), _vm._v(" "), _c('td')]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "withdraws"
  }, [_vm._m(1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.withdrawData
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.dateReadable(scope.row.created_at)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "总额",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.priceReadableInHtml(scope.row.amount))
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payment_method",
      "label": "转出账号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "state",
      "label": "状态"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "details pane"
  }, [_vm._m(2), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.formData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('projectName'),
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "当前价格"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.priceReadableInHtml(scope.row.pay_to_read_price))
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "view_rights_count",
      "label": "付费人数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "总收入"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.priceReadableInHtml(scope.row.total_income))
          }
        })]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "label"
  }, [_c('td', [_vm._v("总收入")]), _vm._v(" "), _c('td', [_vm._v("已提现")]), _vm._v(" "), _c('td', [_vm._v("余额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_vm._v("\n        提现记录\n        "), _c('a', {
    staticClass: "text-btn",
    staticStyle: {
      "margin-left": "1em"
    },
    attrs: {
      "href": "http://ppj.io/docs/#/feedback",
      "target": "_blank"
    }
  }, [_vm._v("申请提现")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('projectIncome')))])
}]}

/***/ }),
/* 906 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "quotas-required-dialog",
    attrs: {
      "title": "永久项目额度不足",
      "size": "small",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.close
    }
  }, [(_vm.organization) ? _c('div', [(_vm.overdate) ? _c('p', [_vm._v("企业套餐已过期，请联系管理员续费或升级")]) : _c('p', [_vm._v("企业套餐额度不足，请联系管理员续费或升级")])]) : _c('div', [_c('p', [_vm._v("您的永久项目额度不足，如果继续将会创建临时项目。临时项目会免费浏览8小时，之后会自动删除。\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("您可以通过以下方式增加永久项目额度：")]), _vm._v(" "), _c('p', [_vm._v("\n      1. 购买单次项目额度；\n    ")]), _vm._v(" "), _c('p', [_vm._v("2. 购买会员套餐，升级账户；"), _c('a', {
    staticClass: "recommand",
    attrs: {
      "href": "/price?closeOnPQuota=true",
      "target": "_blank"
    }
  }, [_vm._v("查看优惠")])])]), _vm._v(" "), _c('div', {
    staticClass: "buttons",
    slot: "footer"
  }, [(_vm.organization) ? _c('div', [_c('a', {
    staticClass: "el-button el-button--primary",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("关闭")])]) : _c('div', [_c('a', {
    staticClass: "el-button el-button--text",
    attrs: {
      "href": "/price?closeOnPQuota=true",
      "target": "_blank"
    }
  }, [_vm._v("购买会员")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.purchase
    }
  }, [_vm._v("购买单次额度")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 907 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category"
  }, [_c('selector', {
    attrs: {
      "category": _vm.category,
      "categories": _vm.categories
    }
  }), _vm._v(" "), (_vm.category) ? _c('info', {
    attrs: {
      "category": _vm.category
    },
    on: {
      "edit": function($event) {
        _vm.$editCategory(_vm.category)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-view"
  }, [_c('div', {
    staticClass: "nav"
  }, [(!_vm.tbcMode) ? _c('router-link', {
    staticClass: "return-btn",
    attrs: {
      "to": _vm.upperPath || '/'
    }
  }, [_c('i', {
    staticClass: "ppj-icon-angle-left"
  }), _vm._v(_vm._s(_vm.$t('common.buttons.return')) + "\n    ")]) : _vm._e()], 1), _vm._v(" "), (_vm.loaded) ? _c('router-view', {
    staticClass: "sub-project-view"
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 909 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "project-created-data",
    attrs: {
      "span": 16,
      "offset": 1
    }
  }, [_c('div', {
    staticClass: "select-bar"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('createProjectNum')))]), _vm._v(" "), _c('el-select', {
    staticClass: "select-box",
    attrs: {
      "placeholder": _vm.$t('common.placeholder.plzChoose')
    },
    model: {
      value: (_vm.projectsCreatedPeriod),
      callback: function($$v) {
        _vm.projectsCreatedPeriod = $$v
      },
      expression: "projectsCreatedPeriod"
    }
  }, _vm._l((_vm.periods), function(p) {
    return _c('el-option', {
      key: p,
      attrs: {
        "label": _vm.$t("periods.past") + _vm.$t(("periods." + p)),
        "value": p
      }
    })
  }))], 1), _vm._v(" "), _c('line-chart', {
    staticClass: "pv-chart",
    attrs: {
      "data": _vm.projectsCreatedData,
      "min": 0,
      "library": _vm.projectsCreatedChartOptions
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "summary",
    attrs: {
      "span": 5,
      "offset": 1
    }
  }, [_c('div', {
    staticClass: "item blue"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.quotas.members))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "item orange"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.summary.projects))]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "item green"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.summary.pv))]), _vm._v(" "), _vm._m(2)])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 1
    }
  }, [_vm._m(3), _vm._v(" "), _c('el-table', {
    staticClass: "recent-projects",
    attrs: {
      "data": _vm.recentProjects,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('projectName')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user.nickname",
      "label": _vm.$t('projectCreator')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('projectCreatedDate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.dateReadable(scope.row.created_at)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pv",
      "label": _vm.$t('projectPV')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('common.tablehead.action')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticClass: "text-btn",
          on: {
            "click": function($event) {
              _vm.projectDialog(scope.row)
            }
          }
        }, [_vm._m(4)])]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('packageAccountsTotalNum')))])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('projectsTotalNum')))])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('projectsTotalPV')))])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-weight": "600",
      "margin": "2em 1em"
    }
  }, [_vm._v(_vm._s(_vm.$t('recentCreateProjectList')))])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm.$t('seeAndShare')))])
}]}

/***/ }),
/* 910 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ss-uploader-wrapper",
    class: {
      'hide': !_vm.defaultBtn
    }
  }, [_vm._t("default", [_c('el-button', {
    staticClass: "ssfileupload",
    attrs: {
      "type": _vm.btnType,
      "plain": _vm.btnPlain,
      "size": "large",
      "disabled": _vm.onUploading
    }
  }, [_vm._v("\n      " + _vm._s(_vm.onUploading ? _vm.onUploadingLabel : _vm.label) + "\n    ")])])], 2)
},staticRenderFns: []}

/***/ }),
/* 911 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "profile-account-cellphone-dialog",
    attrs: {
      "title": "手机号认证",
      "size": "tiny",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('p', {
    staticClass: "hint"
  }, [_vm._v("绑定手机号可以用来登录和找回密码。")]), _vm._v(" "), _c('el-form', {
    ref: "cellphone"
  }, [_c('cellphone-input', {
    ref: "cellphoneInput",
    attrs: {
      "cellphone": _vm.cellphone,
      "captcha": _vm.captcha
    },
    on: {
      "update:cellphone": function($event) {
        _vm.cellphone = $event
      },
      "update:captcha": function($event) {
        _vm.captcha = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v("提交")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 912 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "change_password",
    attrs: {
      "title": "修改密码",
      "size": "small",
      "visible": _vm.dialogVisible
    },
    on: {
      "close": _vm.close,
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "oldPassword",
      "error": _vm.errors.first('oldPassword')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('placeholder.user.oldPassword')
    },
    model: {
      value: (_vm.form.oldPassword),
      callback: function($$v) {
        _vm.form.oldPassword = $$v
      },
      expression: "form.oldPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "newPassword",
      "error": _vm.errors.first('newPassword')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": _vm.$t('placeholder.user.newPassword')
    },
    model: {
      value: (_vm.form.newPassword),
      callback: function($$v) {
        _vm.form.newPassword = $$v
      },
      expression: "form.newPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "passwordConfirmation",
      "error": _vm.errors.first('passwordConfirmation')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('placeholder.user.passwordConfirmation')
    },
    model: {
      value: (_vm.form.passwordConfirmation),
      callback: function($$v) {
        _vm.form.passwordConfirmation = $$v
      },
      expression: "form.passwordConfirmation"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 913 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-dialog"
  }, [_c('el-dialog', {
    attrs: {
      "size": "tiny",
      "visible": _vm.dialogVisible
    },
    on: {
      "close": function($event) {
        _vm.dialogVisible = false
      },
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "qrcode-wrapper"
  }, [_c('img', {
    staticClass: "qrcode",
    attrs: {
      "src": '//qrcode.ppj.io/' + _vm.link
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$t('qrcode.project')))]), _vm._v(" "), _c('div', {
    staticClass: "link-info"
  }, [_c('el-input', {
    staticClass: "link-input",
    attrs: {
      "placeholder": _vm.$t('placeholder.project.viewer_url'),
      "readonly": ""
    },
    model: {
      value: (_vm.link),
      callback: function($$v) {
        _vm.link = $$v
      },
      expression: "link"
    }
  }, [_c('div', {
    staticClass: "append-buttons",
    slot: "append"
  }, [_c('a', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.link),
      expression: "link",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }],
    staticClass: "copy el-button"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('common.buttons.copy')) + "\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "preview el-button",
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('common.buttons.preview')) + "\n              ")])])])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 914 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats"
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('el-menu', {
    staticClass: "theme-primary",
    attrs: {
      "default-active": _vm.$route.path,
      "router": ""
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": ("/projects/" + _vm.id + "/stats")
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('actions.project.stats.data')) + "\n      ")]), _vm._v(" "), (_vm.project.has_form) ? _c('el-menu-item', {
    attrs: {
      "index": ("/projects/" + _vm.id + "/stats/form")
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('actions.project.stats.form')) + "\n      ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('router-view', {
    staticClass: "sub-stats"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 915 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    staticClass: "bgm-setting",
    attrs: {
      "label": _vm.$t('actions.project.settings.bgmLabel')
    }
  }, [(!_vm.name) ? _c('div', [_c('el-button', {
    attrs: {
      "plain": true,
      "type": "primary"
    },
    on: {
      "click": _vm.editBgm
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.project.settings.bgm.submit')))]), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$t('hint.project.edit.bgm')))])], 1) : _c('div', {
    staticClass: "bgm-player"
  }, [_c('el-popover', {
    ref: "volume-popover",
    attrs: {
      "placement": "right",
      "trigger": "click",
      "width": "40",
      "popper-class": "vertical"
    }
  }, [_c('el-slider', {
    attrs: {
      "vertical": "",
      "height": "100px"
    },
    model: {
      value: (_vm.volume),
      callback: function($$v) {
        _vm.volume = $$v
      },
      expression: "volume"
    }
  })], 1), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.paused),
      expression: "!paused"
    }],
    staticClass: "player-btn",
    on: {
      "click": function($event) {
        _vm.player.pause();
        _vm.paused = true
      }
    }
  }, [_c('i', {
    staticClass: "ppj-icon-pause"
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paused),
      expression: "paused"
    }],
    staticClass: "player-btn",
    on: {
      "click": function($event) {
        _vm.player.play();
        _vm.paused = false
      }
    }
  }, [_c('i', {
    staticClass: "ppj-icon-play"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', {
    staticClass: "btn-group"
  }, [_c('a', {
    directives: [{
      name: "popover",
      rawName: "v-popover:volume-popover",
      arg: "volume-popover"
    }],
    staticClass: "volume-btn btn"
  }, [_vm._v("音量")]), _vm._v(" "), _c('a', {
    staticClass: "remove-btn btn",
    on: {
      "click": function($event) {
        _vm.setData()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.delete')))])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 916 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-view"
  }, [_c('div', {
    staticClass: "upload-wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.onUploading),
      expression: "!onUploading"
    }],
    staticClass: "before-upload"
  }, [_c('div', {
    staticClass: "upload-image img"
  }), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$t('supportFormat')))]), _vm._v(" "), _c('div', {
    staticClass: "uploader-btn"
  }, [(_vm.uploader === 'qiniu') ? _c('qiniuuploader', {
    attrs: {
      "btnType": "primary",
      "btnPlain": false,
      "label": _vm.$t('chooseSubmit'),
      "url": _vm.targetUrl,
      "accept": _vm.accept,
      "extensions": _vm.allowedExtensions,
      "filename": _vm.filename,
      "filesize": _vm.filesize,
      "progress": _vm.progress,
      "uploading": _vm.onUploading
    },
    on: {
      "update:filename": function($event) {
        _vm.filename = $event
      },
      "update:filesize": function($event) {
        _vm.filesize = $event
      },
      "update:progress": function($event) {
        _vm.progress = $event
      },
      "update:uploading": function($event) {
        _vm.onUploading = $event
      },
      "complete": _vm.uploadDone,
      "error": _vm.uploadFail
    }
  }) : (_vm.uploader === 'nginx') ? _c('nginxuploader', {
    attrs: {
      "label": _vm.$t('chooseSubmit'),
      "url": _vm.targetUrl,
      "accept": _vm.accept,
      "extensions": _vm.allowedExtensions,
      "filename": _vm.filename,
      "filesize": _vm.filesize,
      "progress": _vm.progress,
      "uploading": _vm.onUploading
    },
    on: {
      "update:filename": function($event) {
        _vm.filename = $event
      },
      "update:filesize": function($event) {
        _vm.filesize = $event
      },
      "update:progress": function($event) {
        _vm.progress = $event
      },
      "update:uploading": function($event) {
        _vm.onUploading = $event
      },
      "complete": _vm.uploadDone,
      "error": _vm.uploadFail
    }
  }) : (_vm.uploader === 'ss') ? _c('ssuploader', {
    attrs: {
      "btnType": "primary",
      "btnPlain": false,
      "label": _vm.$t('chooseSubmit'),
      "url": _vm.targetUrl,
      "accept": _vm.accept,
      "extensions": _vm.allowedExtensions,
      "filename": _vm.filename,
      "filesize": _vm.filesize,
      "progress": _vm.progress,
      "uploading": _vm.onUploading
    },
    on: {
      "update:filename": function($event) {
        _vm.filename = $event
      },
      "update:filesize": function($event) {
        _vm.filesize = $event
      },
      "update:progress": function($event) {
        _vm.progress = $event
      },
      "update:uploading": function($event) {
        _vm.onUploading = $event
      },
      "complete": _vm.uploadDone,
      "error": _vm.uploadFail
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.onUploading),
      expression: "onUploading"
    }],
    staticClass: "uploading"
  }, [_c('div', {
    staticClass: "upload-image img"
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-area"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('p', [_vm._v(_vm._s(_vm.filename))])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('p', [_vm._v(_vm._s(_vm.sizeReadable(_vm.filesize)))])]), _vm._v(" "), _c('el-progress', {
    attrs: {
      "text-inside": true,
      "stroke-width": 18,
      "percentage": _vm.progress
    }
  })], 1), _vm._v(" "), (!_vm.tbcMode) ? _c('div', {
    staticClass: "uploading-hint"
  }, [_vm._m(0)]) : _vm._e()])]), _vm._v(" "), (!_vm.tbcMode) ? _c('div', {
    staticClass: "tempaltes-frame"
  }, [_c('div', {
    staticClass: "qrcode"
  }, [_c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: 'url(' + '//qrcode.ppj.io/http://h5.ppj.io/yhiCzynw/index.html?v=10)'
    })
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hint"
  }, [_vm._v("上传遇到问题？请更换\n          "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "http://ppj.io/docs/#/browsers",
      "target": "_blank"
    }
  }, [_vm._v("\n              其他浏览器")]), _vm._v(" 重试，或\n          "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "http://ppj.io/docs/#/feedback",
      "target": "_blank"
    }
  }, [_vm._v("联系我们")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hint"
  }, [_vm._v("PPT也能做竖版？"), _c('br'), _vm._v("1分钟成为H5达人！")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "links"
  }, [_c('a', {
    staticClass: "text-btn template",
    attrs: {
      "href": "https://pan.baidu.com/s/1gfN4jJl",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "ppj-icon-gift"
  }), _vm._v("福利！海量H5模板下载")])])
}]}

/***/ }),
/* 917 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-container",
    class: {
      'white': _vm.$route.meta.noSession, 'fullscreen': _vm.$route.meta.fullscreen, 'tbc-mode': _vm.tbcMode
    }
  }, [(!_vm.tbcMode && !_vm.embedMode) ? _c('headbar') : _vm._e(), _vm._v(" "), (!_vm.$route.meta.noSession && !_vm.embedMode && !_vm.tbcMode) ? _c('hintbox') : _vm._e(), _vm._v(" "), _c('router-view', {
    staticClass: "page-container"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 918 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    staticClass: "category-dialog",
    attrs: {
      "title": _vm.category.id ? _vm.$t('actions.category.edit') : _vm.$t('actions.category.new'),
      "size": "small",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('image-uploader', {
    staticClass: "cover-wrapper",
    attrs: {
      "title": _vm.$t('actions.category.cover')
    },
    on: {
      "click": _vm.openMediaImageDialog
    },
    model: {
      value: (_vm.category.cover),
      callback: function($$v) {
        _vm.category.cover = $$v
      },
      expression: "category.cover"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inputs"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('placeholder.category.name')
    },
    model: {
      value: (_vm.category.name),
      callback: function($$v) {
        _vm.category.name = $$v
      },
      expression: "category.name"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "resize": "false",
      "placeholder": _vm.$t('placeholder.category.description')
    },
    model: {
      value: (_vm.category.description),
      callback: function($$v) {
        _vm.category.description = $$v
      },
      expression: "category.description"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "publicity"
  }, [_c('el-checkbox', {
    staticClass: "publicity",
    model: {
      value: (_vm.category.publicity),
      callback: function($$v) {
        _vm.category.publicity = $$v
      },
      expression: "category.publicity"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('actions.category.publicity')) + "\n          "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://mp.weixin.qq.com/s/jXd74hGwEVlXEiGtPHW8cQ"
    }
  }, [_c('i', {
    staticClass: "ppj-icon-help-circled"
  })])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "buttons",
    slot: "footer"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.category.id),
      expression: "category.id"
    }],
    staticClass: "left",
    attrs: {
      "type": "danger",
      "plain": true
    },
    on: {
      "click": _vm.removeGroup
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.category.remove')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.update()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.ok')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 919 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "password-view login-form"
  }, [(!_vm.mailSended) ? _c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t('actions.findPassword.title')))]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.findType),
      callback: function($$v) {
        _vm.findType = $$v
      },
      expression: "findType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "email"
    }
  }, [_vm._v("账号邮箱")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "cellphone"
    }
  }, [_vm._v("用户手机号")])], 1)], 1), _vm._v(" "), (_vm.findType === 'email') ? _c('el-form-item', {
    attrs: {
      "prop": "email",
      "error": _vm.errors.first('email')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('actions.findPassword.placeholder')
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.findType === 'cellphone') ? _c('cellphone-input', {
    ref: "cellphoneInput",
    attrs: {
      "cellphone": _vm.cellphone,
      "captcha": _vm.captcha,
      "reset": true
    },
    on: {
      "update:cellphone": function($event) {
        _vm.cellphone = $event
      },
      "update:captcha": function($event) {
        _vm.captcha = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary submit-btn"
    },
    on: {
      "click": function($event) {
        _vm.resetPassword()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(("actions.findPassword.submit." + _vm.findType))) + "\n        ")])], 1), _vm._v(" "), _c('el-form-item', [_c('router-link', {
    attrs: {
      "to": "login"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.findPassword.returnLogin')))])], 1)], 1)], 1) : _c('div', [_c('div', {
    staticClass: "password-sended img"
  }), _vm._v(" "), _c('h1', {
    staticClass: "hint-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('actions.findPassword.sended.title', {
    email: _vm.form.email
  })) + "\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$t('actions.findPassword.sended.hint')) + "   \n      "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "login"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.findPassword.returnLogin')))])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 920 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-uploader-wrapper"
  }, [(_vm.image) ? _c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: 'url(' + _vm.image + ')'
    })
  }) : _c('div', {
    staticClass: "img default"
  }), _vm._v(" "), _c('el-button', {
    staticClass: "media-btn",
    on: {
      "click": _vm.openMediaImageDialog
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.title || _vm.$t('actions.imageUploader.defaultCoverHint')))])], 1)
},staticRenderFns: []}

/***/ }),
/* 921 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-wrapper"
  }, [_c('h1'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v("文件内容无法识别，可能已损坏。请重新保存再上传。")]), _vm._v(" "), _c('router-link', {
    staticClass: "el-button el-button--primary el-button--large",
    attrs: {
      "to": {
        name: 'project_upload',
        params: {
          id: _vm.project.id
        }
      }
    }
  }, [_vm._v("\n    重新上传\n  ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-wrapper"
  }, [_c('div', {
    staticClass: "mock-circle"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("出错啦")])]), _vm._v(" "), _c('div', {
    staticClass: "background-image img"
  })])
}]}

/***/ }),
/* 922 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.readOnly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    ref: "numeric",
    attrs: {
      "placeholder": _vm.placeholder,
      "type": "tel"
    },
    domProps: {
      "value": _vm.value,
      "value": (_vm.amount)
    },
    on: {
      "blur": _vm.formatValue,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }, function($event) {
        _vm.processValue(_vm.amountValue)
      }],
      "focus": function($event) {
        _vm.convertToNumber(_vm.numberValue)
      }
    }
  }) : _c('span', {
    ref: "readOnly"
  }, [_vm._v(" " + _vm._s(_vm.amount) + " ")])
},staticRenderFns: []}

/***/ }),
/* 923 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qiniu-uploader-wrapper",
    attrs: {
      "id": "qiniu-uploader-wrapper"
    }
  }, [_c('el-button', {
    attrs: {
      "id": "qiniu-uploader-btn",
      "type": _vm.btnType,
      "plain": _vm.btnPlain,
      "size": "large",
      "disabled": _vm.onUploading
    }
  }, [_vm._v("\n    " + _vm._s(_vm.onUploading ? _vm.onUploadingLabel : _vm.label) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 924 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-card",
    class: {
      'hover': _vm.hover
    },
    on: {
      "mouseover": function($event) {
        _vm.hover = true
      },
      "mouseout": function($event) {
        _vm.hover = false
      }
    }
  }, [_c('div', {
    staticClass: "cover-wrapper"
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "status",
    class: {
      'expired': _vm.state === 'expired', 'temp': _vm.state === 'temp', 'completed': _vm.state === 'completed'
    }
  }, [_vm._v(_vm._s(_vm.$t(("project.state." + _vm.state))))]), _vm._v(" "), (_vm.project.thumbnail_url) ? _c('div', {
    staticClass: "img cover",
    style: ({
      backgroundImage: 'url(' + _vm.project.thumbnail_url + ')'
    })
  }) : _c('div', {
    staticClass: "img cover default"
  })]), _vm._v(" "), _c('div', {
    staticClass: "hover-actions-group"
  }, [_c('div', {
    staticClass: "qrcode",
    class: {
      'show': _vm.qrcode
    }
  }, [_c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: 'url(' + '//qrcode.ppj.io/' + _vm.project.viewer_url + ')'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "action",
    class: {
      'disabled': !_vm.available
    }
  }, [(_vm.available) ? _c('a', {
    staticClass: "block-btn",
    attrs: {
      "href": _vm.project.viewer_url,
      "target": "_blank"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.check')))])]) : _c('a', {
    staticClass: "block-btn"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t(("project.state." + _vm.state))))])])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.readonly),
      expression: "!readonly"
    }],
    staticClass: "action",
    attrs: {
      "to": ("/projects/" + (_vm.project.id)),
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ppj-icon-pencil"
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('common.buttons.edit')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.readonly),
      expression: "!readonly"
    }],
    staticClass: "action"
  }, [_c('a', {
    staticClass: "block-btn",
    on: {
      "click": _vm.alterSource
    }
  }, [_vm._m(2), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('actions.project.updatePPT')))])])])], 1), _vm._v(" "), (!_vm.project.permanent && !_vm.tbcMode) ? _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.readonly),
      expression: "!readonly"
    }],
    staticClass: "upgrade",
    attrs: {
      "plain": true
    },
    on: {
      "click": _vm.upgrade
    }
  }, [_c('i', {
    staticClass: "ppj-icon-star",
    staticStyle: {
      "margin-right": "0.4em"
    }
  }), _vm._v("升级永久\n    ")]) : _vm._e(), _vm._v(" "), (_vm.tbcMode && _vm.project.tbc && _vm.state === 'completed') ? _c('el-button', {
    staticClass: "publicity",
    attrs: {
      "plain": true
    },
    on: {
      "click": _vm.togglePublicity
    }
  }, [_c('i', {
    class: ("ppj-icon-" + (_vm.publicity ? 'lock-open-alt' : 'lock')),
    staticStyle: {
      "margin-right": "0.4em"
    }
  }), _vm._v(_vm._s(_vm.publicity ? '公开' : '内部') + "\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.tbcMode) ? _c('el-dropdown', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.readonly),
      expression: "!readonly"
    }],
    staticClass: "move-to",
    attrs: {
      "menu-align": "start"
    },
    on: {
      "command": _vm.moveTo
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v(_vm._s(_vm.$t('actions.project.moveTo'))), _c('i', {
    staticClass: "ppj-icon-down-dir"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "dropdown-wrapper",
    slot: "dropdown"
  }, [_c('div', {
    on: {
      "mouseover": function($event) {
        _vm.hover = true
      },
      "mouseout": function($event) {
        _vm.hover = false
      }
    }
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "all"
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.$t('actions.category.all')))])]), _vm._v(" "), _vm._l((_vm.categories), function(cat, index) {
    return _c('el-dropdown-item', {
      key: cat.id,
      attrs: {
        "command": ("" + (cat.id))
      }
    }, [_c('div', {
      staticClass: "item"
    }, [_vm._v(_vm._s(cat.name))])])
  }), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": "",
      "command": "new"
    }
  }, [_c('div', {
    staticClass: "item"
  }, [_c('i', {
    staticClass: "ppj-icon-plus"
  }), _vm._v(_vm._s(_vm.$t('actions.category.new')))])])], 2)])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-actions-group"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": _vm.organization && !_vm.tbcMode ? 20 : 24
    }
  }, [_c('p', {
    staticClass: "title",
    class: {
      'tbc': _vm.tbcMode
    }
  }, [_vm._v(_vm._s(_vm.project.name)), _c('span', {
    staticClass: "nickname"
  }, [_vm._v(_vm._s(_vm.project.user.nickname))])])]), _vm._v(" "), (_vm.organization && !_vm.tbcMode) ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "avatar-wrapper"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.project.user.nickname,
      "placement": "left",
      "popper-options": {
        removeOnDestroy: true
      },
      "open-delay": 200
    }
  }, [_c('div', {
    staticClass: "img avatar",
    style: ({
      backgroundImage: 'url(' + _vm.project.user.profile_picture + ')'
    })
  })])], 1)]) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('span', {
    staticClass: "sub-title"
  }, [_c('i', {
    staticClass: "ppj-icon-clock"
  }), _vm._v(_vm._s(_vm.dateReadable(_vm.project.created_at, true)))]), _vm._v(" "), _c('span', {
    staticClass: "sub-title right"
  }, [_c('i', {
    staticClass: "ppj-icon-eye"
  }), _vm._v(_vm._s(_vm.project.pv))])]), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "left"
  }, [(_vm.project.state === 'completed') ? _c('div', {
    staticClass: "btn qrcode",
    on: {
      "mouseover": function($event) {
        _vm.qrcode = true
      },
      "mouseout": function($event) {
        _vm.qrcode = false
      }
    }
  }, [_c('i', {
    staticClass: "ppj-icon-qrcode"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": "数据统计",
      "placement": "left",
      "popper-options": {
        removeOnDestroy: true
      }
    }
  }, [_c('div', {
    staticClass: "btn"
  }, [_c('router-link', {
    staticClass: "ppj-icon-chart-bar",
    attrs: {
      "to": ("/projects/" + (_vm.project.id) + "/stats"),
      "tag": "i"
    }
  })], 1)]), _vm._v(" "), _c('el-dropdown', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.readonly),
      expression: "!readonly"
    }],
    staticClass: "btn",
    attrs: {
      "menu-align": "start"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('i', {
    staticClass: "ppj-icon-ellipsis-vert"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "small",
    slot: "dropdown"
  }, [_c('div', {
    on: {
      "mouseover": function($event) {
        _vm.hover = true
      },
      "mouseout": function($event) {
        _vm.hover = false
      }
    }
  }, [_c('el-dropdown-item', [_c('div', {
    staticClass: "item",
    on: {
      "click": _vm.rename
    }
  }, [_c('i', {
    staticClass: "ppj-icon-pencil"
  }), _vm._v(_vm._s(_vm.$t('common.buttons.rename')) + "\n                ")])]), _vm._v(" "), _c('el-dropdown-item', [_c('div', {
    staticClass: "item",
    on: {
      "click": _vm.setThumbnail
    }
  }, [_c('i', {
    staticClass: "ppj-icon-file-image"
  }), _vm._v(_vm._s(_vm.$t('actions.project.alterCover')) + "\n                ")])]), _vm._v(" "), _c('el-dropdown-item', [_c('div', {
    staticClass: "item",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "ppj-icon-trash"
  }), _vm._v(_vm._s(_vm.$t('common.buttons.delete')) + "\n                ")])])], 1)])], 1)], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ppj-icon-eye"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ppj-icon-eye"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ppj-icon-arrows-cw"
  })])
}]}

/***/ }),
/* 925 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-dialog"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.$t('actions.project.settings.logo.title'),
      "size": "small",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#333"
    }
  }, [_vm._v(_vm._s(_vm.$t('hint.project.logo.main')))]), _vm._v(" "), (_vm.logosLeft === 0) ? _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.order.labels.price')
    }
  }, [_vm._v("\n        ￥ 99 / " + _vm._s(_vm.$t('common.project')) + "\n        "), _c('a', {
    staticClass: "price-link",
    attrs: {
      "href": "/price?closeOnPQuota=true",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "ppj-icon-gift"
  }), _vm._v("升级账户，100个项目去 logo 只需￥1999！")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.order.labels.payType')
    }
  }, [_c('el-radio-group', {
    staticClass: "payment",
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.payType),
      callback: function($$v) {
        _vm.payType = $$v
      },
      expression: "payType"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "wechat"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.order.wechat')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "alipay"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.order.alipay')))])], 1)], 1)], 1) : _c('div', {
    staticClass: "has-quotas"
  }, [_c('el-checkbox', {
    attrs: {
      "theme": "info",
      "checked": true,
      "disabled": true
    }
  }, [_vm._v("\n        使用账号修改Logo额度（" + _vm._s(_vm.logosLeft === null ? '不限次数' : ("还剩" + _vm.logosLeft + "次")) + "）\n      ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.placeOrder()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.submit')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 926 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "media-image-dialog",
    attrs: {
      "title": _vm.$t('title'),
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.close
    }
  }, [_c('el-tabs', {
    on: {
      "tab-click": function($event) {
        _vm.selected = null;
        _vm.fetchData()
      }
    },
    model: {
      value: (_vm.currentTag),
      callback: function($$v) {
        _vm.currentTag = $$v
      },
      expression: "currentTag"
    }
  }, _vm._l((_vm.tags), function(tag) {
    return _c('el-tab-pane', {
      key: tag,
      staticClass: "image-content",
      attrs: {
        "label": _vm.$t(("tags." + tag)),
        "name": tag
      }
    }, [(!_vm.onUploading) ? _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.images[_vm.currentTag] || _vm.images[_vm.currentTag].length === 0),
        expression: "!images[currentTag] || images[currentTag].length === 0"
      }],
      staticClass: "no-image"
    }, [_vm._v(_vm._s(_vm.$t('empty')))]) : _vm._e(), _vm._v(" "), _c('el-radio-group', {
      model: {
        value: (_vm.selected),
        callback: function($$v) {
          _vm.selected = $$v
        },
        expression: "selected"
      }
    }, [(_vm.onUploading) ? _c('el-radio', {
      staticClass: "hide-input",
      attrs: {
        "label": -1,
        "disabled": true
      }
    }, [_c('div', {
      staticClass: "uploading-progress img cover"
    }, [_c('p', {
      staticClass: "hint"
    }, [_vm._v(_vm._s(_vm.$t('imageUploading')))]), _vm._v(" "), _c('el-progress', {
      staticClass: "uploader-progress-bar",
      attrs: {
        "percentage": _vm.progress * 0.8,
        "show-text": false
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.images[_vm.currentTag]), function(image, index) {
      return _c('el-radio', {
        key: image.id,
        staticClass: "hide-input",
        attrs: {
          "label": image.id
        }
      }, [_c('div', {
        staticClass: "img cover",
        class: {
          'selected': image.id === _vm.selected
        },
        style: ({
          'backgroundImage': 'url(' + image.file_url + ')'
        })
      }, [_c('i', {
        staticClass: "ppj-icon-ok"
      })]), _vm._v(" "), _vm._o(_c('el-tooltip', {
        attrs: {
          "effect": "light",
          "content": _vm.$t('hint.media.image.remove'),
          "placement": "top",
          "open-delay": 500,
          "popper-options": {
            removeOnDestroy: true
          }
        }
      }, [_c('a', {
        staticClass: "remove-btn",
        on: {
          "click": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            _vm.remove(index)
          }
        }
      }, [_c('i', {
        staticClass: "ppj-icon-cancel danger"
      })])]), 0, image.id)], 1)
    })], 2)], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('ssuploader', {
    staticClass: "uploader-btn",
    attrs: {
      "url": _vm.uploadUrl,
      "data": _vm.uploadData,
      "name": "medium[file]",
      "extensions": _vm.extensions,
      "progress": _vm.progress,
      "uploading": _vm.onUploading,
      "accept": _vm.accept
    },
    on: {
      "update:progress": function($event) {
        _vm.progress = $event
      },
      "update:uploading": function($event) {
        _vm.onUploading = $event
      },
      "complete": _vm.uploadComplete
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.ok')))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 927 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "media-audio-dialog",
    attrs: {
      "title": _vm.$t('title'),
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.close
    }
  }, [_c('el-tabs', {
    attrs: {
      "header-no-margin": ""
    },
    on: {
      "tab-click": _vm.fetchData
    },
    model: {
      value: (_vm.currentTag),
      callback: function($$v) {
        _vm.currentTag = $$v
      },
      expression: "currentTag"
    }
  }, _vm._l((_vm.tags), function(tag) {
    return _c('el-tab-pane', {
      key: tag,
      staticClass: "audio-content",
      attrs: {
        "label": _vm.$t(("tags." + tag)),
        "name": tag
      }
    }, [(_vm.onUploading) ? _c('div', {
      staticClass: "audio-item uploading"
    }, [_c('div', {
      staticClass: "name"
    }, [_c('i', {
      staticClass: "ppj-icon-spinner"
    }), _vm._v(" " + _vm._s(_vm.uploadingFilename) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "progress",
      style: ({
        'width': _vm.progress * 0.8 + '%'
      })
    })]) : _vm._e(), _vm._v(" "), _c('el-table', {
      ref: "table",
      refInFor: true,
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.audios[tag],
        "show-header": false,
        "highlight-current-row": ""
      },
      on: {
        "current-change": function($event) {
          _vm.selected = $event ? $event.id : null
        }
      }
    }, [_c('el-table-column', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "audio-item"
          }, [_c('i', {
            class: _vm.currentPlayIndex === scope.$index ? 'ppj-icon-play' : 'ppj-icon-music'
          }), _vm._v(" "), _c('div', {
            staticClass: "name"
          }, [_vm._v("\n                  " + _vm._s(scope.row.name) + "\n                  "), _c('span', {
            staticClass: "duration"
          }, [_vm._v("\n                    " + _vm._s(_vm.durationReadable(scope.row.duration)) + "\n                  ")])]), _vm._v(" "), _c('a', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (tag !== "pub" && scope.row.id !== _vm.selected),
              expression: "tag !== \"pub\" && scope.row.id !== selected"
            }],
            staticClass: "btn trash",
            on: {
              "click": function($event) {
                $event.stopPropagation();
                _vm.remove(scope.$index)
              }
            }
          }, [_c('i', {
            staticClass: "ppj-icon-trash"
          })]), _vm._v(" "), _c('a', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.currentPlayIndex !== scope.$index),
              expression: "currentPlayIndex !== scope.$index"
            }],
            staticClass: "btn",
            on: {
              "click": function($event) {
                $event.stopPropagation();
                _vm.play(scope.$index)
              }
            }
          }, [_c('i', {
            staticClass: "ppj-icon-play"
          })]), _vm._v(" "), _c('a', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.currentPlayIndex === scope.$index),
              expression: "currentPlayIndex === scope.$index"
            }],
            staticClass: "btn",
            on: {
              "click": function($event) {
                $event.stopPropagation();
                _vm.pause()
              }
            }
          }, [_c('i', {
            staticClass: "ppj-icon-pause"
          })]), _vm._v(" "), _c('i', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (scope.row.id === _vm.selected),
              expression: "scope.row.id === selected"
            }],
            staticClass: "ppj-icon-ok"
          })])]
        }
      }])
    }), _vm._v(" "), _c('div', {
      slot: "empty"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.onUploading),
        expression: "!onUploading"
      }],
      staticClass: "empty-hint"
    }, [_vm._v(_vm._s(_vm.$t('empty')))])])], 1)], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('ssuploader', {
    staticClass: "uploader-btn",
    attrs: {
      "url": _vm.uploadUrl,
      "data": _vm.uploadData,
      "name": "medium[file]",
      "extensions": _vm.extensions,
      "filename": _vm.uploadingFilename,
      "progress": _vm.progress,
      "uploading": _vm.onUploading,
      "accept": _vm.accept
    },
    on: {
      "update:filename": function($event) {
        _vm.uploadingFilename = $event
      },
      "update:progress": function($event) {
        _vm.progress = $event
      },
      "update:uploading": function($event) {
        _vm.onUploading = $event
      },
      "complete": _vm.uploadComplete
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.ok')))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 928 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "steps-wrapper"
  }, [_c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "content",
    class: {
      'active': _vm.step === 'upload'
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_vm._v("1")]), _vm._v("上传" + _vm._s(_vm.$t('common.project')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "content",
    class: {
      'active': _vm.step === 'convert'
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_vm._v("2")]), _vm._v("转化 H5\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "content",
    class: {
      'active': _vm.step === 'complete'
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_vm._v("3")]), _vm._v("分享链接\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])])
},staticRenderFns: []}

/***/ }),
/* 929 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "teacher-verification"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticClass: "content-form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "真实姓名",
      "prop": "realname",
      "error": _vm.errors.first('realname')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.realname),
      callback: function($$v) {
        _vm.form.realname = $$v
      },
      expression: "form.realname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属省份",
      "prop": "province",
      "error": _vm.errors.first('province')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.clearErrors('province')
      }
    },
    model: {
      value: (_vm.form.province),
      callback: function($$v) {
        _vm.form.province = $$v
      },
      expression: "form.province"
    }
  }, _vm._l((_vm.provinces), function(prov) {
    return _c('el-option', {
      key: prov.code,
      attrs: {
        "label": prov.name,
        "value": prov.name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "任教学校",
      "prop": "organization",
      "error": _vm.errors.first('organization')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.organization),
      callback: function($$v) {
        _vm.form.organization = $$v
      },
      expression: "form.organization"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "证件图片",
      "prop": "certificate",
      "error": _vm.errors.first('certificate')
    }
  }, [_c('ssuploader', {
    ref: "uploader",
    attrs: {
      "url": _vm.uploadUrl,
      "accept": _vm.accept,
      "extensions": _vm.extensions,
      "name": "verification[certificate]",
      "data": _vm.uploadData,
      "autoSubmit": false
    },
    on: {
      "change": _vm.preview,
      "complete": _vm.complete,
      "error": _vm.error
    }
  }, [_c('div', {
    ref: "uploader-btn",
    staticClass: "preview-wrapper",
    class: {
      'shrink': !_vm.form.certificate
    }
  }, [(_vm.supportPreview && _vm.form.certificate) ? _c('img', {
    ref: "preview-image",
    staticClass: "img",
    attrs: {
      "alt": _vm.form.filename
    }
  }) : (!_vm.supportPreview && _vm.form.certificate) ? _c('div', [_c('p', [_vm._v("文件名：" + _vm._s(_vm.form.filename))]), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v("您的浏览器暂不支持预览图片")])]) : _c('div', {
    staticClass: "img default"
  })])])], 1), _vm._v(" "), _c('el-form-item', [_c('p', {
    staticClass: "hint"
  }, [_vm._v("请上传本人教师资格证件，确保照片清晰，四角完整")])]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v("取消")])], 1), _vm._v(" "), _c('el-form-item', [_c('p', {
    staticClass: "hint",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("注意：通过教师认证后，请务必只上传教学相关的内容。如果擅自用于商业用途，一经发现，平台将取消优惠资格，按正常价格核算额度。")])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-header"
  }, [_c('p', [_c('em', [_vm._v("教师认证")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content-hint"
  }, [_c('i', {
    staticClass: "ppj-icon-gift"
  }), _vm._v("PP匠推出教育发展计划，公立学校老师可以199元购买价值999元的教育专业版（包含50个永久项目额度），助力教育信息化")])
}]}

/***/ }),
/* 930 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infos-card"
  }, [_c('export-dialog', {
    ref: "export-dialog",
    attrs: {
      "loading": _vm.exportLoading
    },
    on: {
      "update:loading": function($event) {
        _vm.exportLoading = $event
      }
    }
  }), _vm._v(" "), _c('record-dialog', {
    ref: "record-dialog"
  }), _vm._v(" "), _c('div', {
    staticClass: "project-name"
  }, [_c('span', [_vm._v(_vm._s(_vm.project.name))])]), _vm._v(" "), _c('div', {
    staticClass: "qrcode-wrapper"
  }, [_c('img', {
    staticClass: "qrcode",
    attrs: {
      "src": '//qrcode.ppj.io/' + _vm.project.viewer_url
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$t('qrcode.project')))]), _vm._v(" "), _c('div', {
    staticClass: "link-info"
  }, [_c('el-input', {
    staticClass: "link-input",
    attrs: {
      "placeholder": _vm.$t('placeholder.project.viewer_url'),
      "readonly": ""
    },
    model: {
      value: (_vm.project.viewer_url),
      callback: function($$v) {
        _vm.project.viewer_url = $$v
      },
      expression: "project.viewer_url"
    }
  }, [_c('div', {
    staticClass: "append-buttons",
    slot: "append"
  }, [_c('a', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.project.viewer_url),
      expression: "project.viewer_url",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }],
    staticClass: "copy el-button"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('common.buttons.copy')) + "\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "preview el-button",
    attrs: {
      "href": _vm.project.viewer_url,
      "target": "_blank"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('common.buttons.preview')) + "\n          ")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "buttons-group"
  }, [(!_vm.tbcMode && !_vm.readonly) ? _c('el-dropdown', {
    attrs: {
      "menu-align": "start"
    },
    on: {
      "command": _vm.exportDropdownCommand
    }
  }, [_c('el-button', {
    staticClass: "export-downdir-btn",
    attrs: {
      "plain": true,
      "type": "info"
    }
  }, [_c('i', {
    staticClass: "ppj-icon-down-dir"
  })]), _vm._v(" "), _c('el-button', {
    staticClass: "export-btn",
    attrs: {
      "plain": true,
      "loading": _vm.exportLoading,
      "type": "info"
    },
    on: {
      "click": function($event) {
        _vm.openExportDialog('html5')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.exportLoading ? '加载中' : _vm.$t('common.buttons.export.html5')) + "\n      ")]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "export-dropdown-menu",
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    staticClass: "export-dropdown-item",
    attrs: {
      "command": "scorm"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("common.buttons.export.scorm")) + "\n        ")])], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 931 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cellphone-register-view login-form"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('actions.cellphoneRegister.title')))]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('cellphone-input', {
    ref: "cellphoneInput",
    attrs: {
      "cellphone": _vm.cellphone,
      "captcha": _vm.captcha
    },
    on: {
      "update:cellphone": function($event) {
        _vm.cellphone = $event
      },
      "update:captcha": function($event) {
        _vm.captcha = $event
      }
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password",
      "error": _vm.errors.first('password')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": _vm.$t('placeholder.user.password')
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.form.password = $$v
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "passwordConfirmation",
      "error": _vm.errors.first('passwordConfirmation')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('placeholder.user.passwordConfirmation')
    },
    model: {
      value: (_vm.form.passwordConfirmation),
      callback: function($$v) {
        _vm.form.passwordConfirmation = $$v
      },
      expression: "form.passwordConfirmation"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "hint",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('actions.register.term'))
    }
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary submit-btn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.signUp($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.register.submit')))])], 1), _vm._v(" "), _c('el-form-item', [_c('router-link', {
    staticClass: "left",
    staticStyle: {
      "line-height": "1"
    },
    attrs: {
      "to": {
        name: 'e_register'
      }
    }
  }, [_vm._v("\n        无法收到验证码？\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "right",
    staticStyle: {
      "line-height": "1"
    },
    attrs: {
      "to": "login"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('actions.register.loginLink')) + "\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 932 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dropdown', {
    staticClass: "nav selector",
    attrs: {
      "menu-align": "start",
      "hide-on-click": false
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v(_vm._s(_vm.category ? _vm.category.name : _vm.$t('actions.category.all'))), _c('i', {
    staticClass: "ppj-icon-down-dir"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "primary-dropdown",
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/",
      "tag": "div",
      "exact": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.category.all')))])], 1), _vm._v(" "), _vm._l((_vm.categories), function(cat, index) {
    return _c('el-dropdown-item', {
      key: cat.id,
      attrs: {
        "divided": index === 0
      }
    }, [_c('router-link', {
      staticClass: "item",
      attrs: {
        "to": {
          name: 'category',
          params: {
            id: cat.id
          }
        },
        "tag": "div"
      }
    }, [_vm._v(_vm._s(cat.name))])], 1)
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 933 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "quotas-required-dialog",
    attrs: {
      "title": _vm.overdate ? '套餐已过期' : '项目额度不足',
      "size": "small",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.close
    }
  }, [(_vm.organization) ? _c('div', [(_vm.overdate) ? _c('p', [_vm._v("企业套餐已过期，请联系管理员续费或升级")]) : _c('p', [_vm._v("企业套餐额度不足，请联系管理员续费或升级")])]) : _c('div', [_c('p', [_vm._v("您的永久项目额度不足，如果继续将会创建临时项目。临时项目会免费浏览8小时，之后会自动删除。\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("请购买额度或会员。")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons",
    slot: "footer"
  }, [(_vm.organization) ? _c('div', [_c('a', {
    staticClass: "el-button el-button--primary",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("关闭")])]) : _c('div', [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("继续创建")]), _vm._v(" "), _c('a', {
    staticClass: "el-button el-button--primary",
    attrs: {
      "href": "/price?closeOnPQuota=true",
      "target": "_blank"
    }
  }, [_vm._v("购买额度")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 934 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category-card"
  }, [(_vm.category.cover_url) ? _c('div', {
    staticClass: "cover-wrapper"
  }, [_c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: 'url( ' + _vm.category.cover_url + ')'
    })
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details",
    class: {
      'empty': !_vm.category.cover_url
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.category.name))]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.category.description))]), _vm._v(" "), (_vm.category.publicity) ? _c('div', {
    staticClass: "public-link"
  }, [_c('i', {
    staticClass: "ppj-icon-link"
  }), _vm._v(_vm._s(_vm.$t('actions.category.publicity')) + "："), _c('a', {
    staticClass: "link",
    attrs: {
      "href": _vm.category.public_url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.category.public_url))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.$emit('edit')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.category.edit')))])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 935 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    staticClass: "permanent",
    attrs: {
      "label": "发布设置"
    }
  }, [_c('quotas-required-dialog', {
    ref: "quotas-required-dialog",
    on: {
      "close": _vm.close
    }
  }), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "theme": "info"
    },
    on: {
      "change": _vm.change
    },
    model: {
      value: (_vm.permanent),
      callback: function($$v) {
        _vm.permanent = $$v
      },
      expression: "permanent"
    }
  }, [(!_vm.project.permanent) ? _c('el-radio-button', {
    attrs: {
      "label": "temp"
    }
  }, [_vm._v("\n      临时\n      "), _c('span', {
    staticClass: "sub",
    domProps: {
      "innerHTML": _vm._s(_vm.timeDiff(_vm.project.expired_at) > 0 ? _vm.timeDiff(_vm.project.expired_at, true) + '过期' : '<span class=\'danger\'>已过期</span>')
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "permanent"
    }
  }, [_vm._v("\n      永久\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 936 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    class: {
      'is-error': _vm.errors.has('cellphone')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('placeholder.user.cellphone')
    },
    on: {
      "change": function($event) {
        _vm.errors.clear()
      }
    },
    model: {
      value: (_vm.mutableCellphone),
      callback: function($$v) {
        _vm.mutableCellphone = $$v
      },
      expression: "mutableCellphone"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.errors.first('cellphone')))])], 1), _vm._v(" "), _c('el-form-item', {
    class: {
      'is-error': _vm.errors.has('captcha')
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('placeholder.user.captcha')
    },
    on: {
      "change": function($event) {
        _vm.errors.clear()
      }
    },
    model: {
      value: (_vm.mutableCaptcha),
      callback: function($$v) {
        _vm.mutableCaptcha = $$v
      },
      expression: "mutableCaptcha"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.errors.first('captcha')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "v-code-btn",
    attrs: {
      "disabled": _vm.sended
    },
    on: {
      "click": _vm.sendCaptcha
    }
  }, [_vm._v("\n        " + _vm._s(_vm.sended ? ("已发送（" + _vm.cooldown + "）") : '发送验证码') + "\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 937 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logs"
  }, [_c('table', {
    staticClass: "members-table"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('tr', [_vm._m(1)]) : _vm._l((_vm.logs), function(log) {
    return _c('tr', {
      key: log.id
    }, [_vm._o(_c('td', {
      staticClass: "profile"
    }, [_c('div', {
      staticClass: "img avatar",
      style: ({
        backgroundImage: 'url(' + log.actor_profile_picture + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "nickname"
    }, [_vm._v(_vm._s(log.actor))])]), 0, log.id), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dateReadable(log.created_at)))])])
  })], 2), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "small": "",
      "layout": "prev, pager, next",
      "total": _vm.totalItems,
      "page-count": _vm.totalPages,
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "current-change": _vm.fetch
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n        所有成员\n      ")]), _vm._v(" "), _c('th', [_vm._v("操作信息")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("时间")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "loading-cell",
    attrs: {
      "colspan": "10"
    }
  }, [_c('div', {
    staticClass: "spinner-wrapper"
  }, [_c('i', {
    staticClass: "ppj-icon-spinner"
  })])])
}]}

/***/ }),
/* 938 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ppj-spinner",
    style: ({
      width: (_vm.size + "px"),
      height: (_vm.size + "px")
    })
  }, [_c('div', {
    staticClass: "ppj-spinner-content",
    style: ({
      width: (_vm.percentage + "%"),
      height: (_vm.percentage + "%"),
      top: ((50 - 0.5 * _vm.percentage) + "%"),
      left: ((50 - 0.5 * _vm.percentage) + "%")
    })
  }, [_c('span', {
    staticClass: "ppj-text"
  }, [_vm._v(_vm._s(_vm.text))])])])
},staticRenderFns: []}

/***/ }),
/* 939 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    staticClass: "logo-setting",
    attrs: {
      "label": _vm.$t('actions.project.settings.logoLabel')
    }
  }, [_c('order-logo-dialog', {
    ref: "order-logo-dialog"
  }), _vm._v(" "), _c('el-radio-group', {
    staticClass: "selector",
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "default"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.project.settings.logo.default')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "custom"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.project.settings.logo.custom')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "hide"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.project.settings.logo.hide')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "logo-content"
  }, [(_vm.type === 'default') ? _c('div', {
    staticClass: "default"
  }, [_c('p', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$t('hint.project.edit.logo.default')))])]) : _vm._e(), _vm._v(" "), (_vm.type === 'custom') ? _c('div', {
    staticClass: "custom"
  }, [(_vm.editable) ? _c('image-uploader', {
    staticClass: "logo-wrapper",
    attrs: {
      "tag": "logo",
      "title": _vm.$t('actions.project.settings.logo.cover')
    },
    model: {
      value: (_vm.logo),
      callback: function($$v) {
        _vm.logo = $$v
      },
      expression: "logo"
    }
  }) : _c('p', {
    staticClass: "hint"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('actions.project.settings.logo.price'))), _c('a', {
    staticClass: "link",
    on: {
      "click": _vm.openOrder
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.project.settings.logo.priceBtn')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'hide') ? _c('div', {
    staticClass: "hide"
  }, [(_vm.editable) ? _c('p', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$t('hint.project.edit.logo.hide')))]) : _c('p', {
    staticClass: "hint"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('actions.project.settings.logo.price'))), _c('a', {
    staticClass: "link",
    on: {
      "click": _vm.openOrder
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.project.settings.logo.priceBtn')))])])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 940 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting-wrapper"
  }, [_c('setting-infos'), _vm._v(" "), _c('setting-form')], 1)
},staticRenderFns: []}

/***/ }),
/* 941 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-form"
  }, [_c('el-form', {
    staticClass: "content-form",
    attrs: {
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "套餐名称"
    }
  }, [_c('p', {
    staticClass: "package-name"
  }, [_vm._v(_vm._s(_vm.product.name) + "   " + _vm._s(_vm.product.price) + " 元/年")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "套餐内容"
    }
  }, [_c('ul', {
    staticClass: "package-details"
  }, [_c('li', [_c('span', [_vm._v("项目额度")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.product.permanent ? ((_vm.product.permanent) + " 个") : '不限个数'))])]), _vm._v(" "), (_vm.product.sub_account) ? _c('li', [_c('span', [_vm._v("子账号")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.product.sub_account) + " 个")])]) : _vm._e(), _vm._v(" "), (!_vm.product.logo) ? _c('li', [_c('span', [_vm._v("自定义加载页")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v("免费")])]) : _vm._e(), _vm._v(" "), (!_vm.product.export) ? _c('li', [_c('span', [_vm._v("导出")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v("免费")])]) : _vm._e(), _vm._v(" "), (_vm.product.custom_cs) ? _c('li', [_c('span', [_vm._v("企业专属服务")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "target-intro"
  }, [_vm._v(_vm._s(_vm.product.target_intro))])])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支付方式"
    }
  }, [_c('el-radio-group', {
    staticClass: "payment",
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.payType),
      callback: function($$v) {
        _vm.payType = $$v
      },
      expression: "payType"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "wechat"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.order.wechat')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "alipay"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.order.alipay')))])], 1), _vm._v(" "), (_vm.product.price > 1000) ? _c('a', {
    staticClass: "info contactUs",
    on: {
      "click": _vm.$contactMarket
    }
  }, [_vm._v("\n            联系销售\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    class: {
      'is-error': _vm.errors.has('promoteCode')
    },
    attrs: {
      "label": "优惠码（选填）"
    }
  }, [_c('el-input', {
    staticClass: "promteInput",
    on: {
      "blur": _vm.checkPrice
    },
    model: {
      value: (_vm.promoteCode),
      callback: function($$v) {
        _vm.promoteCode = $$v
      },
      expression: "promoteCode"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.checkPrice
    },
    slot: "append"
  }, [_vm._v("\n            使用\n          ")])], 1), _vm._v(" "), (!_vm.priceChecking && _vm.promoteDescription) ? _c('span', {
    staticClass: "promoteDescription"
  }, [_c('i', {
    staticClass: "ppj-icon-ok"
  }), _vm._v(_vm._s(_vm.promoteDescription) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.errors.first('promoteCode')))])], 1), _vm._v(" "), _c('el-form-item', [_c('p', {
    staticClass: "price"
  }, [_vm._v("应付金额："), _c('span', {
    staticClass: "actualPrice"
  }, [_vm._v(_vm._s(_vm.actualPrice))]), _vm._v(" 元\n          "), (_vm.actualPrice !== _vm.originalPrice) ? _c('span', {
    staticClass: "sub-price"
  }, [_vm._v("\n            订单总额：" + _vm._s(_vm.originalPrice) + " 元   优惠：" + _vm._s(_vm.discount) + " 元\n        ")]) : _vm._e()])]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.placeOrder
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")])], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-header"
  }, [_c('p', [_vm._v("确认订单")])])
}]}

/***/ }),
/* 942 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register-view login-form"
  }, [_c('h1', [_vm._v("邮箱注册")]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "email",
      "error": _vm.errors.first('email')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('actions.findPassword.placeholder')
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password",
      "error": _vm.errors.first('password')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": _vm.$t('placeholder.user.password')
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.form.password = $$v
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "passwordConfirmation",
      "error": _vm.errors.first('passwordConfirmation')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('placeholder.user.passwordConfirmation')
    },
    model: {
      value: (_vm.form.passwordConfirmation),
      callback: function($$v) {
        _vm.form.passwordConfirmation = $$v
      },
      expression: "form.passwordConfirmation"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "hint",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('actions.register.term'))
    }
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary submit-btn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.signUp($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.register.submit')))])], 1), _vm._v(" "), _c('el-form-item', [_c('router-link', {
    staticClass: "left",
    staticStyle: {
      "line-height": "1"
    },
    attrs: {
      "to": {
        name: 'm_register'
      }
    }
  }, [_vm._v("\n        手机号注册\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "right",
    staticStyle: {
      "line-height": "1"
    },
    attrs: {
      "to": "login"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('actions.register.loginLink')) + "\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 943 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('el-menu', {
    staticClass: "theme-primary",
    attrs: {
      "default-active": _vm.$route.path,
      "router": ""
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/profile"
    }
  }, [_vm._v("账户概况")]), _vm._v(" "), (_vm.apiEnabled) ? _c('el-menu-item', {
    attrs: {
      "index": "/profile/development"
    }
  }, [_vm._v("开发信息")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('router-view', {
    staticClass: "sub-profile"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 944 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    class: {
      'sneaky-mode': _vm.sneakyMode
    }
  }, [_c('router-link', {
    staticClass: "logo img",
    attrs: {
      "to": "/"
    }
  }), _vm._v(" "), (_vm.showNav && _vm.user.id) ? _c('el-menu', {
    staticClass: "nav logged-in",
    attrs: {
      "mode": "horizontal",
      "default-active": _vm.$route.path
    }
  }, [_c('el-menu-item', {
    class: {
      'is-active': _vm.$route.name === 'category'
    },
    attrs: {
      "index": "projects"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/",
      "tag": "div"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.headbar.myProjects')))])], 1), _vm._v(" "), (_vm.organization) ? _c('el-menu-item', {
    class: {
      'is-active': _vm.$route.name === 'members'
    },
    attrs: {
      "index": "members"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/members",
      "tag": "div"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.headbar.members')))])], 1) : _vm._e(), _vm._v(" "), _c('el-menu-item', {
    class: {
      'is-active': _vm.$route.name === 'price'
    },
    attrs: {
      "index": "price"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/price",
      "tag": "div"
    }
  }, [_vm._v("会员服务")])], 1), _vm._v(" "), _c('el-menu-item', {
    staticClass: "help-menu-item",
    attrs: {
      "index": "help"
    }
  }, [_c('a', {
    staticClass: "block-btn",
    attrs: {
      "href": "http://ppj.io/docs/",
      "target": "_blank"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('actions.headbar.help')) + "\n        ")])]), _vm._v(" "), _c('el-menu-item', {
    staticClass: "avatar-wrapper",
    attrs: {
      "index": "avatar"
    }
  }, [_c('el-popover', {
    ref: "popover",
    attrs: {
      "popper-class": "sub-menu header-popover",
      "trigger": "hover",
      "placement": "bottom-end",
      "width": "160"
    }
  }, [_c('router-link', {
    staticClass: "sub-menu-item",
    attrs: {
      "to": "/profile"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.headbar.myAccount')))]), _vm._v(" "), _c('a', {
    staticClass: "sub-menu-item",
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.headbar.logout')))])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover",
      arg: "popover"
    }]
  }, [_c('div', {
    staticClass: "avatar img",
    style: ({
      backgroundImage: 'url(' + _vm.user.profile_picture + ')'
    })
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showNav && !_vm.user.id) ? _c('div', {
    staticClass: "nav no-logged-in"
  }, [_c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$route.path !== "/login"),
      expression: "this.$route.path !== \"/login\""
    }],
    attrs: {
      "to": "login",
      "tag": "el-button"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('actions.headbar.login')) + "\n    ")]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!/^\/register/.test(this.$route.path)),
      expression: "!/^\\/register/.test(this.$route.path)"
    }],
    attrs: {
      "to": "/register",
      "tag": "el-button"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('actions.headbar.register')) + "\n    ")]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$route.path !== '/price'),
      expression: "this.$route.path !== '/price'"
    }],
    attrs: {
      "to": "/price",
      "tag": "el-button"
    }
  }, [_vm._v("\n      会员服务\n    ")])], 1) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 945 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nginx-uploader"
  }, [_c('div', {
    staticClass: "el-button el-button--primary el-button--large"
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n    "), _c('input', {
    staticClass: "fileupload",
    attrs: {
      "id": "fileupload",
      "type": "file",
      "name": "files[]",
      "accept": _vm.accept
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 946 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "welcome-card pane"
  }, [_c('div', {
    staticClass: "features"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.tbcMode) ? _c('div', {
    staticClass: "feature"
  }, [_c('div', {
    staticClass: "img desk"
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("一键上传，碎片知识快速沉淀")]), _vm._v(" "), _vm._m(2)]) : _c('div', {
    staticClass: "feature"
  }, [_c('div', {
    staticClass: "img wechat"
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("扫码阅读，轻松分享传播")]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [(_vm.showCreateProject) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  }, [_vm._v("开始上传")]) : _c('span', [_vm._v(_vm._s(_vm.$t('noProject')))])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature"
  }, [_c('div', {
    staticClass: "img light"
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("最简单的 H5 工具")]), _vm._v(" "), _c('div', {
    staticClass: "sub"
  }, [_c('p', [_vm._v("一键 PPT 转换 H5，零门槛上手")]), _vm._v(" "), _c('p', [_vm._v("完美还原动画、音视频、交互")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature"
  }, [_c('div', {
    staticClass: "img doc"
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("支持答题 & 录音")]), _vm._v(" "), _c('div', {
    staticClass: "sub"
  }, [_c('p', [_vm._v("所见即所得制作答题、表单及录音")]), _vm._v(" "), _c('p', [_vm._v("轻松搞定专业级功能")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub"
  }, [_c('p', [_vm._v("支持将制作好的微课一键同步上传至课程和资料")]), _vm._v(" "), _c('p', [_vm._v("快速沉淀业务碎片化知识，搭建内部微课体系")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub"
  }, [_c('p', [_vm._v("微信扫码查看 H5，随心分享")]), _vm._v(" "), _c('p', [_vm._v("营销策划、微课、产品介绍、工作汇报，统统搞定")])])
}]}

/***/ }),
/* 947 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "members"
  }, [_c('el-tabs', {
    staticClass: "content",
    attrs: {
      "theme": "info",
      "value": _vm.canDo('view_members') ? 'details' : 'logs'
    }
  }, [(_vm.canDo('view_members')) ? _c('el-tab-pane', {
    attrs: {
      "label": "成员信息",
      "name": "details"
    }
  }, [_c('details-card')], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "操作日志",
      "name": "logs"
    }
  }, [_c('logs-card')], 1), _vm._v(" "), (_vm.canDo('edit_members') && !_vm.tbcMode) ? _c('el-tab-pane', {
    attrs: {
      "label": "权限管理",
      "name": "permissions"
    }
  }, [_c('permissions-card')], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "wx_connection",
    attrs: {
      "title": "绑定微信号",
      "size": "tiny",
      "visible": _vm.dialogVisible
    },
    on: {
      "close": _vm.close,
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "qrcode",
    attrs: {
      "src": '//qrcode.ppj.io/' + _vm.wxConnection.url
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v("扫码绑定微信号")])]), _vm._v(" "), _c('div', {
    staticClass: "footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("关闭")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 949 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "api-application login-form"
  }, [_c('h1', [_vm._v("申请 API 使用权限")]), _vm._v(" "), _c('el-form', {
    staticClass: "application-form",
    attrs: {
      "label-thin": "",
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.application.name),
      callback: function($$v) {
        _vm.application.name = $$v
      },
      expression: "application.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话",
      "error": _vm.errors.first('cellphone')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.application.phone),
      callback: function($$v) {
        _vm.application.phone = $$v
      },
      expression: "application.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.application.company),
      callback: function($$v) {
        _vm.application.company = $$v
      },
      expression: "application.company"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "使用场景"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "如教育课件，市场营销等"
    },
    model: {
      value: (_vm.application.scenario),
      callback: function($$v) {
        _vm.application.scenario = $$v
      },
      expression: "application.scenario"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "使用数量"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "预计转化数量，如一年两万次"
    },
    model: {
      value: (_vm.application.estimate_ppts),
      callback: function($$v) {
        _vm.application.estimate_ppts = $$v
      },
      expression: "application.estimate_ppts"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sendApplication
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 950 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hintbox"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.full),
      expression: "!full"
    }],
    staticClass: "hintbox-holder",
    on: {
      "click": function($event) {
        _vm.full = true
      }
    }
  }, [_vm._v("常见问题")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.full),
      expression: "full"
    }],
    staticClass: "hintbox-full"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("常见问题")]), _vm._v(" "), _c('span', {
    staticClass: "hint"
  }, [_vm._v("QQ群：461571276")]), _vm._v(" "), _c('a', {
    staticClass: "block-btn",
    on: {
      "click": function($event) {
        _vm.full = false
      }
    }
  }, [_c('i', {
    staticClass: "ppj-icon-cancel"
  })])]), _vm._v(" "), _vm._m(0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://ppj.kf5.com/hc/kb/article/1062142/",
      "target": "_blank"
    }
  }, [_vm._v("如何使用微信录制语音微课")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://ppj.io/docs/#/createQuiz",
      "target": "_blank"
    }
  }, [_vm._v("如何在PPT中插入答题，制作小测验？")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://ppj.io/docs/#/createForm",
      "target": "_blank"
    }
  }, [_vm._v("如何插入表单，实现数据搜集")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://ppj.io/docs/#/size",
      "target": "_blank"
    }
  }, [_vm._v("如何制作竖版PPT")])])])])
}]}

/***/ }),
/* 951 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wx-login-view login-form"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('actions.wxlogin.title')))]), _vm._v(" "), _c('el-form', {
    ref: "login"
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "login-container",
    attrs: {
      "id": "login_container"
    }
  }, [_c('spinner', {
    staticClass: "spinner"
  })], 1)]), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "left"
  }, [_c('router-link', {
    attrs: {
      "to": "login"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('actions.login.accountlogin')) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.login.register')))]), _vm._v(" |\n        "), _c('router-link', {
    attrs: {
      "to": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.login.password')))])], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 952 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "show-view"
  }, [(_vm.step === 'convert') ? _c('convert-step') : _vm._e(), _vm._v(" "), (_vm.step === 'complete') ? _c('setting-step') : _vm._e(), _vm._v(" "), (_vm.step === 'error') ? _c('error-step') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 953 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "order-dialog",
    attrs: {
      "title": _vm.$t('actions.order.wechat.title'),
      "size": "small",
      "visible": _vm.dialogVisible
    },
    on: {
      "close": _vm.close,
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.paid) ? _c('div', {
    staticClass: "content paid"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('actions.order.paid')))])]) : (_vm.payType === 'wxpay') ? _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('actions.order.wechat.hint')))]), _vm._v(" "), _c('div', {
    staticClass: "img qrcode",
    style: ({
      'backgroundImage': 'url(//qrcode.ppj.io/' + _vm.qrcode + ')'
    })
  })]) : (_vm.payType === 'alipay') ? _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("请在打开的支付宝页面中完成付款")])]) : (_vm.errorMsg) ? _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.errorMsg))])]) : _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('actions.order.loading')))]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "footer",
    slot: "footer"
  }, [_c('p', [_c('a', {
    staticClass: "link",
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": _vm.$contactCS
    }
  }, [_vm._v("遇到问题？")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('spinner', {
    staticClass: "spinner",
    attrs: {
      "size": 180,
      "percentage": 80
    }
  })
}]}

/***/ }),
/* 954 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-records"
  }, [_c('div', {
    staticClass: "pane"
  }, [(_vm.labels) ? _c('el-table', {
    ref: "table",
    attrs: {
      "data": _vm.list,
      "max-height": "600"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "",
      "label": "序号",
      "prop": "seq",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "日期",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.dateReadable(scope.row.created_at)))])]
      }
    }])
  }), _vm._v(" "), _vm._l((_vm.labels), function(label) {
    return _c('el-table-column', {
      key: label.key,
      attrs: {
        "label": label.name,
        "prop": label.key
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin-top": "20px",
      "text-align": "center"
    },
    attrs: {
      "current-page": _vm.current_page,
      "page-size": _vm.page_size,
      "layout": "total, prev, pager, next",
      "total": _vm.total_items
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.current_page = $event
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "link",
    on: {
      "click": _vm.removeSelections
    }
  }, [_vm._v("删除选中")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": ("/projects/" + (_vm.$route.params.id) + "/form_records/export.xls"),
      "target": "_blank"
    }
  }, [_vm._v("导出表单")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 955 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reset-password login-form"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('actions.resetPassword.title')))]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "newPassword",
      "error": _vm.errors.first('newPassword')
    }
  }, [_c('el-input', {
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": _vm.$t('placeholder.user.newPassword')
    },
    model: {
      value: (_vm.form.newPassword),
      callback: function($$v) {
        _vm.form.newPassword = $$v
      },
      expression: "form.newPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "passwordConfirmation",
      "error": _vm.errors.first('passwordConfirmation')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('placeholder.user.passwordConfirmation')
    },
    model: {
      value: (_vm.form.passwordConfirmation),
      callback: function($$v) {
        _vm.form.passwordConfirmation = $$v
      },
      expression: "form.passwordConfirmation"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary submit-btn"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.resetPassword.submit')))]), _vm._v(" "), _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.errors.first('custom')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-view"
  }, [(!_vm.tbcMode && !_vm.embedMode) ? _c('el-alert', {
    staticClass: "notice",
    attrs: {
      "type": "info",
      "closable": false,
      "show-icon": "",
      "title": ""
    }
  }, [_vm._v("\n    PP匠2.0版本正式发布，推出会员计划，为用户带来更实用完善的服务，"), _c('a', {
    staticClass: "text-btn",
    attrs: {
      "href": "/price",
      "target": "_blank"
    }
  }, [_vm._v("了解详情")]), _vm._v("。\n  ")]) : _vm._e(), _vm._v(" "), (/^\/categories/.test(_vm.$route.path) || _vm.hasProjects) ? _c('category') : _vm._e(), _vm._v(" "), _c('projects-list', {
    ref: "projects-list",
    on: {
      "has-projects": function($event) {
        _vm.hasProjects = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-list"
  }, [_c('div', {
    staticClass: "projects-container"
  }, [(_vm.showCreateProject) ? _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "create-card"
  }, [_c('a', {
    on: {
      "click": _vm.createProject
    }
  }, [_c('i', {
    staticClass: "ppj-icon-plus"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('actions.project.new')))])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.projects), function(project, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (project.id),
        expression: "project.id"
      }],
      key: project.id,
      staticClass: "item",
      class: {
        'clear-margin': index % 4 === (_vm.showCreateProject ? 2 : 3)
      }
    }, [_c('project-card', {
      attrs: {
        "project": project
      },
      on: {
        "update": function($event) {
          _vm.update($event, index)
        },
        "refresh": function($event) {
          _vm.refreshData()
        }
      }
    })], 1)
  })], 2), _vm._v(" "), _c('infinite-loading', {
    ref: "infiniteLoading",
    attrs: {
      "on-infinite": _vm.onInfinite
    }
  }, [_c('div', {
    staticStyle: {
      "padding-left": "50%"
    },
    slot: "spinner"
  }, [_c('div', {
    staticClass: "ppj-icon-spinner"
  })]), _vm._v(" "), _c('welcome', {
    on: {
      "click": _vm.createProject
    },
    slot: "no-results"
  }), _vm._v(" "), _c('p', {
    staticClass: "hint",
    slot: "no-more"
  }, [_vm._v(_vm._s(_vm.$t('actions.category.noMore')))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	return new Promise(function(resolve, reject) { reject(new Error("Cannot find module '" + req + "'.")); });
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = 961;

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports = [
	{
		"code": 130000,
		"type": "province",
		"name": "河北省",
		"parent_id": null
	},
	{
		"code": 150000,
		"type": "province",
		"name": "内蒙古自治区",
		"parent_id": null
	},
	{
		"code": 210000,
		"type": "province",
		"name": "辽宁省",
		"parent_id": null
	},
	{
		"code": 220000,
		"type": "province",
		"name": "吉林省",
		"parent_id": null
	},
	{
		"code": 230000,
		"type": "province",
		"name": "黑龙江省",
		"parent_id": null
	},
	{
		"code": 320000,
		"type": "province",
		"name": "江苏省",
		"parent_id": null
	},
	{
		"code": 330000,
		"type": "province",
		"name": "浙江省",
		"parent_id": null
	},
	{
		"code": 340000,
		"type": "province",
		"name": "安徽省",
		"parent_id": null
	},
	{
		"code": 350000,
		"type": "province",
		"name": "福建省",
		"parent_id": null
	},
	{
		"code": 360000,
		"type": "province",
		"name": "江西省",
		"parent_id": null
	},
	{
		"code": 370000,
		"type": "province",
		"name": "山东省",
		"parent_id": null
	},
	{
		"code": 410000,
		"type": "province",
		"name": "河南省",
		"parent_id": null
	},
	{
		"code": 420000,
		"type": "province",
		"name": "湖北省",
		"parent_id": null
	},
	{
		"code": 430000,
		"type": "province",
		"name": "湖南省",
		"parent_id": null
	},
	{
		"code": 440000,
		"type": "province",
		"name": "广东省",
		"parent_id": null
	},
	{
		"code": 450000,
		"type": "province",
		"name": "广西壮族自治区",
		"parent_id": null
	},
	{
		"code": 460000,
		"type": "province",
		"name": "海南省",
		"parent_id": null
	},
	{
		"code": 510000,
		"type": "province",
		"name": "四川省",
		"parent_id": null
	},
	{
		"code": 520000,
		"type": "province",
		"name": "贵州省",
		"parent_id": null
	},
	{
		"code": 530000,
		"type": "province",
		"name": "云南省",
		"parent_id": null
	},
	{
		"code": 540000,
		"type": "province",
		"name": "西藏自治区",
		"parent_id": null
	},
	{
		"code": 610000,
		"type": "province",
		"name": "陕西省",
		"parent_id": null
	},
	{
		"code": 620000,
		"type": "province",
		"name": "甘肃省",
		"parent_id": null
	},
	{
		"code": 630000,
		"type": "province",
		"name": "青海省",
		"parent_id": null
	},
	{
		"code": 640000,
		"type": "province",
		"name": "宁夏回族自治区",
		"parent_id": null
	},
	{
		"code": 650000,
		"type": "province",
		"name": "新疆维吾尔自治区",
		"parent_id": null
	},
	{
		"code": 140000,
		"type": "province",
		"name": "山西",
		"parent_id": null
	},
	{
		"code": 120000,
		"type": "province",
		"name": "天津",
		"parent_id": null
	},
	{
		"code": 110000,
		"type": "province",
		"name": "北京",
		"parent_id": null
	},
	{
		"code": 500000,
		"type": "province",
		"name": "重庆",
		"parent_id": null
	},
	{
		"code": 310000,
		"type": "province",
		"name": "上海",
		"parent_id": null
	},
	{
		"code": 710000,
		"type": "province",
		"name": "台湾",
		"parent_id": null
	},
	{
		"code": 810000,
		"type": "province",
		"name": "香港",
		"parent_id": null
	},
	{
		"code": 820000,
		"type": "province",
		"name": "澳门",
		"parent_id": null
	}
];

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(148);
module.exports = __webpack_require__(332);


/***/ })
]),[963]);


// WEBPACK FOOTER //
// static/js/index.aec61b959802aa899e19.js